// noinspection JSUnusedGlobalSymbols

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSJSON: any;
  Long: any;
};

export type AssignmentCandidate = {
  __typename?: 'AssignmentCandidate';
  additionalTime?: Maybe<Scalars['Int']>;
  baselineDistance?: Maybe<Scalars['Float']>;
  baselineDuration?: Maybe<Scalars['Int']>;
  driverCode?: Maybe<Scalars['String']>;
  driverId: Scalars['Int'];
  driverName?: Maybe<Scalars['String']>;
  hasEta: Scalars['Boolean'];
  incompleteStopCount: Scalars['Int'];
  manifestDriverId: Scalars['Int'];
  matchReason: Scalars['String'];
  optimizedDistance?: Maybe<Scalars['Float']>;
  optimizedDuration?: Maybe<Scalars['Int']>;
  optimizedEtas: Array<EtaItem>;
  optimizedSequences?: Maybe<Array<OptimizedStop>>;
  suggestReasons?: Maybe<Array<Scalars['String']>>;
  timeWindowBuffer?: Maybe<Scalars['Int']>;
};

export type AssignmentDetailInput = {
  dwellTimeSeconds: Scalars['Int'];
  jobIds: Array<Scalars['Int']>;
  optimizationEtas: Array<EtaItemInput>;
  requestEtaIfEmpty?: InputMaybe<Scalars['Boolean']>;
  sequences: Array<Scalars['Int']>;
  startDate: Scalars['String'];
  submittedDriver: RoutePlanningDriverInput;
};

export type BoundingBox = {
  bottomRight: GeoCoordinateInput;
  topLeft: GeoCoordinateInput;
};

export type Bucket = {
  __typename?: 'Bucket';
  doc_count?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
};

export type CancelSuggestAssignmentInput = {
  requestId: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  customerCode?: Maybe<Scalars['String']>;
  customerGroup?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
};

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  items?: Maybe<Array<Customer>>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type CustomerFilter = {
  and?: InputMaybe<Array<CustomerFilter>>;
  customerCode?: InputMaybe<TextFilterInput>;
  customerGroup?: InputMaybe<TextFilterInput>;
  customerId?: InputMaybe<ModelIntFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<Array<CustomerFilter>>;
  or?: InputMaybe<Array<CustomerFilter>>;
  siteId?: InputMaybe<ModelIntFilterInput>;
};

export type CustomerSort = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: CustomerSortableField;
};

export enum CustomerSortableField {
  CustomerCode = 'customerCode',
  CustomerGroup = 'customerGroup',
  CustomerId = 'customerId',
  Name = 'name',
  SiteId = 'siteId'
}

export enum DataChangeEntityType {
  Manifest = 'manifest'
}

export type DataChangedEvent = {
  __typename?: 'DataChangedEvent';
  entityId?: Maybe<Scalars['String']>;
  entityType: DataChangeEntityType;
  tenantId?: Maybe<Scalars['String']>;
};

export type DateTimeFilterInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DispatchGroup = {
  __typename?: 'DispatchGroup';
  TYPE?: Maybe<Scalars['String']>;
  autoCloseManifest?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  dispatchGroup?: Maybe<Scalars['String']>;
  dispatchGroupId?: Maybe<Scalars['Int']>;
  dispatchType?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  sk: Scalars['String'];
};

export type DispatchGroupConnection = {
  __typename?: 'DispatchGroupConnection';
  items?: Maybe<Array<Maybe<DispatchGroup>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type DispatchStationGroup = {
  __typename?: 'DispatchStationGroup';
  TYPE?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispatchGroupId?: Maybe<Scalars['Int']>;
  dispatchStation: Scalars['String'];
  dispatchType?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  sk: Scalars['String'];
};

export type DispatchStationGroupConnection = {
  __typename?: 'DispatchStationGroupConnection';
  items?: Maybe<Array<Maybe<DispatchStationGroup>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type DispatchStationRestrictionInfo = {
  __typename?: 'DispatchStationRestrictionInfo';
  dispatchGridFlag?: Maybe<Scalars['Int']>;
  dispatchStation?: Maybe<Scalars['String']>;
  subDispatchStations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DispatchUpdate = {
  __typename?: 'DispatchUpdate';
  data?: Maybe<Scalars['AWSJSON']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type Driver = {
  __typename?: 'Driver';
  TYPE?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  autoAccept?: Maybe<Scalars['Boolean']>;
  autoSend?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dispatchGroupId?: Maybe<Scalars['Int']>;
  driverAlias?: Maybe<Scalars['String']>;
  driverCode?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['Int']>;
  driverStatus?: Maybe<Scalars['String']>;
  endZip?: Maybe<Scalars['String']>;
  endZone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  qualifications?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  sk: Scalars['String'];
  skills?: Maybe<Scalars['String']>;
  startZip?: Maybe<Scalars['String']>;
  startZone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  vehicleTypeId?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type DriverConnection = {
  __typename?: 'DriverConnection';
  items?: Maybe<Array<Maybe<Driver>>>;
  nextToken?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type DriverFilterInput = {
  driver?: InputMaybe<ModelDriverFilterInput>;
  multiFieldWildcard?: InputMaybe<MultiFieldWildcard>;
  multiMatch?: InputMaybe<MultiMatchFilter>;
  queryString?: InputMaybe<QueryStringFilter>;
};

export type DriverLocation = {
  __typename?: 'DriverLocation';
  accuracy: Scalars['Float'];
  altitude: Scalars['Float'];
  auxData?: Maybe<Scalars['AWSJSON']>;
  coordinates: Scalars['String'];
  driverId: Scalars['Int'];
  fixDateTime: Scalars['AWSDateTime'];
  heading: Scalars['Float'];
  indexDateTime: Scalars['AWSDateTime'];
  receiveDateTime: Scalars['AWSDateTime'];
  tenantId: Scalars['String'];
  velocity: Scalars['Float'];
};

export type DriverLocationConnection = {
  __typename?: 'DriverLocationConnection';
  items?: Maybe<Array<Maybe<DriverLocation>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type DriverQualification = {
  __typename?: 'DriverQualification';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type DriverTotalManifestsResponse = {
  __typename?: 'DriverTotalManifestsResponse';
  manifestCount: Scalars['Int'];
};

export type Eta = {
  __typename?: 'ETA';
  completeTopmostStreak?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Float']>;
  drivingTimeSeconds?: Maybe<Scalars['Int']>;
  items: Array<EtaItem>;
  lastSentItems?: Maybe<Array<NotificationSentData>>;
  latestCompletedJobStopIds?: Maybe<Array<Scalars['Int']>>;
  manifestDriverId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  optimizationEtas?: Maybe<Array<EtaItem>>;
  polyline?: Maybe<RouteLine>;
  rateLimitCredits?: Maybe<Scalars['Int']>;
  startLocation?: Maybe<GeoCoordinate>;
  status?: Maybe<Scalars['String']>;
};

export type EtaConnection = {
  __typename?: 'ETAConnection';
  items: Array<Eta>;
  message?: Maybe<Scalars['String']>;
};

export type EtaItem = {
  __typename?: 'ETAItem';
  eta?: Maybe<Scalars['String']>;
  etaSource?: Maybe<Scalars['String']>;
  generatedDateTime?: Maybe<Scalars['String']>;
  jobStopId?: Maybe<Scalars['Int']>;
};

export type EtaItemInput = {
  eta: Scalars['String'];
  etaSource: Scalars['String'];
  generatedDateTime: Scalars['String'];
  jobStopId: Scalars['Int'];
};

export type EntityMetadata = {
  __typename?: 'EntityMetadata';
  alerts?: Maybe<Array<EntityMetadataAlert>>;
};

export type EntityMetadataAlert = {
  __typename?: 'EntityMetadataAlert';
  level: Scalars['String'];
  message: Scalars['String'];
};

export type EtaNotificationConfig = {
  __typename?: 'EtaNotificationConfig';
  config: Scalars['AWSJSON'];
  siteId: Scalars['Int'];
  sk: Scalars['ID'];
};

export type EtaNotificationConfigsConnection = {
  __typename?: 'EtaNotificationConfigsConnection';
  items?: Maybe<Array<EtaNotificationConfig>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type EtaNotificationConfigsFilter = {
  siteId?: InputMaybe<ModelIntFilterInput>;
  sk?: InputMaybe<ModelIdFilterInput>;
};

export type EventType = {
  __typename?: 'EventType';
  customerId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  driverCreatable?: Maybe<Scalars['Boolean']>;
  eBilling?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<Scalars['String']>;
  eventTypeId: Scalars['Int'];
  lateReason?: Maybe<Scalars['Boolean']>;
  pieceStatusId?: Maybe<Scalars['Int']>;
  showOnWeb?: Maybe<Scalars['Boolean']>;
};

export type EventTypeConnection = {
  __typename?: 'EventTypeConnection';
  items?: Maybe<Array<EventType>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type EventTypeFilterInput = {
  and?: InputMaybe<Array<EventTypeFilterInput>>;
  customerId?: InputMaybe<ModelIntFilterInput>;
  description?: InputMaybe<TextFilterInput>;
  driverCreatable?: InputMaybe<ModelBooleanFilterInput>;
  eBilling?: InputMaybe<ModelBooleanFilterInput>;
  eventType?: InputMaybe<TextFilterInput>;
  eventTypeId?: InputMaybe<ModelIntFilterInput>;
  lateReason?: InputMaybe<ModelBooleanFilterInput>;
  not?: InputMaybe<Array<EventTypeFilterInput>>;
  or?: InputMaybe<Array<EventTypeFilterInput>>;
  pieceStatusId?: InputMaybe<ModelIntFilterInput>;
  showOnWeb?: InputMaybe<ModelBooleanFilterInput>;
};

export type EventTypeSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: EventTypeSortableField;
};

export enum EventTypeSortableField {
  CustomerId = 'customerId',
  Description = 'description',
  DriverCreatable = 'driverCreatable',
  EBilling = 'eBilling',
  EventType = 'eventType',
  EventTypeId = 'eventTypeId',
  LateReason = 'lateReason',
  PieceStatusId = 'pieceStatusId',
  ShowOnWeb = 'showOnWeb'
}

export type FeeTitle = {
  __typename?: 'FeeTitle';
  code?: Maybe<Scalars['String']>;
  driverRequireFlag?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
};

export type FeeTitleConnection = {
  __typename?: 'FeeTitleConnection';
  items?: Maybe<Array<FeeTitle>>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type FeeTitleFilterInput = {
  and?: InputMaybe<Array<FeeTitleFilterInput>>;
  code?: InputMaybe<TextFilterInput>;
  driverRequireFlag?: InputMaybe<ModelBooleanFilterInput>;
  id?: InputMaybe<ModelIntFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<Array<FeeTitleFilterInput>>;
  or?: InputMaybe<Array<FeeTitleFilterInput>>;
  service?: InputMaybe<TextFilterInput>;
  siteId?: InputMaybe<ModelIntFilterInput>;
};

export type FeeTitleSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: FeeTitleSortableField;
};

export enum FeeTitleSortableField {
  Code = 'code',
  DriverRequireFlag = 'driverRequireFlag',
  Name = 'name',
  Service = 'service',
  SiteId = 'siteId'
}

export type GeoCoordinate = {
  __typename?: 'GeoCoordinate';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type GeoCoordinateInput = {
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type GeoPosition = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GeocodeAddressConnection = {
  __typename?: 'GeocodeAddressConnection';
  items?: Maybe<Array<Maybe<GeocodeResult>>>;
};

export type GeocodeResult = {
  __typename?: 'GeocodeResult';
  formattedAddress?: Maybe<Scalars['String']>;
  lat: Scalars['Float'];
  locationType?: Maybe<Scalars['String']>;
  lon: Scalars['Float'];
  status: GeocodeResultStatus;
};

export enum GeocodeResultStatus {
  CacheHit = 'cacheHit',
  CacheMiss = 'cacheMiss',
  InvalidAddress = 'invalidAddress'
}

export type GetDistinctValuesConnection = {
  __typename?: 'GetDistinctValuesConnection';
  items: Array<Bucket>;
};

export type GetRoutePlanningResultInput = {
  responseId: Scalars['String'];
};

export type GetRoutePlanningResultResponse = {
  __typename?: 'GetRoutePlanningResultResponse';
  beforeTotals?: Maybe<RoutePlanningBeforeTotals>;
  copyrights?: Maybe<Array<Scalars['String']>>;
  job_id?: Maybe<Scalars['String']>;
  manifestDriverIds?: Maybe<Array<Scalars['Int']>>;
  message?: Maybe<Scalars['String']>;
  processing_time?: Maybe<Scalars['Int']>;
  routeEtas?: Maybe<Array<RoutePlanningRouteEtas>>;
  solution?: Maybe<RoutePlanningSolution>;
  status?: Maybe<Scalars['String']>;
  waiting_time_in_queue?: Maybe<Scalars['Int']>;
};

export type GetSuggestAssignmentResultInput = {
  requestId: Scalars['String'];
};

export type GetSuggestAssignmentResultResponse = {
  __typename?: 'GetSuggestAssignmentResultResponse';
  error?: Maybe<Scalars['String']>;
  /**
   *   Per-stop/job-level detail, mirroring SubmitSuggestAssignmentResponse —
   *  always empty here in practice (validation happens only at submit; a
   *  validation failure never persists a record for this query to find).
   */
  errors: Array<SuggestAssignmentValidationError>;
  requestId: Scalars['String'];
  result?: Maybe<SuggestAssignmentResult>;
  status: SuggestAssignmentStatus;
};

export type IndicatorConfig = {
  __typename?: 'IndicatorConfig';
  config: Scalars['AWSJSON'];
  siteId: Scalars['Int'];
  sk: Scalars['ID'];
};

export type IndicatorConfigsConnection = {
  __typename?: 'IndicatorConfigsConnection';
  items?: Maybe<Array<IndicatorConfig>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type IndicatorConfigsFilter = {
  siteId?: InputMaybe<ModelIntFilterInput>;
  sk?: InputMaybe<ModelIdFilterInput>;
};

export type Job = {
  __typename?: 'Job';
  dispatchGroup?: Maybe<NestedDispatchGroup>;
  driver?: Maybe<NestedDriver>;
  dueBy?: Maybe<Scalars['AWSDateTime']>;
  indexDateTime: Scalars['AWSDateTime'];
  indicatorColor?: Maybe<Scalars['String']>;
  indicatorExpiry?: Maybe<Scalars['AWSDateTime']>;
  /**   DP-2999 scaffold — populated by the colorized-indicators worker (follow-up ticket). */
  indicatorRank?: Maybe<Scalars['Int']>;
  indicatorSnoozeUntil?: Maybe<Scalars['AWSDateTime']>;
  jobAlias?: Maybe<Scalars['String']>;
  jobId: Scalars['Int'];
  jobNumber: Scalars['String'];
  jobStatus: Scalars['String'];
  manifestDriverId?: Maybe<Scalars['Int']>;
  order: NestedOrder;
  pieces?: Maybe<Scalars['Float']>;
  readyAt?: Maybe<Scalars['AWSDateTime']>;
  routeNumber?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  stopCount?: Maybe<Scalars['Int']>;
  stops: Array<NestedJobStop>;
  tenantId: Scalars['String'];
  vehicleType?: Maybe<NestedVehicleType>;
  weight?: Maybe<Scalars['Float']>;
};

export type JobAssignmentUpdate = {
  __typename?: 'JobAssignmentUpdate';
  jobIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  jobStopIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  manifestDriverId?: Maybe<Scalars['Int']>;
  submissionResult?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type JobAttributeFilter = {
  and?: InputMaybe<Array<InputMaybe<JobAttributeFilter>>>;
  dispatchGroup_description?: InputMaybe<TextFilterInput>;
  dispatchGroup_dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  dispatchGroup_name?: InputMaybe<KeywordFilterInput>;
  dispatchGroup_site_code?: InputMaybe<KeywordFilterInput>;
  dispatchGroup_site_siteId?: InputMaybe<ModelIntFilterInput>;
  dispatchGroup_type?: InputMaybe<KeywordFilterInput>;
  driver_driverCode?: InputMaybe<KeywordFilterInput>;
  driver_driverId?: InputMaybe<ModelIntFilterInput>;
  dueBy?: InputMaybe<ModelStringFilterInput>;
  indicatorColor?: InputMaybe<KeywordFilterInput>;
  indicatorExpiry?: InputMaybe<DateTimeFilterInput>;
  /**   DP-2999 scaffold — filter/sort by backend-computed indicator fields. */
  indicatorRank?: InputMaybe<ModelIntFilterInput>;
  jobAlias?: InputMaybe<TextFilterInput>;
  jobId?: InputMaybe<ModelIntFilterInput>;
  jobNumber?: InputMaybe<KeywordFilterInput>;
  jobStatus?: InputMaybe<KeywordFilterInput>;
  manifestDriverId?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<JobAttributeFilter>;
  or?: InputMaybe<Array<InputMaybe<JobAttributeFilter>>>;
  order_alias?: InputMaybe<TextFilterInput>;
  order_auth?: InputMaybe<TextFilterInput>;
  order_caller?: InputMaybe<TextFilterInput>;
  order_callerPhone?: InputMaybe<KeywordFilterInput>;
  order_codAmount?: InputMaybe<ModelFloatFilterInput>;
  order_codStatus?: InputMaybe<KeywordFilterInput>;
  order_createdDateTime?: InputMaybe<ModelStringFilterInput>;
  order_customer_alias?: InputMaybe<TextFilterInput>;
  order_customer_customerCode?: InputMaybe<TextFilterInput>;
  order_customer_customerId?: InputMaybe<ModelIntFilterInput>;
  order_customer_group?: InputMaybe<TextFilterInput>;
  order_customer_name?: InputMaybe<TextFilterInput>;
  order_customer_notes?: InputMaybe<TextFilterInput>;
  order_declaredValue?: InputMaybe<ModelFloatFilterInput>;
  order_description?: InputMaybe<TextFilterInput>;
  order_invoiceReference?: InputMaybe<TextFilterInput>;
  order_liftGateRequired?: InputMaybe<ModelBooleanFilterInput>;
  order_notes?: InputMaybe<TextFilterInput>;
  order_orderId?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_id?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_name?: InputMaybe<TextFilterInput>;
  order_origin?: InputMaybe<KeywordFilterInput>;
  order_otherReference?: InputMaybe<TextFilterInput>;
  order_packageType_description?: InputMaybe<KeywordFilterInput>;
  order_packageType_packageTypeId?: InputMaybe<ModelIntFilterInput>;
  order_priority_description?: InputMaybe<TextFilterInput>;
  order_priority_orderPriorityId?: InputMaybe<ModelIntFilterInput>;
  order_qualityFlag?: InputMaybe<ModelBooleanFilterInput>;
  order_requirements_code?: InputMaybe<KeywordFilterInput>;
  order_requirements_id?: InputMaybe<ModelIntFilterInput>;
  order_requirements_name?: InputMaybe<TextFilterInput>;
  order_totalMiles?: InputMaybe<ModelFloatFilterInput>;
  order_user_userName?: InputMaybe<TextFilterInput>;
  order_webUserId?: InputMaybe<ModelIntFilterInput>;
  pieces?: InputMaybe<ModelFloatFilterInput>;
  readyAt?: InputMaybe<ModelStringFilterInput>;
  routeNumber?: InputMaybe<KeywordFilterInput>;
  service?: InputMaybe<KeywordFilterInput>;
  site_code?: InputMaybe<KeywordFilterInput>;
  site_siteId?: InputMaybe<ModelIntFilterInput>;
  stopCount?: InputMaybe<ModelIntFilterInput>;
  vehicleType_description?: InputMaybe<TextFilterInput>;
  vehicleType_iconPath?: InputMaybe<KeywordFilterInput>;
  vehicleType_vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
  weight?: InputMaybe<ModelFloatFilterInput>;
};

export type JobConnection = {
  __typename?: 'JobConnection';
  items: Array<Job>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type JobFilter = {
  job?: InputMaybe<JobAttributeFilter>;
  multiMatch?: InputMaybe<MultiMatchFilter>;
  queryString?: InputMaybe<QueryStringFilter>;
  stops?: InputMaybe<Array<NestedJobStopFilterInput>>;
};

export type JobSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<Scalars['String']>;
  nestedFilter?: InputMaybe<NestedJobStopFilterInput>;
};

export type JobStopManifestSequence = {
  jobStopId: Scalars['Int'];
  manifestSequence: Scalars['Int'];
};

export enum JobStopTextFields {
  Address = 'address',
  City = 'city',
  Name = 'name',
  Note = 'note',
  Room = 'room',
  See = 'see'
}

export enum JobTextFields {
  DispatchGroupDescription = 'dispatchGroup_description',
  JobAlias = 'jobAlias',
  OrderAlias = 'order_alias',
  OrderAuth = 'order_auth',
  OrderCaller = 'order_caller',
  OrderCustomerAlias = 'order_customer_alias',
  OrderCustomerCustomerCode = 'order_customer_customerCode',
  OrderCustomerGroup = 'order_customer_group',
  OrderCustomerName = 'order_customer_name',
  OrderCustomerNotes = 'order_customer_notes',
  OrderDescription = 'order_description',
  OrderInvoiceReference = 'order_invoiceReference',
  OrderNotes = 'order_notes',
  OrderOtherReference = 'order_otherReference',
  OrderPackageTypeDescription = 'order_packageType_description',
  OrderPriorityDescription = 'order_priority_description',
  OrderRequirementsName = 'order_requirements_name',
  OrderUserUserName = 'order_user_userName',
  VehicleTypeDescription = 'vehicleType_description'
}

export type KeywordFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['String']>;
  matchPhrase?: InputMaybe<Scalars['String']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']>;
  multiMatch?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['String']>;
};

export type LateStop = {
  __typename?: 'LateStop';
  customerGroup?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['Int']>;
  lateStopId: Scalars['Int'];
  sequence?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['Int']>;
  siteId?: Maybe<Scalars['Int']>;
  stopMinutes?: Maybe<Scalars['Int']>;
  stopType?: Maybe<Scalars['String']>;
  timeType: Scalars['Int'];
  triggerType: Scalars['Int'];
};

export type LateStopConnection = {
  __typename?: 'LateStopConnection';
  items?: Maybe<Array<LateStop>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type LateStopFilterInput = {
  and?: InputMaybe<Array<LateStopFilterInput>>;
  customerGroup?: InputMaybe<TextFilterInput>;
  customerId?: InputMaybe<ModelIntFilterInput>;
  lateStopId?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<Array<LateStopFilterInput>>;
  or?: InputMaybe<Array<LateStopFilterInput>>;
  sequence?: InputMaybe<ModelFloatFilterInput>;
  serviceId?: InputMaybe<ModelIntFilterInput>;
  siteId?: InputMaybe<ModelIntFilterInput>;
  stopMinutes?: InputMaybe<ModelIntFilterInput>;
  stopType?: InputMaybe<TextFilterInput>;
  timeType?: InputMaybe<ModelIntFilterInput>;
  triggerType?: InputMaybe<ModelIntFilterInput>;
};

export type LateStopSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: LateStopSortableField;
};

export enum LateStopSortableField {
  CustomerGroup = 'customerGroup',
  CustomerId = 'customerId',
  LateStopId = 'lateStopId',
  Sequence = 'sequence',
  ServiceId = 'serviceId',
  SiteId = 'siteId',
  StopMinutes = 'stopMinutes',
  StopType = 'stopType',
  TimeType = 'timeType',
  TriggerType = 'triggerType'
}

export enum LineType {
  EncodedLineString = 'EncodedLineString',
  LineString = 'LineString'
}

export type Manifest = {
  __typename?: 'Manifest';
  alertDateTime?: Maybe<Scalars['String']>;
  autoCloseManifest?: Maybe<Scalars['Int']>;
  createdDateTime?: Maybe<Scalars['String']>;
  dispatchGroup?: Maybe<NestedDispatchGroup>;
  driver: ManifestDriver;
  endMileage?: Maybe<Scalars['Float']>;
  endZip?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<ManifestDriverEvent>>>;
  lastZone?: Maybe<Scalars['String']>;
  manifestDate?: Maybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
  manifestStatus: Scalars['ID'];
  metadata?: Maybe<EntityMetadata>;
  optimizedBy?: Maybe<Scalars['String']>;
  optimizedDateTime?: Maybe<Scalars['AWSDateTime']>;
  siteId?: Maybe<Scalars['Int']>;
  startMileage?: Maybe<Scalars['Float']>;
  stopCount?: Maybe<Scalars['Int']>;
  stops?: Maybe<Array<ManifestStop>>;
  totalPieces?: Maybe<Scalars['Int']>;
  vehicleType: NestedVehicleType;
};

export type ManifestAttributeFilter = {
  and?: InputMaybe<Array<InputMaybe<ManifestAttributeFilter>>>;
  autoCloseManifest?: InputMaybe<ModelBooleanFilterInput>;
  createdDateTime?: InputMaybe<ModelStringFilterInput>;
  dispatchGroup_description?: InputMaybe<TextFilterInput>;
  dispatchGroup_dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  dispatchGroup_name?: InputMaybe<KeywordFilterInput>;
  dispatchGroup_siteId?: InputMaybe<ModelIntFilterInput>;
  dispatchGroup_type?: InputMaybe<KeywordFilterInput>;
  driver_alias?: InputMaybe<TextFilterInput>;
  driver_code?: InputMaybe<TextFilterInput>;
  driver_driverId?: InputMaybe<ModelIntFilterInput>;
  driver_name?: InputMaybe<TextFilterInput>;
  driver_note?: InputMaybe<TextFilterInput>;
  driver_phone?: InputMaybe<KeywordFilterInput>;
  driver_qualifications_code?: InputMaybe<KeywordFilterInput>;
  driver_qualifications_id?: InputMaybe<ModelIntFilterInput>;
  driver_qualifications_name?: InputMaybe<TextFilterInput>;
  driver_siteId?: InputMaybe<ModelIntFilterInput>;
  driver_skills_id?: InputMaybe<ModelIntFilterInput>;
  endZip?: InputMaybe<KeywordFilterInput>;
  lastZone?: InputMaybe<KeywordFilterInput>;
  manifestDate?: InputMaybe<ModelStringFilterInput>;
  manifestDriverId?: InputMaybe<ModelIntFilterInput>;
  manifestStatus?: InputMaybe<KeywordFilterInput>;
  not?: InputMaybe<ManifestAttributeFilter>;
  optimizedBy?: InputMaybe<KeywordFilterInput>;
  optimizedDateTime?: InputMaybe<DateTimeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ManifestAttributeFilter>>>;
  siteId?: InputMaybe<ModelIntFilterInput>;
  stopCount?: InputMaybe<ModelIntFilterInput>;
  totalPieces?: InputMaybe<ModelIntFilterInput>;
  vehicleType_description?: InputMaybe<TextFilterInput>;
  vehicleType_vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
};

export type ManifestConnection = {
  __typename?: 'ManifestConnection';
  items: Array<Manifest>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type ManifestDriver = {
  __typename?: 'ManifestDriver';
  alias?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  dispatchGroup?: Maybe<NestedDispatchGroup>;
  driverId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  qualifications?: Maybe<Array<DriverQualification>>;
  siteId?: Maybe<Scalars['Int']>;
  skills?: Maybe<Array<Skill>>;
};

export type ManifestDriverEvent = {
  __typename?: 'ManifestDriverEvent';
  eventId: Scalars['Int'];
  eventTypeId: Scalars['Int'];
  startDateTime?: Maybe<Scalars['String']>;
};

export type ManifestDriverEventInput = {
  manifestDriverEventTypeId: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type ManifestFilter = {
  manifest?: InputMaybe<ManifestAttributeFilter>;
  multiMatch?: InputMaybe<MultiMatchFilter>;
  queryString?: InputMaybe<QueryStringFilter>;
  stops?: InputMaybe<Array<ManifestStopFilter>>;
};

export type ManifestSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<Scalars['String']>;
  nestedFilter?: InputMaybe<ManifestStopFilter>;
};

export type ManifestStop = {
  __typename?: 'ManifestStop';
  address?: Maybe<Scalars['String']>;
  arriveDateTime?: Maybe<Scalars['String']>;
  avsQuality?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  departDateTime?: Maybe<Scalars['String']>;
  dispatchZone?: Maybe<Scalars['ID']>;
  dst?: Maybe<Scalars['Boolean']>;
  earlyDateTime?: Maybe<Scalars['String']>;
  indicatorColor?: Maybe<Scalars['String']>;
  indicatorExpiry?: Maybe<Scalars['AWSDateTime']>;
  /**   DP-2999 scaffold — populated by the colorized-indicators worker per-stop. */
  indicatorRank?: Maybe<Scalars['Int']>;
  indicatorSnoozeUntil?: Maybe<Scalars['AWSDateTime']>;
  job: ManifestStopJob;
  jobStopId: Scalars['Int'];
  jobStopStatus?: Maybe<Scalars['ID']>;
  lateDateTime?: Maybe<Scalars['String']>;
  manifestSequence: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  order: ManifestStopOrder;
  phone?: Maybe<Scalars['ID']>;
  podDateTime?: Maybe<Scalars['String']>;
  podName?: Maybe<Scalars['String']>;
  podRequired?: Maybe<Scalars['Boolean']>;
  room?: Maybe<Scalars['String']>;
  scheduledDateTime?: Maybe<Scalars['String']>;
  see?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['ID']>;
  stopType: Scalars['ID'];
  timeZone?: Maybe<Scalars['ID']>;
  zip?: Maybe<Scalars['ID']>;
};

export type ManifestStopFilter = {
  address?: InputMaybe<TextFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ManifestStopFilter>>>;
  arriveDateTime?: InputMaybe<DateTimeFilterInput>;
  avsQuality?: InputMaybe<ModelIntFilterInput>;
  city?: InputMaybe<TextFilterInput>;
  departDateTime?: InputMaybe<DateTimeFilterInput>;
  dispatchZone?: InputMaybe<KeywordFilterInput>;
  dst?: InputMaybe<ModelBooleanFilterInput>;
  indicatorColor?: InputMaybe<KeywordFilterInput>;
  indicatorExpiry?: InputMaybe<DateTimeFilterInput>;
  /**   DP-2999 scaffold — filter/sort by backend-computed indicator fields (per-stop). */
  indicatorRank?: InputMaybe<ModelIntFilterInput>;
  jobStopId?: InputMaybe<ModelIntFilterInput>;
  jobStopStatus?: InputMaybe<KeywordFilterInput>;
  job_dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  job_driverId?: InputMaybe<ModelIntFilterInput>;
  job_driverId2?: InputMaybe<ModelIntFilterInput>;
  job_jobId?: InputMaybe<ModelIntFilterInput>;
  job_jobNumber?: InputMaybe<KeywordFilterInput>;
  job_pieces?: InputMaybe<ModelFloatFilterInput>;
  job_routeNumber?: InputMaybe<KeywordFilterInput>;
  job_splitPercentage?: InputMaybe<ModelStringFilterInput>;
  job_status?: InputMaybe<KeywordFilterInput>;
  job_weight?: InputMaybe<ModelFloatFilterInput>;
  lateDateTime?: InputMaybe<DateTimeFilterInput>;
  manifestSequence?: InputMaybe<ModelIntFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<ManifestStopFilter>;
  offset?: InputMaybe<ModelIntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ManifestStopFilter>>>;
  order_alias?: InputMaybe<TextFilterInput>;
  order_createDate?: InputMaybe<DateTimeFilterInput>;
  order_customer_customerId?: InputMaybe<ModelIntFilterInput>;
  order_customer_customerName?: InputMaybe<TextFilterInput>;
  order_customer_group?: InputMaybe<TextFilterInput>;
  order_customer_notes?: InputMaybe<KeywordFilterInput>;
  order_liftGateRequired?: InputMaybe<ModelBooleanFilterInput>;
  order_notes?: InputMaybe<KeywordFilterInput>;
  order_orderDate?: InputMaybe<DateTimeFilterInput>;
  order_orderId?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_id?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_name?: InputMaybe<TextFilterInput>;
  order_priority_description?: InputMaybe<TextFilterInput>;
  order_priority_orderPriorityId?: InputMaybe<ModelIntFilterInput>;
  order_qualityFlag?: InputMaybe<ModelBooleanFilterInput>;
  order_service?: InputMaybe<KeywordFilterInput>;
  podDateTime?: InputMaybe<DateTimeFilterInput>;
  scheduledDateTime?: InputMaybe<DateTimeFilterInput>;
  sequence?: InputMaybe<ModelIntFilterInput>;
  state?: InputMaybe<KeywordFilterInput>;
  stopType?: InputMaybe<KeywordFilterInput>;
  timeZone?: InputMaybe<KeywordFilterInput>;
  zip?: InputMaybe<KeywordFilterInput>;
};

export type ManifestStopJob = {
  __typename?: 'ManifestStopJob';
  alias?: Maybe<Scalars['String']>;
  dispatchGroupId?: Maybe<Scalars['Int']>;
  driverId?: Maybe<Scalars['Int']>;
  driverId2?: Maybe<Scalars['Int']>;
  jobId: Scalars['Int'];
  jobNumber: Scalars['ID'];
  pieces?: Maybe<Scalars['Float']>;
  routeNumber?: Maybe<Scalars['ID']>;
  site?: Maybe<Site>;
  splitPercentage?: Maybe<Scalars['String']>;
  status: Scalars['ID'];
  weight?: Maybe<Scalars['Float']>;
};

export type ManifestStopOrder = {
  __typename?: 'ManifestStopOrder';
  alias?: Maybe<Scalars['String']>;
  auth?: Maybe<Scalars['String']>;
  caller?: Maybe<Scalars['String']>;
  callerPhone?: Maybe<Scalars['String']>;
  codAmount?: Maybe<Scalars['Float']>;
  codStatus?: Maybe<Scalars['String']>;
  createDate?: Maybe<Scalars['AWSDateTime']>;
  customer: ManifestStopOrderCustomer;
  declaredValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  invoiceReference?: Maybe<Scalars['String']>;
  liftGateRequired: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  orderId: Scalars['Int'];
  orderSkills?: Maybe<Array<Skill>>;
  otherReference?: Maybe<Scalars['String']>;
  podRequired?: Maybe<Scalars['Boolean']>;
  priority?: Maybe<ManifestStopOrderPriority>;
  qualityFlag: Scalars['Boolean'];
  requirements?: Maybe<Array<OrderRequirement>>;
  service?: Maybe<Scalars['ID']>;
  tabPieces?: Maybe<Scalars['Int']>;
  user?: Maybe<NestedUser>;
};

export type ManifestStopOrderCustomer = {
  __typename?: 'ManifestStopOrderCustomer';
  alias?: Maybe<Scalars['ID']>;
  customerCode?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type ManifestStopOrderPriority = {
  __typename?: 'ManifestStopOrderPriority';
  description?: Maybe<Scalars['String']>;
  orderPriorityId: Scalars['Int'];
};

export enum ManifestStopTextFields {
  Address = 'address',
  City = 'city',
  JobJobNumber = 'job_jobNumber',
  JobRouteNumber = 'job_routeNumber',
  Name = 'name',
  Note = 'note',
  OrderAlias = 'order_alias',
  OrderCustomerAlias = 'order_customer_alias',
  OrderCustomerGroup = 'order_customer_group',
  OrderCustomerName = 'order_customer_name',
  OrderCustomerNotes = 'order_customer_notes',
  OrderNotes = 'order_notes',
  OrderPriorityDescription = 'order_priority_description',
  Room = 'room',
  See = 'see'
}

export enum ManifestTextFields {
  DispatchGroupDescription = 'dispatchGroup_description',
  DriverAlias = 'driver_alias',
  DriverCode = 'driver_code',
  DriverName = 'driver_name',
  DriverNote = 'driver_note',
  DriverQualificationsName = 'driver_qualifications_name',
  VehicleTypeDescription = 'vehicleType_description'
}

export type ModelBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type ModelDispatchGroupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDispatchGroupFilterInput>>>;
  autoCloseManifest?: InputMaybe<ModelIntFilterInput>;
  description?: InputMaybe<ModelStringFilterInput>;
  dispatchGroup?: InputMaybe<ModelStringFilterInput>;
  dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  dispatchType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelDispatchGroupFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDispatchGroupFilterInput>>>;
  siteId?: InputMaybe<ModelIntFilterInput>;
};

export type ModelDispatchStationGroupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDispatchStationGroupFilterInput>>>;
  description?: InputMaybe<ModelStringFilterInput>;
  dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  dispatchStation?: InputMaybe<ModelStringFilterInput>;
  dispatchType?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<Array<InputMaybe<ModelDispatchStationGroupFilterInput>>>;
  or?: InputMaybe<Array<InputMaybe<ModelDispatchStationGroupFilterInput>>>;
  vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
};

export type ModelDriverFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDriverFilterInput>>>;
  autoAccept?: InputMaybe<ModelBooleanFilterInput>;
  autoSend?: InputMaybe<ModelBooleanFilterInput>;
  dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  driverAlias?: InputMaybe<ModelStringFilterInput>;
  driverCode?: InputMaybe<ModelStringFilterInput>;
  driverId?: InputMaybe<ModelIntFilterInput>;
  driverStatus?: InputMaybe<ModelStringFilterInput>;
  name?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelDriverFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDriverFilterInput>>>;
  phone?: InputMaybe<ModelStringFilterInput>;
  siteId?: InputMaybe<ModelIntFilterInput>;
  startZip?: InputMaybe<ModelStringFilterInput>;
  startZone?: InputMaybe<ModelStringFilterInput>;
  vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
};

export type ModelDriverLocationFilterInput = {
  boundingBox?: InputMaybe<BoundingBox>;
  driverIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type ModelFloatFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type ModelIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  match?: InputMaybe<Scalars['ID']>;
  matchPhrase?: InputMaybe<Scalars['ID']>;
  matchPhrasePrefix?: InputMaybe<Scalars['ID']>;
  multiMatch?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regexp?: InputMaybe<Scalars['ID']>;
  wildcard?: InputMaybe<Scalars['ID']>;
};

export type ModelIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  term?: InputMaybe<Scalars['Int']>;
};

export type ModelOrderPriorityFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrderPriorityFilterInput>>>;
  description?: InputMaybe<ModelStringFilterInput>;
  dispatchJobColor?: InputMaybe<ModelIntFilterInput>;
  not?: InputMaybe<ModelOrderPriorityFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrderPriorityFilterInput>>>;
  orderPriorityId?: InputMaybe<ModelIntFilterInput>;
  siteId?: InputMaybe<ModelStringFilterInput>;
};

export type ModelStringFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  match?: InputMaybe<Scalars['String']>;
  matchPhrase?: InputMaybe<Scalars['String']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']>;
  multiMatch?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regexp?: InputMaybe<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['String']>;
};

export type ModelVehicleTypeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelVehicleTypeFilterInput>>>;
  costPerMile?: InputMaybe<ModelFloatFilterInput>;
  description?: InputMaybe<ModelStringFilterInput>;
  dispatchJobColor?: InputMaybe<ModelIntFilterInput>;
  dwellTime?: InputMaybe<ModelIntFilterInput>;
  iconPath?: InputMaybe<ModelStringFilterInput>;
  laborCostPerHo?: InputMaybe<ModelFloatFilterInput>;
  maxCube?: InputMaybe<ModelIntFilterInput>;
  maxPieces?: InputMaybe<ModelIntFilterInput>;
  maxWeight?: InputMaybe<ModelIntFilterInput>;
  message?: InputMaybe<ModelStringFilterInput>;
  not?: InputMaybe<ModelVehicleTypeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelVehicleTypeFilterInput>>>;
  rank?: InputMaybe<ModelIntFilterInput>;
  showOnWeb?: InputMaybe<ModelIntFilterInput>;
  sortSequence?: InputMaybe<ModelStringFilterInput>;
  vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
};

export type MultiFieldWildcard = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']>;
  fields: Array<Scalars['String']>;
  wildcard: Scalars['String'];
};

export type MultiMatchFilter = {
  fields: Array<Scalars['String']>;
  operator: MultiMatchOperator;
  query: Scalars['String'];
  type: MultiMatchType;
};

export enum MultiMatchOperator {
  And = 'and',
  Or = 'or'
}

export enum MultiMatchType {
  BestFields = 'best_fields',
  CrossFields = 'cross_fields',
  MostFields = 'most_fields',
  Phrase = 'phrase',
  PhrasePrefix = 'phrase_prefix'
}

export type Mutation = {
  __typename?: 'Mutation';
  addOrderNote?: Maybe<Scalars['String']>;
  assignJobsToManifest?: Maybe<Scalars['String']>;
  cancelSuggestAssignment?: Maybe<Scalars['Boolean']>;
  clearManifestDriverEvents?: Maybe<Scalars['String']>;
  closeManifest?: Maybe<Scalars['String']>;
  createManifest?: Maybe<Scalars['String']>;
  deleteEtaNotificationConfig?: Maybe<EtaNotificationConfig>;
  deleteIndicatorConfig?: Maybe<IndicatorConfig>;
  deleteTenantPref?: Maybe<TenantPref>;
  deleteUserPref?: Maybe<UserPref>;
  enableDataChangedEvents?: Maybe<Scalars['String']>;
  processRoutePlanning?: Maybe<ProcessRoutePlanningResponse>;
  publishDataChangedEvent?: Maybe<DataChangedEvent>;
  publishEventDispatchUpdate?: Maybe<DispatchUpdate>;
  publishEventJobAssignmentUpdate?: Maybe<JobAssignmentUpdate>;
  publishEventResequenceManifestUpdate?: Maybe<ResequenceManifestUpdate>;
  reassignJobStops?: Maybe<Scalars['String']>;
  recordRoutePlanningUsage?: Maybe<RoutePlanningUsage>;
  resequenceManifestStops?: Maybe<Scalars['String']>;
  saveClearJobStops?: Maybe<Scalars['String']>;
  saveManifestDriverEvents?: Maybe<Scalars['String']>;
  setEtaNotificationConfig?: Maybe<EtaNotificationConfig>;
  setIndicatorConfig?: Maybe<IndicatorConfig>;
  setTenantPref?: Maybe<TenantPref>;
  setUserPref?: Maybe<UserPref>;
  /**   DP-2999 scaffold — handler returns false until follow-up ticket wires the OpenSearch update. */
  snoozeIndicator?: Maybe<Scalars['Boolean']>;
  splitJob?: Maybe<Scalars['String']>;
  submitRoutePlanning?: Maybe<SubmitRoutePlanningResponse>;
  submitSuggestAssignment?: Maybe<SubmitSuggestAssignmentResponse>;
  suggestAssignJob?: Maybe<Scalars['String']>;
  unassignJobStopsFromManifest?: Maybe<Scalars['String']>;
  updateManifest?: Maybe<Scalars['String']>;
};


export type MutationAddOrderNoteArgs = {
  note: Scalars['String'];
  orderId: Scalars['Int'];
};


export type MutationAssignJobsToManifestArgs = {
  jobIds: Array<InputMaybe<Scalars['Int']>>;
  manifestDriverId: Scalars['Int'];
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>>>;
};


export type MutationCancelSuggestAssignmentArgs = {
  input: CancelSuggestAssignmentInput;
};


export type MutationClearManifestDriverEventsArgs = {
  manifestDriverEventTypeId?: InputMaybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
};


export type MutationCloseManifestArgs = {
  endMileage?: InputMaybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
  startMileage?: InputMaybe<Scalars['String']>;
};


export type MutationCreateManifestArgs = {
  autoAccept?: InputMaybe<Scalars['Boolean']>;
  autoSend?: InputMaybe<Scalars['Boolean']>;
  dispatchGroupId?: InputMaybe<Scalars['Int']>;
  driverId: Scalars['Int'];
  endZip?: InputMaybe<Scalars['String']>;
  endZone?: InputMaybe<Scalars['String']>;
  manifestDate?: InputMaybe<Scalars['String']>;
  manifestDriverStatus?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startZip?: InputMaybe<Scalars['String']>;
  startZone?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteEtaNotificationConfigArgs = {
  sk: Scalars['ID'];
};


export type MutationDeleteIndicatorConfigArgs = {
  sk: Scalars['ID'];
};


export type MutationDeleteTenantPrefArgs = {
  name: Scalars['String'];
};


export type MutationDeleteUserPrefArgs = {
  name: Scalars['String'];
};


export type MutationEnableDataChangedEventsArgs = {
  entityId?: InputMaybe<Scalars['String']>;
  entityType: DataChangeEntityType;
  ttl?: InputMaybe<Scalars['Int']>;
};


export type MutationProcessRoutePlanningArgs = {
  input: ProcessRoutePlanningInput;
};


export type MutationPublishDataChangedEventArgs = {
  entityId?: InputMaybe<Scalars['String']>;
  entityType: DataChangeEntityType;
  tenantId: Scalars['String'];
};


export type MutationPublishEventDispatchUpdateArgs = {
  data?: InputMaybe<Scalars['AWSJSON']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationPublishEventJobAssignmentUpdateArgs = {
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  jobStopIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  manifestDriverId?: InputMaybe<Scalars['Int']>;
  submissionResult?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type MutationPublishEventResequenceManifestUpdateArgs = {
  manifestDriverId?: InputMaybe<Scalars['Int']>;
  submissionResult?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};


export type MutationReassignJobStopsArgs = {
  fromManifestDriverId: Scalars['Int'];
  jobStopIds: Array<InputMaybe<Scalars['Int']>>;
  keepManifestSequence?: InputMaybe<Scalars['Boolean']>;
  manifestDriverId: Scalars['Int'];
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>>>;
};


export type MutationRecordRoutePlanningUsageArgs = {
  input: RecordRoutePlanningUsageInput;
};


export type MutationResequenceManifestStopsArgs = {
  etaSourcesDirty?: InputMaybe<Array<Scalars['String']>>;
  isOptimized?: InputMaybe<Scalars['Boolean']>;
  jobStopManifestSequences: Array<InputMaybe<JobStopManifestSequence>>;
  manifestDriverId: Scalars['Int'];
  optimizationEtas?: InputMaybe<Array<EtaItemInput>>;
};


export type MutationSaveClearJobStopsArgs = {
  saveClearJobStops: Array<InputMaybe<SaveClearJobStop>>;
};


export type MutationSaveManifestDriverEventsArgs = {
  events?: InputMaybe<Array<ManifestDriverEventInput>>;
  manifestDriverId: Scalars['Int'];
};


export type MutationSetEtaNotificationConfigArgs = {
  input: SetEtaNotificationConfigInput;
  sk?: InputMaybe<Scalars['ID']>;
};


export type MutationSetIndicatorConfigArgs = {
  input: SetIndicatorConfigInput;
  sk?: InputMaybe<Scalars['ID']>;
};


export type MutationSetTenantPrefArgs = {
  input: SetTenantPrefInput;
  name: Scalars['String'];
};


export type MutationSetUserPrefArgs = {
  input: SetUserPrefInput;
  name: Scalars['String'];
};


export type MutationSnoozeIndicatorArgs = {
  entityType: SnoozeIndicatorEntityType;
  id: Scalars['Int'];
  minutes: Scalars['Int'];
};


export type MutationSplitJobArgs = {
  driverId: Scalars['Int'];
  jobId: Scalars['Int'];
  splitPercentage: Scalars['String'];
};


export type MutationSubmitRoutePlanningArgs = {
  input: SubmitRoutePlanningInput;
};


export type MutationSubmitSuggestAssignmentArgs = {
  input: SubmitSuggestAssignmentInput;
};


export type MutationSuggestAssignJobArgs = {
  jobIds: Array<InputMaybe<Scalars['Int']>>;
  manifestDriverId: Scalars['Int'];
  optimizationEtas: Array<EtaItemInput>;
  sequences: Array<Scalars['Int']>;
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>>>;
};


export type MutationUnassignJobStopsFromManifestArgs = {
  jobStopIds: Array<InputMaybe<Scalars['Int']>>;
  manifestDriverId: Scalars['Int'];
};


export type MutationUpdateManifestArgs = {
  autoAccept?: InputMaybe<Scalars['Boolean']>;
  autoSend?: InputMaybe<Scalars['Boolean']>;
  dispatchGroupId?: InputMaybe<Scalars['Int']>;
  endZip?: InputMaybe<Scalars['String']>;
  endZone?: InputMaybe<Scalars['String']>;
  manifestDate?: InputMaybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
  manifestDriverStatus?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startZip?: InputMaybe<Scalars['String']>;
  startZone?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']>;
};

export type NestedCustomer = {
  __typename?: 'NestedCustomer';
  alias?: Maybe<Scalars['String']>;
  customerCode?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type NestedDispatchGroup = {
  __typename?: 'NestedDispatchGroup';
  description?: Maybe<Scalars['String']>;
  dispatchGroupId: Scalars['Int'];
  name: Scalars['String'];
  site?: Maybe<Site>;
  type: Scalars['String'];
};

export type NestedDriver = {
  __typename?: 'NestedDriver';
  driverCode?: Maybe<Scalars['String']>;
  driverId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type NestedJobStop = {
  __typename?: 'NestedJobStop';
  address?: Maybe<Scalars['String']>;
  arriveDateTime?: Maybe<Scalars['String']>;
  avsQuality?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  departDateTime?: Maybe<Scalars['String']>;
  dispatchZone?: Maybe<Scalars['String']>;
  dst?: Maybe<Scalars['Boolean']>;
  earlyDateTime?: Maybe<Scalars['String']>;
  jobStopId: Scalars['Int'];
  jobStopStatus?: Maybe<Scalars['String']>;
  lateDateTime?: Maybe<Scalars['String']>;
  manifestSequence?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  podDateTime?: Maybe<Scalars['String']>;
  podRequired?: Maybe<Scalars['Boolean']>;
  room?: Maybe<Scalars['String']>;
  scheduledDateTime?: Maybe<Scalars['String']>;
  see?: Maybe<Scalars['String']>;
  sequence: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  stopType?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NestedJobStopFilterInput = {
  address?: InputMaybe<TextFilterInput>;
  and?: InputMaybe<Array<InputMaybe<NestedJobStopFilterInput>>>;
  avsQuality?: InputMaybe<ModelIntFilterInput>;
  city?: InputMaybe<TextFilterInput>;
  dispatchZone?: InputMaybe<KeywordFilterInput>;
  dst?: InputMaybe<ModelBooleanFilterInput>;
  earlyDateTime?: InputMaybe<ModelStringFilterInput>;
  jobStopId?: InputMaybe<ModelIntFilterInput>;
  jobStopStatus?: InputMaybe<KeywordFilterInput>;
  lateDateTime?: InputMaybe<ModelStringFilterInput>;
  manifestSequence?: InputMaybe<ModelIntFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<NestedJobStopFilterInput>;
  note?: InputMaybe<TextFilterInput>;
  offset?: InputMaybe<ModelIntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<NestedJobStopFilterInput>>>;
  phone?: InputMaybe<KeywordFilterInput>;
  room?: InputMaybe<TextFilterInput>;
  scheduledDateTime?: InputMaybe<ModelStringFilterInput>;
  see?: InputMaybe<TextFilterInput>;
  sequence?: InputMaybe<ModelIntFilterInput>;
  state?: InputMaybe<KeywordFilterInput>;
  stopType?: InputMaybe<KeywordFilterInput>;
  timeZone?: InputMaybe<KeywordFilterInput>;
  zip?: InputMaybe<KeywordFilterInput>;
};

export type NestedOrder = {
  __typename?: 'NestedOrder';
  alias?: Maybe<Scalars['String']>;
  auth?: Maybe<Scalars['String']>;
  caller?: Maybe<Scalars['String']>;
  callerPhone?: Maybe<Scalars['String']>;
  codAmount?: Maybe<Scalars['Float']>;
  codStatus?: Maybe<Scalars['String']>;
  createdDateTime?: Maybe<Scalars['String']>;
  customer?: Maybe<NestedCustomer>;
  declaredValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  invoiceReference?: Maybe<Scalars['String']>;
  liftGateRequired: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  orderEvents?: Maybe<Array<OrderEvent>>;
  orderId: Scalars['Int'];
  orderSkills?: Maybe<Array<Skill>>;
  origin?: Maybe<Scalars['String']>;
  otherReference?: Maybe<Scalars['String']>;
  packageType?: Maybe<PackageType>;
  priority?: Maybe<NestedOrderPriority>;
  qualityFlag: Scalars['Boolean'];
  requirements?: Maybe<Array<OrderRequirement>>;
  totalMiles?: Maybe<Scalars['Float']>;
  user?: Maybe<NestedUser>;
  webUserId?: Maybe<Scalars['Int']>;
};

export type NestedOrderPriority = {
  __typename?: 'NestedOrderPriority';
  description?: Maybe<Scalars['String']>;
  orderPriorityId: Scalars['Int'];
};

export type NestedStopJob = {
  __typename?: 'NestedStopJob';
  alias?: Maybe<Scalars['String']>;
  jobId: Scalars['Int'];
  jobNumber: Scalars['String'];
  jobStatus: Scalars['String'];
  pieces?: Maybe<Scalars['Float']>;
  routeNumber?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  weight?: Maybe<Scalars['Float']>;
};

export type NestedStopManifest = {
  __typename?: 'NestedStopManifest';
  dispatchGroupId?: Maybe<Scalars['Int']>;
  manifestDriverId?: Maybe<Scalars['Int']>;
  manifestStatus?: Maybe<Scalars['ID']>;
  vehicleType?: Maybe<NestedStopVehicleType>;
};

export type NestedStopOrder = {
  __typename?: 'NestedStopOrder';
  alias?: Maybe<Scalars['String']>;
  auth?: Maybe<Scalars['String']>;
  caller?: Maybe<Scalars['String']>;
  callerPhone?: Maybe<Scalars['String']>;
  codAmount?: Maybe<Scalars['Float']>;
  createDate?: Maybe<Scalars['AWSDateTime']>;
  customer?: Maybe<NestedCustomer>;
  declaredValue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['AWSDate']>;
  orderId: Scalars['Int'];
  orderSkills?: Maybe<Array<Skill>>;
  priority?: Maybe<NestedOrderPriority>;
  service?: Maybe<Scalars['String']>;
  user?: Maybe<NestedUser>;
};

export type NestedStopVehicleType = {
  __typename?: 'NestedStopVehicleType';
  description?: Maybe<Scalars['String']>;
  vehicleTypeId: Scalars['Int'];
};

export type NestedUser = {
  __typename?: 'NestedUser';
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
};

export type NestedVehicleType = {
  __typename?: 'NestedVehicleType';
  description?: Maybe<Scalars['String']>;
  iconPath?: Maybe<Scalars['String']>;
  vehicleTypeId: Scalars['Int'];
};

export type NotificationSentData = {
  __typename?: 'NotificationSentData';
  jobStopId?: Maybe<Scalars['Int']>;
  windowEnd?: Maybe<Scalars['String']>;
  windowStart?: Maybe<Scalars['String']>;
};

export type OptimizedStop = {
  __typename?: 'OptimizedStop';
  isNewJobStop: Scalars['Boolean'];
  jobStopId: Scalars['Int'];
  stopType: Scalars['String'];
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  eventDateTime?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  orderEventId: Scalars['Long'];
  userId?: Maybe<Scalars['Int']>;
  userName?: Maybe<Scalars['String']>;
};

export type OrderPriority = {
  __typename?: 'OrderPriority';
  TYPE?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispatchJobColor?: Maybe<Scalars['Int']>;
  orderPriorityId: Scalars['Int'];
  pk: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
  sk: Scalars['String'];
};

export type OrderPriorityConnection = {
  __typename?: 'OrderPriorityConnection';
  items?: Maybe<Array<Maybe<OrderPriority>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type OrderRequirement = {
  __typename?: 'OrderRequirement';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type PackageType = {
  __typename?: 'PackageType';
  description?: Maybe<Scalars['String']>;
  packageTypeId: Scalars['Int'];
};

export type Pref = {
  lastUpdated?: Maybe<Scalars['AWSDateTime']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['AWSJSON']>;
};

export type ProcessRoutePlanningInput = {
  assignmentDetails: Array<AssignmentDetailInput>;
  metrics?: InputMaybe<RoutePlanningMetricsInput>;
  responseId?: InputMaybe<Scalars['String']>;
};

export type ProcessRoutePlanningResponse = {
  __typename?: 'ProcessRoutePlanningResponse';
  errorsJson?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  optimizationResponse?: Maybe<RoutePlanningSolution>;
  status: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  geocodeAddresses?: Maybe<GeocodeAddressConnection>;
  getBatchOptimizationResult?: Maybe<RouteOptimizationConnection>;
  getCustomer?: Maybe<Customer>;
  getDispatchGroup?: Maybe<DispatchGroup>;
  getDispatchStationGroup?: Maybe<DispatchStationGroup>;
  getDispatchStationRestrictionInfo?: Maybe<DispatchStationRestrictionInfo>;
  getDistinctValues?: Maybe<GetDistinctValuesConnection>;
  getDriver?: Maybe<Driver>;
  getDriverTotalManifests?: Maybe<DriverTotalManifestsResponse>;
  getETA?: Maybe<EtaConnection>;
  getEventType?: Maybe<EventType>;
  getFeeTitle?: Maybe<FeeTitle>;
  getLateStop?: Maybe<LateStop>;
  getOrderPriority?: Maybe<OrderPriority>;
  getRoutePlanningResult?: Maybe<GetRoutePlanningResultResponse>;
  getRoutePlanningUsage?: Maybe<RoutePlanningUsage>;
  getRouteWithEtas?: Maybe<EtaConnection>;
  getService?: Maybe<Service>;
  getSite?: Maybe<Site>;
  getSkill?: Maybe<Skill>;
  getSuggestAssignmentResult?: Maybe<GetSuggestAssignmentResultResponse>;
  getSuggestAssignmentUsage?: Maybe<SuggestAssignmentUsage>;
  getTenantPref?: Maybe<TenantPref>;
  getUserPref?: Maybe<UserPref>;
  getVehicleType?: Maybe<VehicleType>;
  optimizeRoutes?: Maybe<RouteOptimizationConnection>;
  route?: Maybe<RoutingConnection>;
  searchCustomers?: Maybe<CustomerConnection>;
  searchDispatchGroups?: Maybe<DispatchGroupConnection>;
  searchDispatchStationGroups?: Maybe<DispatchStationGroupConnection>;
  searchDriverLocations?: Maybe<DriverLocationConnection>;
  searchDrivers?: Maybe<DriverConnection>;
  searchDriversEnhanced?: Maybe<DriverConnection>;
  searchEtaNotificationConfigs?: Maybe<EtaNotificationConfigsConnection>;
  searchEventTypes?: Maybe<EventTypeConnection>;
  searchFeeTitles?: Maybe<FeeTitleConnection>;
  searchIndicatorConfigs?: Maybe<IndicatorConfigsConnection>;
  searchJobs?: Maybe<JobConnection>;
  searchLateStops?: Maybe<LateStopConnection>;
  searchManifests?: Maybe<ManifestConnection>;
  searchOrderPriorities?: Maybe<OrderPriorityConnection>;
  searchServices?: Maybe<ServiceConnection>;
  searchSites?: Maybe<SiteConnection>;
  searchSkills?: Maybe<SkillConnection>;
  searchStops?: Maybe<StopConnection>;
  searchTenantPrefs?: Maybe<TenantPrefConnection>;
  searchUserPrefs?: Maybe<UserPrefConnection>;
  searchVehicleTypes?: Maybe<VehicleTypeConnection>;
};


export type QueryGeocodeAddressesArgs = {
  formattedAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGetBatchOptimizationResultArgs = {
  jobId: Scalars['String'];
};


export type QueryGetCustomerArgs = {
  id: Scalars['Int'];
};


export type QueryGetDispatchGroupArgs = {
  id: Scalars['String'];
};


export type QueryGetDispatchStationGroupArgs = {
  id: Scalars['String'];
};


export type QueryGetDistinctValuesArgs = {
  field: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  typename: Scalars['String'];
};


export type QueryGetDriverArgs = {
  id: Scalars['String'];
};


export type QueryGetDriverTotalManifestsArgs = {
  driverId: Scalars['Int'];
};


export type QueryGetEtaArgs = {
  includeLastSent?: InputMaybe<Scalars['Boolean']>;
  manifestDriverIds: Array<Scalars['Int']>;
};


export type QueryGetEventTypeArgs = {
  eventTypeId: Scalars['Int'];
};


export type QueryGetFeeTitleArgs = {
  id: Scalars['Int'];
};


export type QueryGetLateStopArgs = {
  lateStopId: Scalars['Int'];
};


export type QueryGetOrderPriorityArgs = {
  id: Scalars['String'];
};


export type QueryGetRoutePlanningResultArgs = {
  input: GetRoutePlanningResultInput;
};


export type QueryGetRouteWithEtasArgs = {
  dwellTimeSeconds?: InputMaybe<Scalars['Int']>;
  routePoints: Array<RouteWithEtasPoint>;
  service?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['String']>;
};


export type QueryGetServiceArgs = {
  id: Scalars['Int'];
};


export type QueryGetSiteArgs = {
  siteId: Scalars['Int'];
};


export type QueryGetSkillArgs = {
  id: Scalars['Int'];
};


export type QueryGetSuggestAssignmentResultArgs = {
  input: GetSuggestAssignmentResultInput;
};


export type QueryGetTenantPrefArgs = {
  name: Scalars['String'];
};


export type QueryGetUserPrefArgs = {
  name: Scalars['String'];
};


export type QueryGetVehicleTypeArgs = {
  id: Scalars['String'];
};


export type QueryOptimizeRoutesArgs = {
  routeOptimizationRequestOptions?: InputMaybe<Array<RouteOptimizationRequestOption>>;
  routeOptimizationRequests: Array<RouteOptimizationRequest>;
};


export type QueryRouteArgs = {
  routingRequest: RoutingRequest;
};


export type QuerySearchCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSort>>>;
};


export type QuerySearchDispatchGroupsArgs = {
  filter?: InputMaybe<ModelDispatchGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDispatchGroupSortInput>>>;
};


export type QuerySearchDispatchStationGroupsArgs = {
  filter?: InputMaybe<ModelDispatchStationGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDispatchStationSortInput>>>;
};


export type QuerySearchDriverLocationsArgs = {
  filter?: InputMaybe<ModelDriverLocationFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverLocationsSortInput>>>;
};


export type QuerySearchDriversArgs = {
  filter?: InputMaybe<ModelDriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverSortInput>>>;
};


export type QuerySearchDriversEnhancedArgs = {
  filter?: InputMaybe<DriverFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverSortInput>>>;
};


export type QuerySearchEtaNotificationConfigsArgs = {
  filter?: InputMaybe<EtaNotificationConfigsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QuerySearchEventTypesArgs = {
  filter?: InputMaybe<EventTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<EventTypeSortInput>>;
};


export type QuerySearchFeeTitlesArgs = {
  filter?: InputMaybe<FeeTitleFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<FeeTitleSortInput>>;
};


export type QuerySearchIndicatorConfigsArgs = {
  filter?: InputMaybe<IndicatorConfigsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QuerySearchJobsArgs = {
  filter?: InputMaybe<JobFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<JobSortInput>>>;
};


export type QuerySearchLateStopsArgs = {
  filter?: InputMaybe<LateStopFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<LateStopSortInput>>;
};


export type QuerySearchManifestsArgs = {
  filter?: InputMaybe<ManifestFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ManifestSortInput>>>;
};


export type QuerySearchOrderPrioritiesArgs = {
  filter?: InputMaybe<ModelOrderPriorityFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableOrderPrioritySortInput>>>;
};


export type QuerySearchServicesArgs = {
  filter?: InputMaybe<ServiceFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ServiceSort>>>;
};


export type QuerySearchSitesArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SiteSortInput>>;
};


export type QuerySearchSkillsArgs = {
  filter?: InputMaybe<SkillFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SkillSortInput>>;
};


export type QuerySearchStopsArgs = {
  filter?: InputMaybe<SearchStopFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<StopSortInput>>>;
};


export type QuerySearchVehicleTypesArgs = {
  filter?: InputMaybe<ModelVehicleTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableVehicleTypeSortInput>>>;
};

export type QueryStringFilter = {
  fields: Array<Scalars['String']>;
  query: Scalars['String'];
};

export type RecordRoutePlanningUsageInput = {
  responseId: Scalars['String'];
};

export type ResequenceManifestUpdate = {
  __typename?: 'ResequenceManifestUpdate';
  manifestDriverId?: Maybe<Scalars['Int']>;
  submissionResult?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type RouteDifference = {
  __typename?: 'RouteDifference';
  distanceDifference: Scalars['Float'];
  timeDifference: Scalars['Int'];
};

export type RouteLine = {
  __typename?: 'RouteLine';
  coordinates?: Maybe<Array<Array<Scalars['Float']>>>;
  encodedLine?: Maybe<Scalars['String']>;
  lineType: LineType;
};

export type RouteOptimizationActivity = {
  __typename?: 'RouteOptimizationActivity';
  address?: Maybe<RouteOptimizationResponseAddress>;
  arr_date_time?: Maybe<Scalars['String']>;
  arr_time?: Maybe<Scalars['Long']>;
  distance?: Maybe<Scalars['Int']>;
  driving_time?: Maybe<Scalars['Int']>;
  end_date_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  load_after?: Maybe<Array<Scalars['Int']>>;
  load_before?: Maybe<Array<Scalars['Int']>>;
  location_id?: Maybe<Scalars['String']>;
  preparation_time?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  waiting_time?: Maybe<Scalars['Int']>;
};

export type RouteOptimizationAddress = {
  lat: Scalars['Float'];
  location_id: Scalars['String'];
  lon: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  street_hint?: Maybe<Scalars['String']>;
};

export type RouteOptimizationConnection = {
  __typename?: 'RouteOptimizationConnection';
  items: Array<RouteOptimizationResultItem>;
};

export enum RouteOptimizationCurbsideStrictness {
  Ignore = 'ignore',
  Soft = 'soft',
  Strict = 'strict'
}

export enum RouteOptimizationDataProvider {
  Openstreetmap = 'openstreetmap',
  Tomtom = 'tomtom'
}

export type RouteOptimizationExcludedStop = {
  __typename?: 'RouteOptimizationExcludedStop';
  jobStopId: Scalars['Int'];
  reason: RouteOptimizationStopExclusionReason;
};

export type RouteOptimizationRequest = {
  dwellTime: Scalars['Int'];
  endLocation?: InputMaybe<Scalars['String']>;
  endLocationCoords?: InputMaybe<GeoCoordinateInput>;
  manifestDriverId: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
  startingDateTime: Scalars['AWSDateTime'];
  startingLocation?: InputMaybe<Scalars['String']>;
  startingLocationCoords?: InputMaybe<GeoCoordinateInput>;
};

export type RouteOptimizationRequestOption = {
  enabled: Scalars['Boolean'];
  requestOption: RouteOptimizationRequestOptionType;
};

export enum RouteOptimizationRequestOptionType {
  BatchMode = 'batchMode',
  EncodeOriginalRoutePoints = 'encodeOriginalRoutePoints',
  IgnoreTimeWindows = 'ignoreTimeWindows',
  IncludeOriginalRouteDetail = 'includeOriginalRouteDetail',
  IncludeOriginalRouteSummary = 'includeOriginalRouteSummary'
}

export type RouteOptimizationRequestValidationErrorDetail = {
  __typename?: 'RouteOptimizationRequestValidationErrorDetail';
  details?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  serviceId?: Maybe<Scalars['String']>;
};

export type RouteOptimizationRequestValidationErrors = {
  __typename?: 'RouteOptimizationRequestValidationErrors';
  hints?: Maybe<Array<RouteOptimizationRequestValidationErrorDetail>>;
  message?: Maybe<Scalars['String']>;
};

export type RouteOptimizationResponse = {
  __typename?: 'RouteOptimizationResponse';
  cached?: Maybe<Scalars['Boolean']>;
  copyrights?: Maybe<Scalars['String']>;
  job_id?: Maybe<Scalars['String']>;
  processing_time?: Maybe<Scalars['Int']>;
  rateLimitCredits?: Maybe<Scalars['Int']>;
  solution?: Maybe<RouteOptimizationSolution>;
  status?: Maybe<Scalars['String']>;
  waiting_time_in_queue?: Maybe<Scalars['Int']>;
};

export type RouteOptimizationResponseAddress = RouteOptimizationAddress & {
  __typename?: 'RouteOptimizationResponseAddress';
  lat: Scalars['Float'];
  location_id: Scalars['String'];
  lon: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  snapped_waypoint?: Maybe<RouteOptimizationSnappedWaypoint>;
  street_hint?: Maybe<Scalars['String']>;
};

export type RouteOptimizationResultItem = {
  __typename?: 'RouteOptimizationResultItem';
  excludedStops?: Maybe<Array<RouteOptimizationExcludedStop>>;
  manifestDriverId: Scalars['Int'];
  optimizationEtas?: Maybe<Array<EtaItem>>;
  originalRoute?: Maybe<RoutingResult>;
  routeDifference?: Maybe<RouteDifference>;
  solution?: Maybe<RouteOptimizationResponse>;
  valid?: Maybe<Scalars['Boolean']>;
  validationErrors?: Maybe<RouteOptimizationRequestValidationErrors>;
};

export type RouteOptimizationRoute = {
  __typename?: 'RouteOptimizationRoute';
  activities?: Maybe<Array<RouteOptimizationActivity>>;
  completion_time?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Int']>;
  points: Array<RouteOptimizationRoutePoint>;
  preparation_time?: Maybe<Scalars['Int']>;
  service_duration?: Maybe<Scalars['Int']>;
  transport_time?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['String']>;
  waiting_time?: Maybe<Scalars['Int']>;
};

export type RouteOptimizationRouteItem = {
  allowed_vehicles: Array<Scalars['String']>;
  disallowed_vehicles: Array<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  max_time_in_vehicle: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  preparation_time?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  required_skills: Array<Scalars['String']>;
  size?: Maybe<Array<Scalars['Int']>>;
  time_windows: Array<RouteOptimizationTimeWindow>;
};

export type RouteOptimizationRoutePoint = {
  __typename?: 'RouteOptimizationRoutePoint';
  coordinates: Array<Array<Scalars['Float']>>;
  type?: Maybe<Scalars['String']>;
};

export type RouteOptimizationRouting = {
  __typename?: 'RouteOptimizationRouting';
  calc_points: Scalars['Boolean'];
  consider_traffic: Scalars['Boolean'];
  curbside_strictness: RouteOptimizationCurbsideStrictness;
  fail_fast: Scalars['Boolean'];
  network_data_provider?: Maybe<RouteOptimizationDataProvider>;
  return_snapped_waypoints: Scalars['Boolean'];
  snap_preventions: Array<Scalars['String']>;
};

export type RouteOptimizationRoutingConfiguration = {
  __typename?: 'RouteOptimizationRoutingConfiguration';
  routing?: Maybe<RouteOptimizationRouting>;
};

export type RouteOptimizationService = RouteOptimizationRouteItem & {
  __typename?: 'RouteOptimizationService';
  address?: Maybe<RouteOptimizationAddress>;
  allowed_vehicles: Array<Scalars['String']>;
  disallowed_vehicles: Array<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  max_time_in_vehicle: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  preparation_time?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  required_skills: Array<Scalars['String']>;
  size?: Maybe<Array<Scalars['Int']>>;
  time_windows: Array<RouteOptimizationTimeWindow>;
  type?: Maybe<RouteOptimizationServiceType>;
};

export enum RouteOptimizationServiceType {
  Delivery = 'delivery',
  Pickup = 'pickup',
  Service = 'service'
}

export type RouteOptimizationShipment = RouteOptimizationRouteItem & {
  __typename?: 'RouteOptimizationShipment';
  allowed_vehicles: Array<Scalars['String']>;
  delivery: RouteOptimizationStop;
  disallowed_vehicles: Array<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  max_time_in_vehicle: Array<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pickup: RouteOptimizationStop;
  preparation_time?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  required_skills: Array<Scalars['String']>;
  size?: Maybe<Array<Scalars['Int']>>;
  time_windows: Array<RouteOptimizationTimeWindow>;
};

export type RouteOptimizationSnappedWaypoint = {
  __typename?: 'RouteOptimizationSnappedWaypoint';
  lat: Scalars['Float'];
  lon: Scalars['Float'];
};

export type RouteOptimizationSolution = {
  __typename?: 'RouteOptimizationSolution';
  completion_time?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Int']>;
  max_operation_time?: Maybe<Scalars['Int']>;
  no_unassigned?: Maybe<Scalars['Int']>;
  no_vehicles?: Maybe<Scalars['Int']>;
  preparation_time?: Maybe<Scalars['Int']>;
  routes?: Maybe<Array<RouteOptimizationRoute>>;
  service_duration?: Maybe<Scalars['Int']>;
  transport_time?: Maybe<Scalars['Int']>;
  unassigned?: Maybe<RouteOptimizationUnassignedToRoute>;
  waiting_time?: Maybe<Scalars['Int']>;
};

export type RouteOptimizationStop = {
  __typename?: 'RouteOptimizationStop';
  address: RouteOptimizationAddress;
  duration?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  preparation_time?: Maybe<Scalars['Int']>;
  time_windows: Array<RouteOptimizationTimeWindow>;
};

export enum RouteOptimizationStopExclusionReason {
  CompleteOrInactive = 'COMPLETE_OR_INACTIVE'
}

export type RouteOptimizationTimeWindow = {
  __typename?: 'RouteOptimizationTimeWindow';
  earliest?: Maybe<Scalars['Int']>;
  latest?: Maybe<Scalars['Int']>;
};

export type RouteOptimizationUnassignedDetail = {
  __typename?: 'RouteOptimizationUnassignedDetail';
  code?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type RouteOptimizationUnassignedToRoute = {
  __typename?: 'RouteOptimizationUnassignedToRoute';
  breaks: Array<Scalars['String']>;
  details: Array<RouteOptimizationUnassignedDetail>;
  services: Array<Scalars['String']>;
  shipments: Array<Scalars['String']>;
};

export type RouteOptimizationVehicle = {
  __typename?: 'RouteOptimizationVehicle';
  break?: Maybe<Scalars['Boolean']>;
  earliest_start?: Maybe<Scalars['Int']>;
  end_address?: Maybe<RouteOptimizationAddress>;
  latest_end?: Maybe<Scalars['Int']>;
  max_jobs?: Maybe<Scalars['Int']>;
  min_jobs?: Maybe<Scalars['Int']>;
  return_to_depot?: Maybe<Scalars['Boolean']>;
  start_address?: Maybe<RouteOptimizationAddress>;
  type_id?: Maybe<Scalars['String']>;
  vehicle_id: Scalars['String'];
};

export type RouteOptimizationVehicleType = {
  __typename?: 'RouteOptimizationVehicleType';
  capacity: Array<Maybe<Scalars['Int']>>;
  consider_traffic?: Maybe<Scalars['Boolean']>;
  network_data_provider?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  service_time_factor?: Maybe<Scalars['Float']>;
  speed_factor?: Maybe<Scalars['Float']>;
  type_id: Scalars['String'];
};

export type RoutePlanningActivity = {
  __typename?: 'RoutePlanningActivity';
  address?: Maybe<RoutePlanningAddress>;
  arr_date_time?: Maybe<Scalars['String']>;
  arr_time?: Maybe<Scalars['Long']>;
  distance?: Maybe<Scalars['Int']>;
  driving_time?: Maybe<Scalars['Int']>;
  end_date_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  load_after?: Maybe<Array<Scalars['Int']>>;
  load_before?: Maybe<Array<Scalars['Int']>>;
  location_id?: Maybe<Scalars['String']>;
  preparation_time?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  waiting_time?: Maybe<Scalars['Int']>;
};

export type RoutePlanningAddress = {
  __typename?: 'RoutePlanningAddress';
  lat?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type RoutePlanningBeforeTotals = {
  __typename?: 'RoutePlanningBeforeTotals';
  totalDeliveryStops?: Maybe<Scalars['Int']>;
  totalMiles?: Maybe<Scalars['Float']>;
  totalPickupStops?: Maybe<Scalars['Int']>;
  totalRoutes?: Maybe<Scalars['Int']>;
  totalTransitSeconds?: Maybe<Scalars['Int']>;
};

export type RoutePlanningDriverInput = {
  driverId: Scalars['Int'];
  endAddress?: InputMaybe<Scalars['String']>;
  endAddressPosition?: InputMaybe<GeoPosition>;
  manifestDriverId?: InputMaybe<Scalars['Int']>;
  maxDrivingTime?: InputMaybe<Scalars['Int']>;
  skillsIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startAddress?: InputMaybe<Scalars['String']>;
  startAddressPosition?: InputMaybe<GeoPosition>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type RoutePlanningMetricsInput = {
  processingTime?: InputMaybe<Scalars['Int']>;
  routesCount?: InputMaybe<Scalars['Int']>;
  waitingTimeInQueue?: InputMaybe<Scalars['Int']>;
  wasModified?: InputMaybe<Scalars['Boolean']>;
};

export type RoutePlanningRoute = {
  __typename?: 'RoutePlanningRoute';
  activities?: Maybe<Array<RoutePlanningActivity>>;
  completion_time?: Maybe<Scalars['Long']>;
  distance?: Maybe<Scalars['Int']>;
  points?: Maybe<Array<RoutePlanningRoutePoint>>;
  preparation_time?: Maybe<Scalars['Long']>;
  service_duration?: Maybe<Scalars['Long']>;
  shift_id?: Maybe<Scalars['String']>;
  transport_time?: Maybe<Scalars['Long']>;
  vehicle_id?: Maybe<Scalars['String']>;
  waiting_time?: Maybe<Scalars['Long']>;
};

export type RoutePlanningRouteEtas = {
  __typename?: 'RoutePlanningRouteEtas';
  endDateTime?: Maybe<Scalars['String']>;
  etas?: Maybe<Array<EtaItem>>;
  startDateTime?: Maybe<Scalars['String']>;
  vehicleId: Scalars['String'];
};

export type RoutePlanningRoutePoint = {
  __typename?: 'RoutePlanningRoutePoint';
  coordinates?: Maybe<Array<Array<Scalars['Float']>>>;
  type?: Maybe<Scalars['String']>;
};

export type RoutePlanningSolution = {
  __typename?: 'RoutePlanningSolution';
  completion_time?: Maybe<Scalars['Long']>;
  costs?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['Int']>;
  max_operation_time?: Maybe<Scalars['Long']>;
  no_unassigned?: Maybe<Scalars['Int']>;
  no_vehicles?: Maybe<Scalars['Int']>;
  preparation_time?: Maybe<Scalars['Long']>;
  routes?: Maybe<Array<RoutePlanningRoute>>;
  service_duration?: Maybe<Scalars['Long']>;
  time?: Maybe<Scalars['Long']>;
  transport_time?: Maybe<Scalars['Long']>;
  unassigned?: Maybe<RoutePlanningUnassigned>;
  waiting_time?: Maybe<Scalars['Long']>;
};

export type RoutePlanningUnassigned = {
  __typename?: 'RoutePlanningUnassigned';
  breaks?: Maybe<Array<Scalars['String']>>;
  details?: Maybe<Array<RoutePlanningUnassignedDetail>>;
  services?: Maybe<Array<Scalars['String']>>;
  shipments?: Maybe<Array<Scalars['String']>>;
};

export type RoutePlanningUnassignedDetail = {
  __typename?: 'RoutePlanningUnassignedDetail';
  code?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type RoutePlanningUsage = {
  __typename?: 'RoutePlanningUsage';
  isUnlimited: Scalars['Boolean'];
  limit: Scalars['Int'];
  resetDate: Scalars['AWSDateTime'];
  used: Scalars['Int'];
};

export type RouteWithEtasPoint = {
  coordinates: Array<Scalars['Float']>;
  earlyDateTime?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  scheduledDateTime?: InputMaybe<Scalars['String']>;
  stopType?: InputMaybe<Scalars['String']>;
};

export type RoutingConnection = {
  __typename?: 'RoutingConnection';
  result: RoutingResult;
};

export type RoutingInstruction = {
  __typename?: 'RoutingInstruction';
  distance?: Maybe<Scalars['Float']>;
  exitNumber?: Maybe<Scalars['Int']>;
  interval: Array<Scalars['Int']>;
  sign?: Maybe<Scalars['Int']>;
  streetName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  time?: Maybe<Scalars['Long']>;
  turnAngle?: Maybe<Scalars['Float']>;
};

export type RoutingRequest = {
  calcPoints?: InputMaybe<Scalars['Boolean']>;
  elevation?: InputMaybe<Scalars['Boolean']>;
  instructions?: InputMaybe<Scalars['Boolean']>;
  optimize?: InputMaybe<Scalars['Boolean']>;
  points: Array<Array<Scalars['Float']>>;
  pointsEncoded?: InputMaybe<Scalars['Boolean']>;
  profile?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type RoutingResponseInfo = {
  __typename?: 'RoutingResponseInfo';
  copyrights: Array<Scalars['String']>;
  took: Scalars['Int'];
};

export type RoutingResult = {
  __typename?: 'RoutingResult';
  cached?: Maybe<Scalars['Boolean']>;
  info?: Maybe<RoutingResponseInfo>;
  paths: Array<RoutingResultPath>;
  rateLimitCredits?: Maybe<Scalars['Int']>;
};

export type RoutingResultDetail = {
  __typename?: 'RoutingResultDetail';
  pointRange: Array<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type RoutingResultDetailEntry = {
  __typename?: 'RoutingResultDetailEntry';
  key: Scalars['String'];
  value: RoutingResultDetail;
};

export type RoutingResultPath = {
  __typename?: 'RoutingResultPath';
  ascend: Scalars['Float'];
  boundaryBox: Array<Scalars['Float']>;
  descend: Scalars['Float'];
  details: Array<RoutingResultDetailEntry>;
  distance: Scalars['Float'];
  instructions: Array<RoutingInstruction>;
  points?: Maybe<RouteLine>;
  pointsEncoded: Scalars['Boolean'];
  pointsOrder: Array<Scalars['Long']>;
  snappedWaypoints?: Maybe<RouteLine>;
  time: Scalars['Long'];
};

export type SaveClearJobStop = {
  adjustLateMinutes?: InputMaybe<Scalars['Int']>;
  adjustScheduledMinutes?: InputMaybe<Scalars['Int']>;
  arriveDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  arriveDateTimeSource?: InputMaybe<Scalars['String']>;
  departDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  departDateTimeSource?: InputMaybe<Scalars['String']>;
  eventNote?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<Scalars['String']>;
  jobStopId: Scalars['Int'];
  jobStopStatus?: InputMaybe<Scalars['String']>;
  nextJobStopStatus?: InputMaybe<Scalars['String']>;
  pieces?: InputMaybe<Scalars['Int']>;
  podDateTime?: InputMaybe<Scalars['AWSDateTime']>;
  podName?: InputMaybe<Scalars['String']>;
  podSign?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type SearchStopFilter = {
  multiMatch?: InputMaybe<MultiMatchFilter>;
  queryString?: InputMaybe<QueryStringFilter>;
  stop?: InputMaybe<StopFilter>;
};

export type SearchableDispatchGroupSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableDispatchGroupSortableFields>;
};

export enum SearchableDispatchGroupSortableFields {
  AutoCloseManifest = 'autoCloseManifest',
  Description = 'description',
  DispatchGroup = 'dispatchGroup',
  DispatchGroupId = 'dispatchGroupId',
  DispatchType = 'dispatchType',
  SiteId = 'siteId'
}

export enum SearchableDispatchStationGroupSortableFields {
  Description = 'description',
  DispatchGroupId = 'dispatchGroupId',
  DispatchStation = 'dispatchStation',
  DispatchType = 'dispatchType'
}

export type SearchableDispatchStationSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableDispatchStationGroupSortableFields>;
};

export type SearchableDriverLocationsSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableDriverLocationsSortableFields>;
};

export enum SearchableDriverLocationsSortableFields {
  Accuracy = 'accuracy',
  Altitude = 'altitude',
  AuxData = 'auxData',
  Coordinates = 'coordinates',
  DriverId = 'driverId',
  FixDateTime = 'fixDateTime',
  Heading = 'heading',
  IndexDateTime = 'indexDateTime',
  ReceiveDateTime = 'receiveDateTime',
  Velocity = 'velocity'
}

export type SearchableDriverSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableDriverSortableFields>;
};

export enum SearchableDriverSortableFields {
  AutoAccept = 'autoAccept',
  AutoSend = 'autoSend',
  DriverAlias = 'driverAlias',
  DriverCode = 'driverCode',
  DriverId = 'driverId',
  DriverStatus = 'driverStatus',
  Name = 'name',
  SiteId = 'siteId',
  StartZip = 'startZip',
  StartZone = 'startZone',
  VehicleTypeId = 'vehicleTypeId'
}

export type SearchableOrderPrioritySortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableOrderPrioritySortableFields>;
};

export enum SearchableOrderPrioritySortableFields {
  Description = 'description',
  DispatchJobColor = 'dispatchJobColor',
  OrderPriorityId = 'orderPriorityId',
  SiteId = 'siteId'
}

export enum SearchableSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SearchableVehicleTypeSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableVehicleTypeSortableFields>;
};

export enum SearchableVehicleTypeSortableFields {
  CostPerMile = 'costPerMile',
  Description = 'description',
  DispatchJobColor = 'dispatchJobColor',
  DwellTime = 'dwellTime',
  IconPath = 'iconPath',
  LaborCostPerHo = 'laborCostPerHo',
  MaxCube = 'maxCube',
  MaxPieces = 'maxPieces',
  MaxWeight = 'maxWeight',
  Message = 'message',
  Rank = 'rank',
  ShowOnWeb = 'showOnWeb',
  SortSequence = 'sortSequence',
  VehicleTypeId = 'vehicleTypeId'
}

export type Service = {
  __typename?: 'Service';
  abbrService?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  serviceId: Scalars['Int'];
  siteId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type ServiceConnection = {
  __typename?: 'ServiceConnection';
  items?: Maybe<Array<Service>>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type ServiceFilter = {
  abbrService?: InputMaybe<KeywordFilterInput>;
  and?: InputMaybe<Array<ServiceFilter>>;
  description?: InputMaybe<KeywordFilterInput>;
  not?: InputMaybe<Array<ServiceFilter>>;
  or?: InputMaybe<Array<ServiceFilter>>;
  service?: InputMaybe<KeywordFilterInput>;
  serviceId?: InputMaybe<ModelIntFilterInput>;
  siteId?: InputMaybe<ModelIntFilterInput>;
  status?: InputMaybe<KeywordFilterInput>;
};

export type ServiceSort = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: ServiceSortableField;
};

export enum ServiceSortableField {
  AbbrService = 'abbrService',
  Description = 'description',
  Service = 'service',
  ServiceId = 'serviceId',
  SiteId = 'siteId',
  Status = 'status'
}

export type SetEtaNotificationConfigInput = {
  config: Scalars['AWSJSON'];
  siteId: Scalars['Int'];
};

export type SetIndicatorConfigInput = {
  config: Scalars['AWSJSON'];
  siteId: Scalars['Int'];
};

export type SetTenantPrefInput = {
  value?: InputMaybe<Scalars['AWSJSON']>;
};

export type SetUserPrefInput = {
  value?: InputMaybe<Scalars['AWSJSON']>;
};

export type Site = {
  __typename?: 'Site';
  code?: Maybe<Scalars['String']>;
  siteId: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  items?: Maybe<Array<Site>>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type SiteFilterInput = {
  and?: InputMaybe<Array<SiteFilterInput>>;
  code?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<Array<SiteFilterInput>>;
  or?: InputMaybe<Array<SiteFilterInput>>;
  siteId?: InputMaybe<ModelIntFilterInput>;
  status?: InputMaybe<TextFilterInput>;
};

export type SiteSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: SiteSortableField;
};

export enum SiteSortableField {
  Code = 'code',
  Status = 'status'
}

export type Skill = {
  __typename?: 'Skill';
  id: Scalars['Int'];
  name: Scalars['String'];
  skillDescription?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type SkillConnection = {
  __typename?: 'SkillConnection';
  items: Array<Skill>;
  nextToken?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type SkillFilterInput = {
  and?: InputMaybe<Array<SkillFilterInput>>;
  id?: InputMaybe<ModelIntFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<Array<SkillFilterInput>>;
  or?: InputMaybe<Array<SkillFilterInput>>;
  skillDescription?: InputMaybe<TextFilterInput>;
  status?: InputMaybe<ModelIntFilterInput>;
};

export type SkillOverrideNoteInput = {
  note: Scalars['String'];
  orderId: Scalars['Int'];
};

export type SkillSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field: SkillSortableField;
};

export enum SkillSortableField {
  Id = 'id',
  Name = 'name',
  SkillDescription = 'skillDescription',
  Status = 'status'
}

export enum SnoozeIndicatorEntityType {
  Job = 'JOB',
  Manifest = 'MANIFEST'
}

export type Stop = {
  __typename?: 'Stop';
  address?: Maybe<Scalars['String']>;
  arriveDateTime?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  departDateTime?: Maybe<Scalars['String']>;
  dispatchZone?: Maybe<Scalars['String']>;
  driver?: Maybe<NestedDriver>;
  dst?: Maybe<Scalars['Boolean']>;
  earlyDateTime?: Maybe<Scalars['String']>;
  indicatorColor?: Maybe<Scalars['String']>;
  indicatorExpiry?: Maybe<Scalars['AWSDateTime']>;
  /**   DP-2999 scaffold — populated by the colorized-indicators worker per-stop. */
  indicatorRank?: Maybe<Scalars['Int']>;
  indicatorSnoozeUntil?: Maybe<Scalars['AWSDateTime']>;
  job?: Maybe<NestedStopJob>;
  jobStopId: Scalars['Int'];
  jobStopStatus?: Maybe<Scalars['String']>;
  lateDateTime?: Maybe<Scalars['String']>;
  manifest?: Maybe<NestedStopManifest>;
  manifestSequence?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  order?: Maybe<NestedStopOrder>;
  phone?: Maybe<Scalars['String']>;
  podDateTime?: Maybe<Scalars['String']>;
  podName?: Maybe<Scalars['String']>;
  podRequired?: Maybe<Scalars['Boolean']>;
  room?: Maybe<Scalars['String']>;
  scheduledDateTime?: Maybe<Scalars['String']>;
  see?: Maybe<Scalars['String']>;
  sequence: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  stopType?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  timeZone?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type StopConnection = {
  __typename?: 'StopConnection';
  items: Array<Stop>;
  nextToken?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type StopFilter = {
  address?: InputMaybe<TextFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StopFilter>>>;
  arriveDateTime?: InputMaybe<DateTimeFilterInput>;
  avsQuality?: InputMaybe<ModelIntFilterInput>;
  city?: InputMaybe<TextFilterInput>;
  departDateTime?: InputMaybe<DateTimeFilterInput>;
  dispatchZone?: InputMaybe<KeywordFilterInput>;
  driver_driverCode?: InputMaybe<KeywordFilterInput>;
  driver_driverId?: InputMaybe<ModelIntFilterInput>;
  driver_name?: InputMaybe<KeywordFilterInput>;
  dst?: InputMaybe<ModelBooleanFilterInput>;
  earlyDateTime?: InputMaybe<ModelStringFilterInput>;
  indicatorColor?: InputMaybe<KeywordFilterInput>;
  indicatorExpiry?: InputMaybe<DateTimeFilterInput>;
  /**   DP-2999 scaffold — filter/sort by backend-computed indicator fields (per-stop). */
  indicatorRank?: InputMaybe<ModelIntFilterInput>;
  jobStopId?: InputMaybe<ModelIntFilterInput>;
  jobStopStatus?: InputMaybe<KeywordFilterInput>;
  job_alias?: InputMaybe<TextFilterInput>;
  job_jobId?: InputMaybe<ModelIntFilterInput>;
  job_jobNumber?: InputMaybe<KeywordFilterInput>;
  job_jobStatus?: InputMaybe<KeywordFilterInput>;
  job_pieces?: InputMaybe<ModelFloatFilterInput>;
  job_routeNumber?: InputMaybe<KeywordFilterInput>;
  job_service?: InputMaybe<KeywordFilterInput>;
  job_site_code?: InputMaybe<KeywordFilterInput>;
  job_site_siteId?: InputMaybe<ModelIntFilterInput>;
  job_weight?: InputMaybe<ModelFloatFilterInput>;
  lateDateTime?: InputMaybe<ModelStringFilterInput>;
  manifestSequence?: InputMaybe<ModelIntFilterInput>;
  manifest_dispatchGroupId?: InputMaybe<ModelIntFilterInput>;
  manifest_manifestDriverId?: InputMaybe<ModelIntFilterInput>;
  manifest_manifestStatus?: InputMaybe<KeywordFilterInput>;
  name?: InputMaybe<TextFilterInput>;
  not?: InputMaybe<StopFilter>;
  note?: InputMaybe<TextFilterInput>;
  offset?: InputMaybe<ModelIntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<StopFilter>>>;
  order_alias?: InputMaybe<TextFilterInput>;
  order_auth?: InputMaybe<TextFilterInput>;
  order_caller?: InputMaybe<TextFilterInput>;
  order_callerPhone?: InputMaybe<KeywordFilterInput>;
  order_codAmount?: InputMaybe<ModelFloatFilterInput>;
  order_createDate?: InputMaybe<DateTimeFilterInput>;
  order_customer_customerCode?: InputMaybe<TextFilterInput>;
  order_customer_customerId?: InputMaybe<ModelIntFilterInput>;
  order_customer_name?: InputMaybe<TextFilterInput>;
  order_customer_notes?: InputMaybe<TextFilterInput>;
  order_declaredValue?: InputMaybe<ModelFloatFilterInput>;
  order_description?: InputMaybe<TextFilterInput>;
  order_notes?: InputMaybe<TextFilterInput>;
  order_orderDate?: InputMaybe<DateTimeFilterInput>;
  order_orderId?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_id?: InputMaybe<ModelIntFilterInput>;
  order_orderSkills_name?: InputMaybe<TextFilterInput>;
  order_priority_description?: InputMaybe<TextFilterInput>;
  order_priority_orderPriorityId?: InputMaybe<ModelIntFilterInput>;
  order_service?: InputMaybe<KeywordFilterInput>;
  order_user_userName?: InputMaybe<TextFilterInput>;
  phone?: InputMaybe<KeywordFilterInput>;
  podDateTime?: InputMaybe<DateTimeFilterInput>;
  podName?: InputMaybe<KeywordFilterInput>;
  podRequired?: InputMaybe<ModelBooleanFilterInput>;
  room?: InputMaybe<TextFilterInput>;
  scheduledDateTime?: InputMaybe<ModelStringFilterInput>;
  see?: InputMaybe<TextFilterInput>;
  sequence?: InputMaybe<ModelIntFilterInput>;
  state?: InputMaybe<KeywordFilterInput>;
  stopType?: InputMaybe<KeywordFilterInput>;
  timeZone?: InputMaybe<KeywordFilterInput>;
  vehicleType_description?: InputMaybe<TextFilterInput>;
  vehicleType_vehicleTypeId?: InputMaybe<ModelIntFilterInput>;
  zip?: InputMaybe<KeywordFilterInput>;
};

export type StopSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<Scalars['String']>;
  nestedFilter?: InputMaybe<StopFilter>;
};

export enum StopTextFields {
  Address = 'address',
  City = 'city',
  DispatchZone = 'dispatchZone',
  DriverName = 'driver_name',
  JobStopStatus = 'jobStopStatus',
  JobAlias = 'job_alias',
  JobJobNumber = 'job_jobNumber',
  JobRouteNumber = 'job_routeNumber',
  JobService = 'job_service',
  JobSiteCode = 'job_site_code',
  Name = 'name',
  Note = 'note',
  OrderAlias = 'order_alias',
  OrderAuth = 'order_auth',
  OrderCaller = 'order_caller',
  OrderCustomerCustomerCode = 'order_customer_customerCode',
  OrderCustomerName = 'order_customer_name',
  OrderCustomerNotes = 'order_customer_notes',
  OrderNotes = 'order_notes',
  OrderPriorityDescription = 'order_priority_description',
  OrderUserUserName = 'order_user_userName',
  PodName = 'podName',
  Room = 'room',
  See = 'see',
  StopType = 'stopType'
}

export type SubmitRoutePlanningInput = {
  allowMovingExistingWork?: InputMaybe<Scalars['Boolean']>;
  considerSkills?: InputMaybe<Scalars['Boolean']>;
  drivers: Array<InputMaybe<RoutePlanningDriverInput>>;
  dwellTimeSeconds?: InputMaybe<Scalars['Int']>;
  ignoreTimeWindows?: InputMaybe<Scalars['Boolean']>;
  jobIds: Array<Scalars['Int']>;
  objective?: InputMaybe<Scalars['String']>;
  startAnyTime?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type SubmitRoutePlanningResponse = {
  __typename?: 'SubmitRoutePlanningResponse';
  errorsJson?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  requestBodyJson?: Maybe<Scalars['String']>;
  responseId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  usageCount?: Maybe<Scalars['Int']>;
  usageLimit?: Maybe<Scalars['Int']>;
};

export type SubmitSuggestAssignmentInput = {
  jobId: Scalars['Int'];
  manifestFilter?: InputMaybe<ManifestFilter>;
};

export type SubmitSuggestAssignmentResponse = {
  __typename?: 'SubmitSuggestAssignmentResponse';
  /**
   *   Generic message: VALIDATION_FAILED on COMPLETE, the system error on
   *  FAILED, null on PENDING. Nothing is ever persisted for a validation
   *  failure — this response is the only place it's surfaced, so
   *  getSuggestAssignmentResult(requestId) would report Not Found.
   */
  error?: Maybe<Scalars['String']>;
  /**
   *   Per-stop/job-level detail when status is COMPLETE (validation failure);
   *  empty otherwise.
   */
  errors: Array<SuggestAssignmentValidationError>;
  requestId: Scalars['String'];
  status: SuggestAssignmentStatus;
  /**   DP-3194: daily usage cap info, populated on every submit response. */
  usageCount?: Maybe<Scalars['Int']>;
  usageLimit?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onDataChanged?: Maybe<DataChangedEvent>;
  onDispatchUpdate?: Maybe<DispatchUpdate>;
  onJobAssignmentUpdate?: Maybe<JobAssignmentUpdate>;
  onResequenceManifestUpdate?: Maybe<ResequenceManifestUpdate>;
};


export type SubscriptionOnDataChangedArgs = {
  entityId?: InputMaybe<Scalars['String']>;
  entityType: DataChangeEntityType;
};

export type SuggestAssignmentResult = {
  __typename?: 'SuggestAssignmentResult';
  candidates: Array<AssignmentCandidate>;
  credits: Scalars['Int'];
  evaluatedCount: Scalars['Int'];
  feasible: Scalars['Boolean'];
  ghProcessedTime: Scalars['Int'];
  processedTime: Scalars['Int'];
};

export enum SuggestAssignmentStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/**   DP-3194: daily usage cap info returned by getSuggestAssignmentUsage. */
export type SuggestAssignmentUsage = {
  __typename?: 'SuggestAssignmentUsage';
  limit: Scalars['Int'];
  resetDate: Scalars['String'];
  used: Scalars['Int'];
};

/**
 *   jobStopId is 0 for a job-level failure (no single stop is at fault — e.g.
 *  the job is already assigned, or has an unsupported multi-shipment shape).
 *  value is the offending value formatted for display; null for a "missing"
 *  failure (there is nothing to show).
 */
export type SuggestAssignmentValidationError = {
  __typename?: 'SuggestAssignmentValidationError';
  field: Scalars['String'];
  jobStopId: Scalars['Int'];
  reason: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type TenantPref = Pref & {
  __typename?: 'TenantPref';
  lastUpdated?: Maybe<Scalars['AWSDateTime']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['AWSJSON']>;
};

export type TenantPrefConnection = {
  __typename?: 'TenantPrefConnection';
  items: Array<Maybe<TenantPref>>;
};

export type TextFilterInput = {
  caseInsensitive?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['String']>;
  matchPhrase?: InputMaybe<Scalars['String']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']>;
  multiMatch?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['String']>;
};

export type UserPref = Pref & {
  __typename?: 'UserPref';
  lastUpdated?: Maybe<Scalars['AWSDateTime']>;
  name: Scalars['String'];
  value?: Maybe<Scalars['AWSJSON']>;
};

export type UserPrefConnection = {
  __typename?: 'UserPrefConnection';
  items: Array<Maybe<UserPref>>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  TYPE?: Maybe<Scalars['String']>;
  costPerMile?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  dispatchJobColor?: Maybe<Scalars['Int']>;
  dwellTime?: Maybe<Scalars['Int']>;
  iconPath?: Maybe<Scalars['String']>;
  laborCostPerHo?: Maybe<Scalars['Float']>;
  maxCube?: Maybe<Scalars['Int']>;
  maxPieces?: Maybe<Scalars['Int']>;
  maxWeight?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  pk: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
  showOnWeb?: Maybe<Scalars['Int']>;
  sk: Scalars['String'];
  sortSequence?: Maybe<Scalars['String']>;
  vehicleTypeId: Scalars['Int'];
};

export type VehicleTypeConnection = {
  __typename?: 'VehicleTypeConnection';
  items?: Maybe<Array<Maybe<VehicleType>>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type AssignJobsToManifestMutationVariables = Exact<{
  manifestDriverId: Scalars['Int'];
  jobIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>> | InputMaybe<SkillOverrideNoteInput>>;
}>;


export type AssignJobsToManifestMutation = { __typename?: 'Mutation', assignJobsToManifest?: string | null };

export type UnassignJobStopsFromManifestMutationVariables = Exact<{
  jobStopIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  manifestDriverId: Scalars['Int'];
}>;


export type UnassignJobStopsFromManifestMutation = { __typename?: 'Mutation', unassignJobStopsFromManifest?: string | null };

export type CloseManifestMutationVariables = Exact<{
  manifestDriverId: Scalars['Int'];
  endMileage?: InputMaybe<Scalars['String']>;
  startMileage?: InputMaybe<Scalars['String']>;
}>;


export type CloseManifestMutation = { __typename?: 'Mutation', closeManifest?: string | null };

export type SaveManifestDriverEventsMutationVariables = Exact<{
  events?: InputMaybe<Array<ManifestDriverEventInput> | ManifestDriverEventInput>;
  manifestDriverId: Scalars['Int'];
}>;


export type SaveManifestDriverEventsMutation = { __typename?: 'Mutation', saveManifestDriverEvents?: string | null };

export type ClearManifestDriverEventsMutationVariables = Exact<{
  manifestDriverEventTypeId?: InputMaybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
}>;


export type ClearManifestDriverEventsMutation = { __typename?: 'Mutation', clearManifestDriverEvents?: string | null };

export type CreateManifestMutationVariables = Exact<{
  driverId: Scalars['Int'];
  dispatchGroupId?: InputMaybe<Scalars['Int']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']>;
  startZone?: InputMaybe<Scalars['String']>;
  startZip?: InputMaybe<Scalars['String']>;
  endZip?: InputMaybe<Scalars['String']>;
  autoSend?: InputMaybe<Scalars['Boolean']>;
  autoAccept?: InputMaybe<Scalars['Boolean']>;
  manifestDate?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  manifestDriverStatus?: InputMaybe<Scalars['String']>;
}>;


export type CreateManifestMutation = { __typename?: 'Mutation', createManifest?: string | null };

export type UpdateManifestMutationVariables = Exact<{
  autoAccept?: InputMaybe<Scalars['Boolean']>;
  autoSend?: InputMaybe<Scalars['Boolean']>;
  dispatchGroupId?: InputMaybe<Scalars['Int']>;
  endZip?: InputMaybe<Scalars['String']>;
  endZone?: InputMaybe<Scalars['String']>;
  manifestDate?: InputMaybe<Scalars['String']>;
  manifestDriverId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  startZip?: InputMaybe<Scalars['String']>;
  startZone?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']>;
  manifestDriverStatus?: InputMaybe<Scalars['String']>;
}>;


export type UpdateManifestMutation = { __typename?: 'Mutation', updateManifest?: string | null };

export type SetUserPrefMutationVariables = Exact<{
  name: Scalars['String'];
  input: SetUserPrefInput;
}>;


export type SetUserPrefMutation = { __typename?: 'Mutation', setUserPref?: { __typename?: 'UserPref', name: string, value?: any | null } | null };

export type SetTenantPrefMutationVariables = Exact<{
  name: Scalars['String'];
  input: SetTenantPrefInput;
}>;


export type SetTenantPrefMutation = { __typename?: 'Mutation', setTenantPref?: { __typename?: 'TenantPref', name: string, value?: any | null } | null };

export type ResequenceManifestStopsMutationVariables = Exact<{
  manifestDriverId: Scalars['Int'];
  jobStopManifestSequences: Array<InputMaybe<JobStopManifestSequence>> | InputMaybe<JobStopManifestSequence>;
  isOptimized?: InputMaybe<Scalars['Boolean']>;
  etaSourcesDirty?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  optimizationEtas?: InputMaybe<Array<EtaItemInput> | EtaItemInput>;
}>;


export type ResequenceManifestStopsMutation = { __typename?: 'Mutation', resequenceManifestStops?: string | null };

export type SaveClearJobStopsMutationVariables = Exact<{
  saveClearJobStops: Array<InputMaybe<SaveClearJobStop>> | InputMaybe<SaveClearJobStop>;
}>;


export type SaveClearJobStopsMutation = { __typename?: 'Mutation', saveClearJobStops?: string | null };

export type EnableDataChangedEventsMutationVariables = Exact<{
  entityType: DataChangeEntityType;
  entityId?: InputMaybe<Scalars['String']>;
  ttl?: InputMaybe<Scalars['Int']>;
}>;


export type EnableDataChangedEventsMutation = { __typename?: 'Mutation', enableDataChangedEvents?: string | null };

export type SetIndicatorConfigMutationVariables = Exact<{
  input: SetIndicatorConfigInput;
  sk?: InputMaybe<Scalars['ID']>;
}>;


export type SetIndicatorConfigMutation = { __typename?: 'Mutation', setIndicatorConfig?: { __typename?: 'IndicatorConfig', config: any, siteId: number, sk: string } | null };

export type ReassignJobStopsMutationVariables = Exact<{
  manifestDriverId: Scalars['Int'];
  fromManifestDriverId: Scalars['Int'];
  jobStopIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  keepManifestSequence?: InputMaybe<Scalars['Boolean']>;
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>> | InputMaybe<SkillOverrideNoteInput>>;
}>;


export type ReassignJobStopsMutation = { __typename?: 'Mutation', reassignJobStops?: string | null };

export type SubmitRoutePlanningMutationVariables = Exact<{
  input: SubmitRoutePlanningInput;
}>;


export type SubmitRoutePlanningMutation = { __typename?: 'Mutation', submitRoutePlanning?: { __typename?: 'SubmitRoutePlanningResponse', responseId?: string | null, requestBodyJson?: string | null, status: string, message: string, errorsJson?: string | null } | null };

export type ProcessRoutePlanningMutationVariables = Exact<{
  input: ProcessRoutePlanningInput;
}>;


export type ProcessRoutePlanningMutation = { __typename?: 'Mutation', processRoutePlanning?: { __typename?: 'ProcessRoutePlanningResponse', status: string, message: string } | null };

export type SetEtaNotificationConfigMutationVariables = Exact<{
  input: SetEtaNotificationConfigInput;
  sk?: InputMaybe<Scalars['ID']>;
}>;


export type SetEtaNotificationConfigMutation = { __typename?: 'Mutation', setEtaNotificationConfig?: { __typename?: 'EtaNotificationConfig', sk: string, siteId: number, config: any } | null };

export type DeleteEtaNotificationConfigMutationVariables = Exact<{
  sk: Scalars['ID'];
}>;


export type DeleteEtaNotificationConfigMutation = { __typename?: 'Mutation', deleteEtaNotificationConfig?: { __typename?: 'EtaNotificationConfig', sk: string, siteId: number, config: any } | null };

export type AddOrderNoteMutationVariables = Exact<{
  orderId: Scalars['Int'];
  note: Scalars['String'];
}>;


export type AddOrderNoteMutation = { __typename?: 'Mutation', addOrderNote?: string | null };

export type SplitJobMutationVariables = Exact<{
  driverId: Scalars['Int'];
  jobId: Scalars['Int'];
  splitPercentage: Scalars['String'];
}>;


export type SplitJobMutation = { __typename?: 'Mutation', splitJob?: string | null };

export type RecordRoutePlanningUsageMutationVariables = Exact<{
  input: RecordRoutePlanningUsageInput;
}>;


export type RecordRoutePlanningUsageMutation = { __typename?: 'Mutation', recordRoutePlanningUsage?: { __typename?: 'RoutePlanningUsage', used: number, limit: number, isUnlimited: boolean, resetDate: any } | null };

export type SubmitSuggestAssignmentMutationVariables = Exact<{
  input: SubmitSuggestAssignmentInput;
}>;


export type SubmitSuggestAssignmentMutation = { __typename?: 'Mutation', submitSuggestAssignment?: { __typename?: 'SubmitSuggestAssignmentResponse', requestId: string, status: SuggestAssignmentStatus, error?: string | null, usageCount?: number | null, usageLimit?: number | null, errors: Array<{ __typename?: 'SuggestAssignmentValidationError', jobStopId: number, field: string, reason: string, value?: string | null }> } | null };

export type CancelSuggestAssignmentMutationVariables = Exact<{
  input: CancelSuggestAssignmentInput;
}>;


export type CancelSuggestAssignmentMutation = { __typename?: 'Mutation', cancelSuggestAssignment?: boolean | null };

export type SuggestAssignJobMutationVariables = Exact<{
  manifestDriverId: Scalars['Int'];
  jobIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  sequences: Array<Scalars['Int']> | Scalars['Int'];
  optimizationEtas: Array<EtaItemInput> | EtaItemInput;
  skillOverrideNotes?: InputMaybe<Array<InputMaybe<SkillOverrideNoteInput>> | InputMaybe<SkillOverrideNoteInput>>;
}>;


export type SuggestAssignJobMutation = { __typename?: 'Mutation', suggestAssignJob?: string | null };

export type GetDistinctValuesQueryVariables = Exact<{
  field: Scalars['String'];
  typeName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDistinctValuesQuery = { __typename?: 'Query', getDistinctValues?: { __typename?: 'GetDistinctValuesConnection', items: Array<{ __typename?: 'Bucket', key?: string | null, doc_count?: number | null }> } | null };

export type GetUserPrefQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetUserPrefQuery = { __typename?: 'Query', getUserPref?: { __typename?: 'UserPref', name: string, value?: any | null } | null };

export type SearchUserPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchUserPrefsQuery = { __typename?: 'Query', searchUserPrefs?: { __typename?: 'UserPrefConnection', items: Array<{ __typename?: 'UserPref', name: string, value?: any | null } | null> } | null };

export type GetTenantPrefQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetTenantPrefQuery = { __typename?: 'Query', getTenantPref?: { __typename?: 'TenantPref', name: string, value?: any | null } | null };

export type SearchTenantPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchTenantPrefsQuery = { __typename?: 'Query', searchTenantPrefs?: { __typename?: 'TenantPrefConnection', items: Array<{ __typename?: 'TenantPref', name: string, value?: any | null } | null> } | null };

export type SearchDispatchGroupsQueryVariables = Exact<{
  filter?: InputMaybe<ModelDispatchGroupFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDispatchGroupSortInput>> | InputMaybe<SearchableDispatchGroupSortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type SearchDispatchGroupsQuery = { __typename?: 'Query', searchDispatchGroups?: { __typename?: 'DispatchGroupConnection', items?: Array<{ __typename?: 'DispatchGroup', siteId?: number | null, description?: string | null, dispatchGroup?: string | null, dispatchGroupId?: number | null, dispatchType?: string | null } | null> | null } | null };

export type SearchDriverLocationQueryVariables = Exact<{
  filter?: InputMaybe<ModelDriverLocationFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverLocationsSortInput>> | InputMaybe<SearchableDriverLocationsSortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type SearchDriverLocationQuery = { __typename?: 'Query', searchDriverLocations?: { __typename?: 'DriverLocationConnection', nextToken?: string | null, total?: number | null, items?: Array<{ __typename?: 'DriverLocation', accuracy: number, altitude: number, auxData?: any | null, coordinates: string, driverId: number, fixDateTime: any, heading: number, indexDateTime: any, receiveDateTime: any, tenantId: string, velocity: number } | null> | null } | null };

export type SearchDriversQueryVariables = Exact<{
  filter?: InputMaybe<ModelDriverFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverSortInput>> | InputMaybe<SearchableDriverSortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type SearchDriversQuery = { __typename?: 'Query', searchDrivers?: { __typename?: 'DriverConnection', items?: Array<{ __typename?: 'Driver', autoAccept?: boolean | null, autoSend?: boolean | null, driverCode?: string | null, driverAlias?: string | null, driverId?: number | null, driverStatus?: string | null, name?: string | null, siteId?: number | null, startZip?: string | null, startZone?: string | null, endZip?: string | null, endZone?: string | null, dispatchGroupId?: number | null, vehicleTypeId?: number | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null> | null } | null };

export type SearchDriversEnhancedQueryVariables = Exact<{
  filter?: InputMaybe<DriverFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDriverSortInput>> | InputMaybe<SearchableDriverSortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchDriversEnhancedQuery = { __typename?: 'Query', searchDriversEnhanced?: { __typename?: 'DriverConnection', total?: number | null, items?: Array<{ __typename?: 'Driver', autoAccept?: boolean | null, autoSend?: boolean | null, driverCode?: string | null, driverAlias?: string | null, driverId?: number | null, driverStatus?: string | null, name?: string | null, siteId?: number | null, startZip?: string | null, startZone?: string | null, endZip?: string | null, endZone?: string | null, dispatchGroupId?: number | null, vehicleTypeId?: number | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, phone?: string | null, skills?: string | null } | null> | null } | null };

export type Map_SearchJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobFilter>;
  sort?: InputMaybe<Array<InputMaybe<JobSortInput>> | InputMaybe<JobSortInput>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type Map_SearchJobsQuery = { __typename?: 'Query', searchJobs?: { __typename?: 'JobConnection', items: Array<{ __typename?: 'Job', jobId: number, jobNumber: string, service?: string | null, jobStatus: string, indicatorRank?: number | null, indicatorColor?: string | null, indicatorExpiry?: any | null, indicatorSnoozeUntil?: any | null, order: { __typename?: 'NestedOrder', orderId: number, customer?: { __typename?: 'NestedCustomer', name?: string | null } | null, requirements?: Array<{ __typename?: 'OrderRequirement', id: number, code?: string | null, name?: string | null }> | null }, vehicleType?: { __typename?: 'NestedVehicleType', description?: string | null } | null, stops: Array<{ __typename?: 'NestedJobStop', name?: string | null, jobStopId: number, sequence: number, stopType?: string | null, dispatchZone?: string | null, scheduledDateTime?: string | null, earlyDateTime?: string | null, lateDateTime?: string | null, arriveDateTime?: string | null, departDateTime?: string | null, podDateTime?: string | null, jobStopStatus?: string | null, timeZone?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null }> }> } | null };

export type Map_SearchManifestsQueryVariables = Exact<{
  filter?: InputMaybe<ManifestFilter>;
  sort?: InputMaybe<Array<InputMaybe<ManifestSortInput>> | InputMaybe<ManifestSortInput>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type Map_SearchManifestsQuery = { __typename?: 'Query', searchManifests?: { __typename?: 'ManifestConnection', items: Array<{ __typename?: 'Manifest', manifestDriverId: number, manifestStatus: string, vehicleType: { __typename?: 'NestedVehicleType', description?: string | null }, driver: { __typename?: 'ManifestDriver', driverId: number, code?: string | null, name?: string | null }, stops?: Array<{ __typename?: 'ManifestStop', name?: string | null, jobStopId: number, manifestSequence: number, stopType: string, timeZone?: string | null, scheduledDateTime?: string | null, earlyDateTime?: string | null, lateDateTime?: string | null, arriveDateTime?: string | null, dispatchZone?: string | null, departDateTime?: string | null, podDateTime?: string | null, jobStopStatus?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, indicatorRank?: number | null, indicatorColor?: string | null, indicatorExpiry?: any | null, indicatorSnoozeUntil?: any | null, job: { __typename?: 'ManifestStopJob', jobNumber: string, jobId: number }, order: { __typename?: 'ManifestStopOrder', orderId: number, service?: string | null, customer: { __typename?: 'ManifestStopOrderCustomer', customerId: number, name?: string | null } } }> | null }> } | null };

export type SearchManifestDetailsQueryVariables = Exact<{
  filter?: InputMaybe<ManifestFilter>;
  sort?: InputMaybe<Array<InputMaybe<ManifestSortInput>> | InputMaybe<ManifestSortInput>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchManifestDetailsQuery = { __typename?: 'Query', searchManifests?: { __typename?: 'ManifestConnection', nextToken?: number | null, total: number, items: Array<{ __typename?: 'Manifest', lastZone?: string | null, endZip?: string | null, totalPieces?: number | null, manifestDriverId: number, manifestDate?: string | null, manifestStatus: string, autoCloseManifest?: number | null, optimizedDateTime?: any | null, optimizedBy?: string | null, startMileage?: number | null, endMileage?: number | null, stopCount?: number | null, events?: Array<{ __typename?: 'ManifestDriverEvent', eventId: number, eventTypeId: number, startDateTime?: string | null } | null> | null, vehicleType: { __typename?: 'NestedVehicleType', vehicleTypeId: number, description?: string | null }, dispatchGroup?: { __typename?: 'NestedDispatchGroup', dispatchGroupId: number, name: string, description?: string | null } | null, driver: { __typename?: 'ManifestDriver', driverId: number, code?: string | null, name?: string | null, phone?: string | null, alias?: string | null, note?: string | null, skills?: Array<{ __typename?: 'Skill', id: number, name: string, skillDescription?: string | null, status: number }> | null, qualifications?: Array<{ __typename?: 'DriverQualification', id: number, code?: string | null, name?: string | null }> | null, dispatchGroup?: { __typename?: 'NestedDispatchGroup', dispatchGroupId: number, name: string } | null }, stops?: Array<{ __typename?: 'ManifestStop', jobStopId: number, sequence?: number | null, name?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, timeZone?: string | null, manifestSequence: number, scheduledDateTime?: string | null, earlyDateTime?: string | null, dispatchZone?: string | null, lateDateTime?: string | null, arriveDateTime?: string | null, departDateTime?: string | null, podName?: string | null, podDateTime?: string | null, podRequired?: boolean | null, stopType: string, jobStopStatus?: string | null, see?: string | null, phone?: string | null, note?: string | null, room?: string | null, indicatorRank?: number | null, indicatorColor?: string | null, indicatorExpiry?: any | null, indicatorSnoozeUntil?: any | null, job: { __typename?: 'ManifestStopJob', jobId: number, jobNumber: string, alias?: string | null, pieces?: number | null, weight?: number | null, routeNumber?: string | null, driverId?: number | null, driverId2?: number | null, splitPercentage?: string | null, site?: { __typename?: 'Site', code?: string | null, siteId: number } | null }, order: { __typename?: 'ManifestStopOrder', alias?: string | null, auth?: string | null, caller?: string | null, callerPhone?: string | null, description?: string | null, declaredValue?: number | null, orderId: number, codAmount?: number | null, codStatus?: string | null, otherReference?: string | null, invoiceReference?: string | null, podRequired?: boolean | null, service?: string | null, tabPieces?: number | null, createDate?: any | null, notes?: string | null, customer: { __typename?: 'ManifestStopOrderCustomer', customerId: number, customerCode?: string | null, name?: string | null, notes?: string | null, alias?: string | null, group?: string | null }, priority?: { __typename?: 'ManifestStopOrderPriority', orderPriorityId: number, description?: string | null } | null, orderSkills?: Array<{ __typename?: 'Skill', id: number, name: string }> | null, requirements?: Array<{ __typename?: 'OrderRequirement', id: number, code?: string | null, name?: string | null }> | null, user?: { __typename?: 'NestedUser', userId?: number | null, userName?: string | null } | null } }> | null, metadata?: { __typename?: 'EntityMetadata', alerts?: Array<{ __typename?: 'EntityMetadataAlert', level: string, message: string }> | null } | null }> } | null };

export type GeoCodeAddressesQueryVariables = Exact<{
  formattedAddresses: Array<Scalars['String']> | Scalars['String'];
}>;


export type GeoCodeAddressesQuery = { __typename?: 'Query', geocodeAddresses?: { __typename?: 'GeocodeAddressConnection', items?: Array<{ __typename?: 'GeocodeResult', lat: number, lon: number, formattedAddress?: string | null, locationType?: string | null, status: GeocodeResultStatus } | null> | null } | null };

export type SearchVehicleTypesQueryVariables = Exact<{
  filter?: InputMaybe<ModelVehicleTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableVehicleTypeSortInput>> | InputMaybe<SearchableVehicleTypeSortInput>>;
}>;


export type SearchVehicleTypesQuery = { __typename?: 'Query', searchVehicleTypes?: { __typename?: 'VehicleTypeConnection', items?: Array<{ __typename?: 'VehicleType', vehicleTypeId: number, description?: string | null, sortSequence?: string | null, rank?: number | null } | null> | null } | null };

export type SearchIndicatorConfigsQueryVariables = Exact<{
  filter?: InputMaybe<IndicatorConfigsFilter>;
}>;


export type SearchIndicatorConfigsQuery = { __typename?: 'Query', searchIndicatorConfigs?: { __typename?: 'IndicatorConfigsConnection', items?: Array<{ __typename?: 'IndicatorConfig', config: any, siteId: number, sk: string }> | null } | null };

export type SearchCustomersQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSort>> | InputMaybe<CustomerSort>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchCustomersQuery = { __typename?: 'Query', searchCustomers?: { __typename?: 'CustomerConnection', items?: Array<{ __typename?: 'Customer', customerCode?: string | null, customerId: number, customerGroup?: string | null, name?: string | null, siteId?: number | null }> | null } | null };

export type SearchServicesQueryVariables = Exact<{
  filter?: InputMaybe<ServiceFilter>;
  sort?: InputMaybe<Array<InputMaybe<ServiceSort>> | InputMaybe<ServiceSort>>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchServicesQuery = { __typename?: 'Query', searchServices?: { __typename?: 'ServiceConnection', items?: Array<{ __typename?: 'Service', serviceId: number, service?: string | null, description?: string | null, siteId?: number | null }> | null } | null };

export type SearchEventTypesQueryVariables = Exact<{
  filter?: InputMaybe<EventTypeFilterInput>;
  sort?: InputMaybe<Array<EventTypeSortInput> | EventTypeSortInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchEventTypesQuery = { __typename?: 'Query', searchEventTypes?: { __typename?: 'EventTypeConnection', items?: Array<{ __typename?: 'EventType', customerId?: number | null, description?: string | null, driverCreatable?: boolean | null, eBilling?: boolean | null, eventType?: string | null, eventTypeId: number, lateReason?: boolean | null, pieceStatusId?: number | null, showOnWeb?: boolean | null }> | null } | null };

export type SearchLateStopsQueryVariables = Exact<{
  filter?: InputMaybe<LateStopFilterInput>;
  sort?: InputMaybe<Array<LateStopSortInput> | LateStopSortInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchLateStopsQuery = { __typename?: 'Query', searchLateStops?: { __typename?: 'LateStopConnection', items?: Array<{ __typename?: 'LateStop', lateStopId: number, siteId?: number | null, customerId?: number | null, customerGroup?: string | null, sequence?: number | null, serviceId?: number | null, stopMinutes?: number | null, stopType?: string | null, timeType: number, triggerType: number }> | null } | null };

export type OptimizeRoutesQueryVariables = Exact<{
  routeOptimizationRequests: Array<RouteOptimizationRequest> | RouteOptimizationRequest;
  routeOptimizationRequestOptions?: InputMaybe<Array<RouteOptimizationRequestOption> | RouteOptimizationRequestOption>;
}>;


export type OptimizeRoutesQuery = { __typename?: 'Query', optimizeRoutes?: { __typename?: 'RouteOptimizationConnection', items: Array<{ __typename?: 'RouteOptimizationResultItem', manifestDriverId: number, valid?: boolean | null, routeDifference?: { __typename?: 'RouteDifference', distanceDifference: number, timeDifference: number } | null, originalRoute?: { __typename?: 'RoutingResult', info?: { __typename?: 'RoutingResponseInfo', copyrights: Array<string>, took: number } | null, paths: Array<{ __typename?: 'RoutingResultPath', points?: { __typename?: 'RouteLine', encodedLine?: string | null, lineType: LineType } | null }> } | null, solution?: { __typename?: 'RouteOptimizationResponse', cached?: boolean | null, job_id?: string | null, copyrights?: string | null, processing_time?: number | null, status?: string | null, waiting_time_in_queue?: number | null, rateLimitCredits?: number | null, solution?: { __typename?: 'RouteOptimizationSolution', distance?: number | null, transport_time?: number | null, max_operation_time?: number | null, waiting_time?: number | null, service_duration?: number | null, preparation_time?: number | null, completion_time?: number | null, no_vehicles?: number | null, no_unassigned?: number | null, routes?: Array<{ __typename?: 'RouteOptimizationRoute', vehicle_id?: string | null, distance?: number | null, transport_time?: number | null, completion_time?: number | null, waiting_time?: number | null, service_duration?: number | null, preparation_time?: number | null, activities?: Array<{ __typename?: 'RouteOptimizationActivity', type?: string | null, id?: string | null, location_id?: string | null, arr_time?: any | null, arr_date_time?: string | null, end_time?: any | null, end_date_time?: string | null, waiting_time?: number | null, preparation_time?: number | null, distance?: number | null, driving_time?: number | null, load_before?: Array<number> | null, load_after?: Array<number> | null, address?: { __typename?: 'RouteOptimizationResponseAddress', location_id: string, name?: string | null, lon: number, lat: number } | null }> | null, points: Array<{ __typename?: 'RouteOptimizationRoutePoint', type?: string | null, coordinates: Array<Array<number>> }> }> | null, unassigned?: { __typename?: 'RouteOptimizationUnassignedToRoute', services: Array<string>, shipments: Array<string>, breaks: Array<string>, details: Array<{ __typename?: 'RouteOptimizationUnassignedDetail', id?: string | null, code?: number | null, reason?: string | null }> } | null } | null } | null, validationErrors?: { __typename?: 'RouteOptimizationRequestValidationErrors', message?: string | null, hints?: Array<{ __typename?: 'RouteOptimizationRequestValidationErrorDetail', details?: string | null, message: string, serviceId?: string | null }> | null } | null, optimizationEtas?: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, generatedDateTime?: string | null, etaSource?: string | null }> | null }> } | null };

export type GetBatchOptimizationResultQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetBatchOptimizationResultQuery = { __typename?: 'Query', getBatchOptimizationResult?: { __typename?: 'RouteOptimizationConnection', items: Array<{ __typename?: 'RouteOptimizationResultItem', manifestDriverId: number, valid?: boolean | null, routeDifference?: { __typename?: 'RouteDifference', distanceDifference: number, timeDifference: number } | null, originalRoute?: { __typename?: 'RoutingResult', info?: { __typename?: 'RoutingResponseInfo', copyrights: Array<string>, took: number } | null, paths: Array<{ __typename?: 'RoutingResultPath', points?: { __typename?: 'RouteLine', encodedLine?: string | null, lineType: LineType } | null }> } | null, solution?: { __typename?: 'RouteOptimizationResponse', cached?: boolean | null, job_id?: string | null, copyrights?: string | null, processing_time?: number | null, status?: string | null, waiting_time_in_queue?: number | null, rateLimitCredits?: number | null, solution?: { __typename?: 'RouteOptimizationSolution', distance?: number | null, transport_time?: number | null, max_operation_time?: number | null, waiting_time?: number | null, service_duration?: number | null, preparation_time?: number | null, completion_time?: number | null, no_vehicles?: number | null, no_unassigned?: number | null, routes?: Array<{ __typename?: 'RouteOptimizationRoute', vehicle_id?: string | null, distance?: number | null, transport_time?: number | null, completion_time?: number | null, waiting_time?: number | null, service_duration?: number | null, preparation_time?: number | null, activities?: Array<{ __typename?: 'RouteOptimizationActivity', type?: string | null, id?: string | null, location_id?: string | null, arr_time?: any | null, arr_date_time?: string | null, end_time?: any | null, end_date_time?: string | null, waiting_time?: number | null, preparation_time?: number | null, distance?: number | null, driving_time?: number | null, load_before?: Array<number> | null, load_after?: Array<number> | null, address?: { __typename?: 'RouteOptimizationResponseAddress', location_id: string, name?: string | null, lon: number, lat: number } | null }> | null, points: Array<{ __typename?: 'RouteOptimizationRoutePoint', type?: string | null, coordinates: Array<Array<number>> }> }> | null, unassigned?: { __typename?: 'RouteOptimizationUnassignedToRoute', services: Array<string>, shipments: Array<string>, breaks: Array<string>, details: Array<{ __typename?: 'RouteOptimizationUnassignedDetail', id?: string | null, code?: number | null, reason?: string | null }> } | null } | null } | null, validationErrors?: { __typename?: 'RouteOptimizationRequestValidationErrors', message?: string | null, hints?: Array<{ __typename?: 'RouteOptimizationRequestValidationErrorDetail', details?: string | null, message: string, serviceId?: string | null }> | null } | null, optimizationEtas?: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, generatedDateTime?: string | null, etaSource?: string | null }> | null }> } | null };

export type SearchOrderPrioritiesQueryVariables = Exact<{
  filter?: InputMaybe<ModelOrderPriorityFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableOrderPrioritySortInput>> | InputMaybe<SearchableOrderPrioritySortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchOrderPrioritiesQuery = { __typename?: 'Query', searchOrderPriorities?: { __typename?: 'OrderPriorityConnection', items?: Array<{ __typename?: 'OrderPriority', orderPriorityId: number, description?: string | null, dispatchJobColor?: number | null, siteId?: string | null } | null> | null } | null };

export type SearchDispatchStationGroupsQueryVariables = Exact<{
  filter?: InputMaybe<ModelDispatchStationGroupFilterInput>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDispatchStationSortInput>> | InputMaybe<SearchableDispatchStationSortInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type SearchDispatchStationGroupsQuery = { __typename?: 'Query', searchDispatchStationGroups?: { __typename?: 'DispatchStationGroupConnection', items?: Array<{ __typename?: 'DispatchStationGroup', pk: string, sk: string, dispatchStation: string, description?: string | null, dispatchGroupId?: number | null, dispatchType?: string | null } | null> | null } | null };

export type SearchFeeTitlesQueryVariables = Exact<{
  filter?: InputMaybe<FeeTitleFilterInput>;
  sort?: InputMaybe<Array<FeeTitleSortInput> | FeeTitleSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchFeeTitlesQuery = { __typename?: 'Query', searchFeeTitles?: { __typename?: 'FeeTitleConnection', items?: Array<{ __typename?: 'FeeTitle', id: number, name?: string | null, code?: string | null }> | null } | null };

export type SearchSitesQueryVariables = Exact<{
  filter?: InputMaybe<SiteFilterInput>;
  sort?: InputMaybe<Array<SiteSortInput> | SiteSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchSitesQuery = { __typename?: 'Query', searchSites?: { __typename?: 'SiteConnection', items?: Array<{ __typename?: 'Site', siteId: number, code?: string | null }> | null } | null };

export type GetRouteQueryVariables = Exact<{
  routingRequest: RoutingRequest;
}>;


export type GetRouteQuery = { __typename?: 'Query', route?: { __typename?: 'RoutingConnection', result: { __typename?: 'RoutingResult', paths: Array<{ __typename?: 'RoutingResultPath', ascend: number, boundaryBox: Array<number>, descend: number, distance: number, pointsEncoded: boolean, pointsOrder: Array<any>, time: any, points?: { __typename?: 'RouteLine', lineType: LineType, coordinates?: Array<Array<number>> | null, encodedLine?: string | null } | null, snappedWaypoints?: { __typename: 'RouteLine', lineType: LineType, coordinates?: Array<Array<number>> | null, encodedLine?: string | null } | null }>, info?: { __typename?: 'RoutingResponseInfo', copyrights: Array<string>, took: number } | null } } | null };

export type GetRouteWithEtasQueryVariables = Exact<{
  routePoints: Array<RouteWithEtasPoint> | RouteWithEtasPoint;
  startDateTime?: InputMaybe<Scalars['String']>;
  dwellTimeSeconds?: InputMaybe<Scalars['Int']>;
  service?: InputMaybe<Scalars['String']>;
}>;


export type GetRouteWithEtasQuery = { __typename?: 'Query', getRouteWithEtas?: { __typename?: 'ETAConnection', message?: string | null, items: Array<{ __typename?: 'ETA', manifestDriverId?: number | null, message?: string | null, rateLimitCredits?: number | null, distance?: number | null, drivingTimeSeconds?: number | null, items: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, etaSource?: string | null, generatedDateTime?: string | null }>, polyline?: { __typename?: 'RouteLine', lineType: LineType, coordinates?: Array<Array<number>> | null, encodedLine?: string | null } | null }> } | null };

export type GetEtaQueryVariables = Exact<{
  manifestDriverIds: Array<Scalars['Int']> | Scalars['Int'];
  includeLastSent?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetEtaQuery = { __typename?: 'Query', getETA?: { __typename?: 'ETAConnection', message?: string | null, items: Array<{ __typename?: 'ETA', manifestDriverId?: number | null, message?: string | null, latestCompletedJobStopIds?: Array<number> | null, status?: string | null, completeTopmostStreak?: number | null, items: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, generatedDateTime?: string | null, etaSource?: string | null }>, lastSentItems?: Array<{ __typename?: 'NotificationSentData', jobStopId?: number | null, windowStart?: string | null, windowEnd?: string | null }> | null, optimizationEtas?: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, generatedDateTime?: string | null, etaSource?: string | null }> | null }> } | null };

export type GetDispatchStationRestrictionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDispatchStationRestrictionInfoQuery = { __typename?: 'Query', getDispatchStationRestrictionInfo?: { __typename?: 'DispatchStationRestrictionInfo', dispatchGridFlag?: number | null, dispatchStation?: string | null, subDispatchStations?: Array<string | null> | null } | null };

export type SearchSkillsQueryVariables = Exact<{
  filter?: InputMaybe<SkillFilterInput>;
  sort?: InputMaybe<Array<SkillSortInput> | SkillSortInput>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchSkillsQuery = { __typename?: 'Query', searchSkills?: { __typename?: 'SkillConnection', items: Array<{ __typename?: 'Skill', id: number, name: string, status: number }> } | null };

export type SearchEtaNotificationConfigsQueryVariables = Exact<{
  filter?: InputMaybe<EtaNotificationConfigsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type SearchEtaNotificationConfigsQuery = { __typename?: 'Query', searchEtaNotificationConfigs?: { __typename?: 'EtaNotificationConfigsConnection', nextToken?: string | null, items?: Array<{ __typename?: 'EtaNotificationConfig', sk: string, siteId: number, config: any }> | null } | null };

export type GetRoutePlanningResultQueryVariables = Exact<{
  input: GetRoutePlanningResultInput;
}>;


export type GetRoutePlanningResultQuery = { __typename?: 'Query', getRoutePlanningResult?: { __typename?: 'GetRoutePlanningResultResponse', copyrights?: Array<string> | null, job_id?: string | null, manifestDriverIds?: Array<number> | null, message?: string | null, processing_time?: number | null, status?: string | null, waiting_time_in_queue?: number | null, beforeTotals?: { __typename?: 'RoutePlanningBeforeTotals', totalDeliveryStops?: number | null, totalMiles?: number | null, totalPickupStops?: number | null, totalRoutes?: number | null, totalTransitSeconds?: number | null } | null, routeEtas?: Array<{ __typename?: 'RoutePlanningRouteEtas', vehicleId: string, startDateTime?: string | null, endDateTime?: string | null, etas?: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, etaSource?: string | null, generatedDateTime?: string | null }> | null }> | null, solution?: { __typename?: 'RoutePlanningSolution', costs?: number | null, distance?: number | null, time?: any | null, transport_time?: any | null, completion_time?: any | null, max_operation_time?: any | null, waiting_time?: any | null, service_duration?: any | null, preparation_time?: any | null, no_vehicles?: number | null, no_unassigned?: number | null, routes?: Array<{ __typename?: 'RoutePlanningRoute', vehicle_id?: string | null, shift_id?: string | null, distance?: number | null, transport_time?: any | null, completion_time?: any | null, waiting_time?: any | null, service_duration?: any | null, preparation_time?: any | null, activities?: Array<{ __typename?: 'RoutePlanningActivity', type?: string | null, id?: string | null, location_id?: string | null, arr_time?: any | null, arr_date_time?: string | null, end_time?: any | null, end_date_time?: string | null, waiting_time?: number | null, preparation_time?: number | null, distance?: number | null, driving_time?: number | null, load_before?: Array<number> | null, load_after?: Array<number> | null, address?: { __typename?: 'RoutePlanningAddress', location_id?: string | null, name?: string | null, lon?: number | null, lat?: number | null } | null }> | null, points?: Array<{ __typename?: 'RoutePlanningRoutePoint', type?: string | null, coordinates?: Array<Array<number>> | null }> | null }> | null, unassigned?: { __typename?: 'RoutePlanningUnassigned', services?: Array<string> | null, shipments?: Array<string> | null, breaks?: Array<string> | null, details?: Array<{ __typename?: 'RoutePlanningUnassignedDetail', id?: string | null, code?: number | null, reason?: string | null }> | null } | null } | null } | null };

export type GetDriverTotalManifestsQueryVariables = Exact<{
  driverId: Scalars['Int'];
}>;


export type GetDriverTotalManifestsQuery = { __typename?: 'Query', getDriverTotalManifests?: { __typename?: 'DriverTotalManifestsResponse', manifestCount: number } | null };

export type GetRoutePlanningUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoutePlanningUsageQuery = { __typename?: 'Query', getRoutePlanningUsage?: { __typename?: 'RoutePlanningUsage', used: number, limit: number, isUnlimited: boolean, resetDate: any } | null };

export type GetSuggestAssignmentUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuggestAssignmentUsageQuery = { __typename?: 'Query', getSuggestAssignmentUsage?: { __typename?: 'SuggestAssignmentUsage', used: number, limit: number, resetDate: string } | null };

export type GetSuggestAssignmentResultQueryVariables = Exact<{
  input: GetSuggestAssignmentResultInput;
}>;


export type GetSuggestAssignmentResultQuery = { __typename?: 'Query', getSuggestAssignmentResult?: { __typename?: 'GetSuggestAssignmentResultResponse', requestId: string, status: SuggestAssignmentStatus, error?: string | null, errors: Array<{ __typename?: 'SuggestAssignmentValidationError', jobStopId: number, field: string, reason: string, value?: string | null }>, result?: { __typename?: 'SuggestAssignmentResult', evaluatedCount: number, feasible: boolean, processedTime: number, ghProcessedTime: number, credits: number, candidates: Array<{ __typename?: 'AssignmentCandidate', manifestDriverId: number, driverId: number, driverName?: string | null, driverCode?: string | null, matchReason: string, incompleteStopCount: number, hasEta: boolean, additionalTime?: number | null, baselineDuration?: number | null, optimizedDuration?: number | null, baselineDistance?: number | null, optimizedDistance?: number | null, timeWindowBuffer?: number | null, suggestReasons?: Array<string> | null, optimizedSequences?: Array<{ __typename?: 'OptimizedStop', jobStopId: number, stopType: string, isNewJobStop: boolean }> | null, optimizedEtas: Array<{ __typename?: 'ETAItem', jobStopId?: number | null, eta?: string | null, etaSource?: string | null, generatedDateTime?: string | null }> }> } | null } | null };

export type OnJobAssignmentUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnJobAssignmentUpdateSubscription = { __typename?: 'Subscription', onJobAssignmentUpdate?: { __typename?: 'JobAssignmentUpdate', tenantId?: string | null, manifestDriverId?: number | null, jobIds?: Array<number | null> | null, jobStopIds?: Array<number | null> | null, submissionResult?: string | null, userName?: string | null } | null };

export type OnDispatchUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnDispatchUpdateSubscription = { __typename?: 'Subscription', onDispatchUpdate?: { __typename?: 'DispatchUpdate', data?: any | null, tenantId?: string | null } | null };

export type OnDataChangedSubscriptionVariables = Exact<{
  entityType: DataChangeEntityType;
  entityId?: InputMaybe<Scalars['String']>;
}>;


export type OnDataChangedSubscription = { __typename?: 'Subscription', onDataChanged?: { __typename?: 'DataChangedEvent', entityId?: string | null, entityType: DataChangeEntityType } | null };


export const AssignJobsToManifestDocument = gql`
    mutation AssignJobsToManifest($manifestDriverId: Int!, $jobIds: [Int]!, $skillOverrideNotes: [SkillOverrideNoteInput]) {
  assignJobsToManifest(
    manifestDriverId: $manifestDriverId
    jobIds: $jobIds
    skillOverrideNotes: $skillOverrideNotes
  )
}
    `;
export type AssignJobsToManifestMutationFn = Apollo.MutationFunction<AssignJobsToManifestMutation, AssignJobsToManifestMutationVariables>;

/**
 * __useAssignJobsToManifestMutation__
 *
 * To run a mutation, you first call `useAssignJobsToManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignJobsToManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignJobsToManifestMutation, { data, loading, error }] = useAssignJobsToManifestMutation({
 *   variables: {
 *      manifestDriverId: // value for 'manifestDriverId'
 *      jobIds: // value for 'jobIds'
 *      skillOverrideNotes: // value for 'skillOverrideNotes'
 *   },
 * });
 */
export function useAssignJobsToManifestMutation(baseOptions?: Apollo.MutationHookOptions<AssignJobsToManifestMutation, AssignJobsToManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignJobsToManifestMutation, AssignJobsToManifestMutationVariables>(AssignJobsToManifestDocument, options);
      }
export type AssignJobsToManifestMutationHookResult = ReturnType<typeof useAssignJobsToManifestMutation>;
export type AssignJobsToManifestMutationResult = Apollo.MutationResult<AssignJobsToManifestMutation>;
export type AssignJobsToManifestMutationOptions = Apollo.BaseMutationOptions<AssignJobsToManifestMutation, AssignJobsToManifestMutationVariables>;
export const UnassignJobStopsFromManifestDocument = gql`
    mutation UnassignJobStopsFromManifest($jobStopIds: [Int]!, $manifestDriverId: Int!) {
  unassignJobStopsFromManifest(
    jobStopIds: $jobStopIds
    manifestDriverId: $manifestDriverId
  )
}
    `;
export type UnassignJobStopsFromManifestMutationFn = Apollo.MutationFunction<UnassignJobStopsFromManifestMutation, UnassignJobStopsFromManifestMutationVariables>;

/**
 * __useUnassignJobStopsFromManifestMutation__
 *
 * To run a mutation, you first call `useUnassignJobStopsFromManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignJobStopsFromManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignJobStopsFromManifestMutation, { data, loading, error }] = useUnassignJobStopsFromManifestMutation({
 *   variables: {
 *      jobStopIds: // value for 'jobStopIds'
 *      manifestDriverId: // value for 'manifestDriverId'
 *   },
 * });
 */
export function useUnassignJobStopsFromManifestMutation(baseOptions?: Apollo.MutationHookOptions<UnassignJobStopsFromManifestMutation, UnassignJobStopsFromManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignJobStopsFromManifestMutation, UnassignJobStopsFromManifestMutationVariables>(UnassignJobStopsFromManifestDocument, options);
      }
export type UnassignJobStopsFromManifestMutationHookResult = ReturnType<typeof useUnassignJobStopsFromManifestMutation>;
export type UnassignJobStopsFromManifestMutationResult = Apollo.MutationResult<UnassignJobStopsFromManifestMutation>;
export type UnassignJobStopsFromManifestMutationOptions = Apollo.BaseMutationOptions<UnassignJobStopsFromManifestMutation, UnassignJobStopsFromManifestMutationVariables>;
export const CloseManifestDocument = gql`
    mutation CloseManifest($manifestDriverId: Int!, $endMileage: String, $startMileage: String) {
  closeManifest(
    manifestDriverId: $manifestDriverId
    endMileage: $endMileage
    startMileage: $startMileage
  )
}
    `;
export type CloseManifestMutationFn = Apollo.MutationFunction<CloseManifestMutation, CloseManifestMutationVariables>;

/**
 * __useCloseManifestMutation__
 *
 * To run a mutation, you first call `useCloseManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeManifestMutation, { data, loading, error }] = useCloseManifestMutation({
 *   variables: {
 *      manifestDriverId: // value for 'manifestDriverId'
 *      endMileage: // value for 'endMileage'
 *      startMileage: // value for 'startMileage'
 *   },
 * });
 */
export function useCloseManifestMutation(baseOptions?: Apollo.MutationHookOptions<CloseManifestMutation, CloseManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseManifestMutation, CloseManifestMutationVariables>(CloseManifestDocument, options);
      }
export type CloseManifestMutationHookResult = ReturnType<typeof useCloseManifestMutation>;
export type CloseManifestMutationResult = Apollo.MutationResult<CloseManifestMutation>;
export type CloseManifestMutationOptions = Apollo.BaseMutationOptions<CloseManifestMutation, CloseManifestMutationVariables>;
export const SaveManifestDriverEventsDocument = gql`
    mutation SaveManifestDriverEvents($events: [ManifestDriverEventInput!], $manifestDriverId: Int!) {
  saveManifestDriverEvents(events: $events, manifestDriverId: $manifestDriverId)
}
    `;
export type SaveManifestDriverEventsMutationFn = Apollo.MutationFunction<SaveManifestDriverEventsMutation, SaveManifestDriverEventsMutationVariables>;

/**
 * __useSaveManifestDriverEventsMutation__
 *
 * To run a mutation, you first call `useSaveManifestDriverEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManifestDriverEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManifestDriverEventsMutation, { data, loading, error }] = useSaveManifestDriverEventsMutation({
 *   variables: {
 *      events: // value for 'events'
 *      manifestDriverId: // value for 'manifestDriverId'
 *   },
 * });
 */
export function useSaveManifestDriverEventsMutation(baseOptions?: Apollo.MutationHookOptions<SaveManifestDriverEventsMutation, SaveManifestDriverEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveManifestDriverEventsMutation, SaveManifestDriverEventsMutationVariables>(SaveManifestDriverEventsDocument, options);
      }
export type SaveManifestDriverEventsMutationHookResult = ReturnType<typeof useSaveManifestDriverEventsMutation>;
export type SaveManifestDriverEventsMutationResult = Apollo.MutationResult<SaveManifestDriverEventsMutation>;
export type SaveManifestDriverEventsMutationOptions = Apollo.BaseMutationOptions<SaveManifestDriverEventsMutation, SaveManifestDriverEventsMutationVariables>;
export const ClearManifestDriverEventsDocument = gql`
    mutation ClearManifestDriverEvents($manifestDriverEventTypeId: String, $manifestDriverId: Int!) {
  clearManifestDriverEvents(
    manifestDriverEventTypeId: $manifestDriverEventTypeId
    manifestDriverId: $manifestDriverId
  )
}
    `;
export type ClearManifestDriverEventsMutationFn = Apollo.MutationFunction<ClearManifestDriverEventsMutation, ClearManifestDriverEventsMutationVariables>;

/**
 * __useClearManifestDriverEventsMutation__
 *
 * To run a mutation, you first call `useClearManifestDriverEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearManifestDriverEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearManifestDriverEventsMutation, { data, loading, error }] = useClearManifestDriverEventsMutation({
 *   variables: {
 *      manifestDriverEventTypeId: // value for 'manifestDriverEventTypeId'
 *      manifestDriverId: // value for 'manifestDriverId'
 *   },
 * });
 */
export function useClearManifestDriverEventsMutation(baseOptions?: Apollo.MutationHookOptions<ClearManifestDriverEventsMutation, ClearManifestDriverEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearManifestDriverEventsMutation, ClearManifestDriverEventsMutationVariables>(ClearManifestDriverEventsDocument, options);
      }
export type ClearManifestDriverEventsMutationHookResult = ReturnType<typeof useClearManifestDriverEventsMutation>;
export type ClearManifestDriverEventsMutationResult = Apollo.MutationResult<ClearManifestDriverEventsMutation>;
export type ClearManifestDriverEventsMutationOptions = Apollo.BaseMutationOptions<ClearManifestDriverEventsMutation, ClearManifestDriverEventsMutationVariables>;
export const CreateManifestDocument = gql`
    mutation CreateManifest($driverId: Int!, $dispatchGroupId: Int, $vehicleTypeId: Int, $startZone: String, $startZip: String, $endZip: String, $autoSend: Boolean, $autoAccept: Boolean, $manifestDate: String, $notes: String, $manifestDriverStatus: String) {
  createManifest(
    driverId: $driverId
    dispatchGroupId: $dispatchGroupId
    vehicleTypeId: $vehicleTypeId
    startZone: $startZone
    startZip: $startZip
    endZip: $endZip
    autoSend: $autoSend
    autoAccept: $autoAccept
    manifestDate: $manifestDate
    notes: $notes
    manifestDriverStatus: $manifestDriverStatus
  )
}
    `;
export type CreateManifestMutationFn = Apollo.MutationFunction<CreateManifestMutation, CreateManifestMutationVariables>;

/**
 * __useCreateManifestMutation__
 *
 * To run a mutation, you first call `useCreateManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManifestMutation, { data, loading, error }] = useCreateManifestMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      dispatchGroupId: // value for 'dispatchGroupId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      startZone: // value for 'startZone'
 *      startZip: // value for 'startZip'
 *      endZip: // value for 'endZip'
 *      autoSend: // value for 'autoSend'
 *      autoAccept: // value for 'autoAccept'
 *      manifestDate: // value for 'manifestDate'
 *      notes: // value for 'notes'
 *      manifestDriverStatus: // value for 'manifestDriverStatus'
 *   },
 * });
 */
export function useCreateManifestMutation(baseOptions?: Apollo.MutationHookOptions<CreateManifestMutation, CreateManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManifestMutation, CreateManifestMutationVariables>(CreateManifestDocument, options);
      }
export type CreateManifestMutationHookResult = ReturnType<typeof useCreateManifestMutation>;
export type CreateManifestMutationResult = Apollo.MutationResult<CreateManifestMutation>;
export type CreateManifestMutationOptions = Apollo.BaseMutationOptions<CreateManifestMutation, CreateManifestMutationVariables>;
export const UpdateManifestDocument = gql`
    mutation updateManifest($autoAccept: Boolean, $autoSend: Boolean, $dispatchGroupId: Int, $endZip: String, $endZone: String, $manifestDate: String, $manifestDriverId: Int!, $notes: String, $startZip: String, $startZone: String, $vehicleTypeId: Int, $manifestDriverStatus: String) {
  updateManifest(
    autoAccept: $autoAccept
    autoSend: $autoSend
    dispatchGroupId: $dispatchGroupId
    endZip: $endZip
    endZone: $endZone
    manifestDate: $manifestDate
    manifestDriverId: $manifestDriverId
    notes: $notes
    startZip: $startZip
    startZone: $startZone
    vehicleTypeId: $vehicleTypeId
    manifestDriverStatus: $manifestDriverStatus
  )
}
    `;
export type UpdateManifestMutationFn = Apollo.MutationFunction<UpdateManifestMutation, UpdateManifestMutationVariables>;

/**
 * __useUpdateManifestMutation__
 *
 * To run a mutation, you first call `useUpdateManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManifestMutation, { data, loading, error }] = useUpdateManifestMutation({
 *   variables: {
 *      autoAccept: // value for 'autoAccept'
 *      autoSend: // value for 'autoSend'
 *      dispatchGroupId: // value for 'dispatchGroupId'
 *      endZip: // value for 'endZip'
 *      endZone: // value for 'endZone'
 *      manifestDate: // value for 'manifestDate'
 *      manifestDriverId: // value for 'manifestDriverId'
 *      notes: // value for 'notes'
 *      startZip: // value for 'startZip'
 *      startZone: // value for 'startZone'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      manifestDriverStatus: // value for 'manifestDriverStatus'
 *   },
 * });
 */
export function useUpdateManifestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManifestMutation, UpdateManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManifestMutation, UpdateManifestMutationVariables>(UpdateManifestDocument, options);
      }
export type UpdateManifestMutationHookResult = ReturnType<typeof useUpdateManifestMutation>;
export type UpdateManifestMutationResult = Apollo.MutationResult<UpdateManifestMutation>;
export type UpdateManifestMutationOptions = Apollo.BaseMutationOptions<UpdateManifestMutation, UpdateManifestMutationVariables>;
export const SetUserPrefDocument = gql`
    mutation SetUserPref($name: String!, $input: SetUserPrefInput!) {
  setUserPref(name: $name, input: $input) {
    name
    value
  }
}
    `;
export type SetUserPrefMutationFn = Apollo.MutationFunction<SetUserPrefMutation, SetUserPrefMutationVariables>;

/**
 * __useSetUserPrefMutation__
 *
 * To run a mutation, you first call `useSetUserPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPrefMutation, { data, loading, error }] = useSetUserPrefMutation({
 *   variables: {
 *      name: // value for 'name'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserPrefMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPrefMutation, SetUserPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPrefMutation, SetUserPrefMutationVariables>(SetUserPrefDocument, options);
      }
export type SetUserPrefMutationHookResult = ReturnType<typeof useSetUserPrefMutation>;
export type SetUserPrefMutationResult = Apollo.MutationResult<SetUserPrefMutation>;
export type SetUserPrefMutationOptions = Apollo.BaseMutationOptions<SetUserPrefMutation, SetUserPrefMutationVariables>;
export const SetTenantPrefDocument = gql`
    mutation SetTenantPref($name: String!, $input: SetTenantPrefInput!) {
  setTenantPref(name: $name, input: $input) {
    name
    value
  }
}
    `;
export type SetTenantPrefMutationFn = Apollo.MutationFunction<SetTenantPrefMutation, SetTenantPrefMutationVariables>;

/**
 * __useSetTenantPrefMutation__
 *
 * To run a mutation, you first call `useSetTenantPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTenantPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTenantPrefMutation, { data, loading, error }] = useSetTenantPrefMutation({
 *   variables: {
 *      name: // value for 'name'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTenantPrefMutation(baseOptions?: Apollo.MutationHookOptions<SetTenantPrefMutation, SetTenantPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTenantPrefMutation, SetTenantPrefMutationVariables>(SetTenantPrefDocument, options);
      }
export type SetTenantPrefMutationHookResult = ReturnType<typeof useSetTenantPrefMutation>;
export type SetTenantPrefMutationResult = Apollo.MutationResult<SetTenantPrefMutation>;
export type SetTenantPrefMutationOptions = Apollo.BaseMutationOptions<SetTenantPrefMutation, SetTenantPrefMutationVariables>;
export const ResequenceManifestStopsDocument = gql`
    mutation ResequenceManifestStops($manifestDriverId: Int!, $jobStopManifestSequences: [JobStopManifestSequence]!, $isOptimized: Boolean, $etaSourcesDirty: [String!], $optimizationEtas: [ETAItemInput!]) {
  resequenceManifestStops(
    manifestDriverId: $manifestDriverId
    jobStopManifestSequences: $jobStopManifestSequences
    isOptimized: $isOptimized
    etaSourcesDirty: $etaSourcesDirty
    optimizationEtas: $optimizationEtas
  )
}
    `;
export type ResequenceManifestStopsMutationFn = Apollo.MutationFunction<ResequenceManifestStopsMutation, ResequenceManifestStopsMutationVariables>;

/**
 * __useResequenceManifestStopsMutation__
 *
 * To run a mutation, you first call `useResequenceManifestStopsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResequenceManifestStopsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resequenceManifestStopsMutation, { data, loading, error }] = useResequenceManifestStopsMutation({
 *   variables: {
 *      manifestDriverId: // value for 'manifestDriverId'
 *      jobStopManifestSequences: // value for 'jobStopManifestSequences'
 *      isOptimized: // value for 'isOptimized'
 *      etaSourcesDirty: // value for 'etaSourcesDirty'
 *      optimizationEtas: // value for 'optimizationEtas'
 *   },
 * });
 */
export function useResequenceManifestStopsMutation(baseOptions?: Apollo.MutationHookOptions<ResequenceManifestStopsMutation, ResequenceManifestStopsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResequenceManifestStopsMutation, ResequenceManifestStopsMutationVariables>(ResequenceManifestStopsDocument, options);
      }
export type ResequenceManifestStopsMutationHookResult = ReturnType<typeof useResequenceManifestStopsMutation>;
export type ResequenceManifestStopsMutationResult = Apollo.MutationResult<ResequenceManifestStopsMutation>;
export type ResequenceManifestStopsMutationOptions = Apollo.BaseMutationOptions<ResequenceManifestStopsMutation, ResequenceManifestStopsMutationVariables>;
export const SaveClearJobStopsDocument = gql`
    mutation SaveClearJobStops($saveClearJobStops: [SaveClearJobStop]!) {
  saveClearJobStops(saveClearJobStops: $saveClearJobStops)
}
    `;
export type SaveClearJobStopsMutationFn = Apollo.MutationFunction<SaveClearJobStopsMutation, SaveClearJobStopsMutationVariables>;

/**
 * __useSaveClearJobStopsMutation__
 *
 * To run a mutation, you first call `useSaveClearJobStopsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClearJobStopsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClearJobStopsMutation, { data, loading, error }] = useSaveClearJobStopsMutation({
 *   variables: {
 *      saveClearJobStops: // value for 'saveClearJobStops'
 *   },
 * });
 */
export function useSaveClearJobStopsMutation(baseOptions?: Apollo.MutationHookOptions<SaveClearJobStopsMutation, SaveClearJobStopsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClearJobStopsMutation, SaveClearJobStopsMutationVariables>(SaveClearJobStopsDocument, options);
      }
export type SaveClearJobStopsMutationHookResult = ReturnType<typeof useSaveClearJobStopsMutation>;
export type SaveClearJobStopsMutationResult = Apollo.MutationResult<SaveClearJobStopsMutation>;
export type SaveClearJobStopsMutationOptions = Apollo.BaseMutationOptions<SaveClearJobStopsMutation, SaveClearJobStopsMutationVariables>;
export const EnableDataChangedEventsDocument = gql`
    mutation EnableDataChangedEvents($entityType: DataChangeEntityType!, $entityId: String, $ttl: Int) {
  enableDataChangedEvents(entityType: $entityType, entityId: $entityId, ttl: $ttl)
}
    `;
export type EnableDataChangedEventsMutationFn = Apollo.MutationFunction<EnableDataChangedEventsMutation, EnableDataChangedEventsMutationVariables>;

/**
 * __useEnableDataChangedEventsMutation__
 *
 * To run a mutation, you first call `useEnableDataChangedEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableDataChangedEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableDataChangedEventsMutation, { data, loading, error }] = useEnableDataChangedEventsMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      ttl: // value for 'ttl'
 *   },
 * });
 */
export function useEnableDataChangedEventsMutation(baseOptions?: Apollo.MutationHookOptions<EnableDataChangedEventsMutation, EnableDataChangedEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableDataChangedEventsMutation, EnableDataChangedEventsMutationVariables>(EnableDataChangedEventsDocument, options);
      }
export type EnableDataChangedEventsMutationHookResult = ReturnType<typeof useEnableDataChangedEventsMutation>;
export type EnableDataChangedEventsMutationResult = Apollo.MutationResult<EnableDataChangedEventsMutation>;
export type EnableDataChangedEventsMutationOptions = Apollo.BaseMutationOptions<EnableDataChangedEventsMutation, EnableDataChangedEventsMutationVariables>;
export const SetIndicatorConfigDocument = gql`
    mutation SetIndicatorConfig($input: SetIndicatorConfigInput!, $sk: ID) {
  setIndicatorConfig(input: $input, sk: $sk) {
    config
    siteId
    sk
  }
}
    `;
export type SetIndicatorConfigMutationFn = Apollo.MutationFunction<SetIndicatorConfigMutation, SetIndicatorConfigMutationVariables>;

/**
 * __useSetIndicatorConfigMutation__
 *
 * To run a mutation, you first call `useSetIndicatorConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndicatorConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndicatorConfigMutation, { data, loading, error }] = useSetIndicatorConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sk: // value for 'sk'
 *   },
 * });
 */
export function useSetIndicatorConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetIndicatorConfigMutation, SetIndicatorConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIndicatorConfigMutation, SetIndicatorConfigMutationVariables>(SetIndicatorConfigDocument, options);
      }
export type SetIndicatorConfigMutationHookResult = ReturnType<typeof useSetIndicatorConfigMutation>;
export type SetIndicatorConfigMutationResult = Apollo.MutationResult<SetIndicatorConfigMutation>;
export type SetIndicatorConfigMutationOptions = Apollo.BaseMutationOptions<SetIndicatorConfigMutation, SetIndicatorConfigMutationVariables>;
export const ReassignJobStopsDocument = gql`
    mutation ReassignJobStops($manifestDriverId: Int!, $fromManifestDriverId: Int!, $jobStopIds: [Int]!, $keepManifestSequence: Boolean, $skillOverrideNotes: [SkillOverrideNoteInput]) {
  reassignJobStops(
    manifestDriverId: $manifestDriverId
    fromManifestDriverId: $fromManifestDriverId
    jobStopIds: $jobStopIds
    keepManifestSequence: $keepManifestSequence
    skillOverrideNotes: $skillOverrideNotes
  )
}
    `;
export type ReassignJobStopsMutationFn = Apollo.MutationFunction<ReassignJobStopsMutation, ReassignJobStopsMutationVariables>;

/**
 * __useReassignJobStopsMutation__
 *
 * To run a mutation, you first call `useReassignJobStopsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignJobStopsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignJobStopsMutation, { data, loading, error }] = useReassignJobStopsMutation({
 *   variables: {
 *      manifestDriverId: // value for 'manifestDriverId'
 *      fromManifestDriverId: // value for 'fromManifestDriverId'
 *      jobStopIds: // value for 'jobStopIds'
 *      keepManifestSequence: // value for 'keepManifestSequence'
 *      skillOverrideNotes: // value for 'skillOverrideNotes'
 *   },
 * });
 */
export function useReassignJobStopsMutation(baseOptions?: Apollo.MutationHookOptions<ReassignJobStopsMutation, ReassignJobStopsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignJobStopsMutation, ReassignJobStopsMutationVariables>(ReassignJobStopsDocument, options);
      }
export type ReassignJobStopsMutationHookResult = ReturnType<typeof useReassignJobStopsMutation>;
export type ReassignJobStopsMutationResult = Apollo.MutationResult<ReassignJobStopsMutation>;
export type ReassignJobStopsMutationOptions = Apollo.BaseMutationOptions<ReassignJobStopsMutation, ReassignJobStopsMutationVariables>;
export const SubmitRoutePlanningDocument = gql`
    mutation SubmitRoutePlanning($input: SubmitRoutePlanningInput!) {
  submitRoutePlanning(input: $input) {
    responseId
    requestBodyJson
    status
    message
    errorsJson
  }
}
    `;
export type SubmitRoutePlanningMutationFn = Apollo.MutationFunction<SubmitRoutePlanningMutation, SubmitRoutePlanningMutationVariables>;

/**
 * __useSubmitRoutePlanningMutation__
 *
 * To run a mutation, you first call `useSubmitRoutePlanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRoutePlanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRoutePlanningMutation, { data, loading, error }] = useSubmitRoutePlanningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRoutePlanningMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRoutePlanningMutation, SubmitRoutePlanningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRoutePlanningMutation, SubmitRoutePlanningMutationVariables>(SubmitRoutePlanningDocument, options);
      }
export type SubmitRoutePlanningMutationHookResult = ReturnType<typeof useSubmitRoutePlanningMutation>;
export type SubmitRoutePlanningMutationResult = Apollo.MutationResult<SubmitRoutePlanningMutation>;
export type SubmitRoutePlanningMutationOptions = Apollo.BaseMutationOptions<SubmitRoutePlanningMutation, SubmitRoutePlanningMutationVariables>;
export const ProcessRoutePlanningDocument = gql`
    mutation processRoutePlanning($input: ProcessRoutePlanningInput!) {
  processRoutePlanning(input: $input) {
    status
    message
  }
}
    `;
export type ProcessRoutePlanningMutationFn = Apollo.MutationFunction<ProcessRoutePlanningMutation, ProcessRoutePlanningMutationVariables>;

/**
 * __useProcessRoutePlanningMutation__
 *
 * To run a mutation, you first call `useProcessRoutePlanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessRoutePlanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processRoutePlanningMutation, { data, loading, error }] = useProcessRoutePlanningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessRoutePlanningMutation(baseOptions?: Apollo.MutationHookOptions<ProcessRoutePlanningMutation, ProcessRoutePlanningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessRoutePlanningMutation, ProcessRoutePlanningMutationVariables>(ProcessRoutePlanningDocument, options);
      }
export type ProcessRoutePlanningMutationHookResult = ReturnType<typeof useProcessRoutePlanningMutation>;
export type ProcessRoutePlanningMutationResult = Apollo.MutationResult<ProcessRoutePlanningMutation>;
export type ProcessRoutePlanningMutationOptions = Apollo.BaseMutationOptions<ProcessRoutePlanningMutation, ProcessRoutePlanningMutationVariables>;
export const SetEtaNotificationConfigDocument = gql`
    mutation SetEtaNotificationConfig($input: SetEtaNotificationConfigInput!, $sk: ID) {
  setEtaNotificationConfig(input: $input, sk: $sk) {
    sk
    siteId
    config
  }
}
    `;
export type SetEtaNotificationConfigMutationFn = Apollo.MutationFunction<SetEtaNotificationConfigMutation, SetEtaNotificationConfigMutationVariables>;

/**
 * __useSetEtaNotificationConfigMutation__
 *
 * To run a mutation, you first call `useSetEtaNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEtaNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEtaNotificationConfigMutation, { data, loading, error }] = useSetEtaNotificationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sk: // value for 'sk'
 *   },
 * });
 */
export function useSetEtaNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetEtaNotificationConfigMutation, SetEtaNotificationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEtaNotificationConfigMutation, SetEtaNotificationConfigMutationVariables>(SetEtaNotificationConfigDocument, options);
      }
export type SetEtaNotificationConfigMutationHookResult = ReturnType<typeof useSetEtaNotificationConfigMutation>;
export type SetEtaNotificationConfigMutationResult = Apollo.MutationResult<SetEtaNotificationConfigMutation>;
export type SetEtaNotificationConfigMutationOptions = Apollo.BaseMutationOptions<SetEtaNotificationConfigMutation, SetEtaNotificationConfigMutationVariables>;
export const DeleteEtaNotificationConfigDocument = gql`
    mutation DeleteEtaNotificationConfig($sk: ID!) {
  deleteEtaNotificationConfig(sk: $sk) {
    sk
    siteId
    config
  }
}
    `;
export type DeleteEtaNotificationConfigMutationFn = Apollo.MutationFunction<DeleteEtaNotificationConfigMutation, DeleteEtaNotificationConfigMutationVariables>;

/**
 * __useDeleteEtaNotificationConfigMutation__
 *
 * To run a mutation, you first call `useDeleteEtaNotificationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEtaNotificationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEtaNotificationConfigMutation, { data, loading, error }] = useDeleteEtaNotificationConfigMutation({
 *   variables: {
 *      sk: // value for 'sk'
 *   },
 * });
 */
export function useDeleteEtaNotificationConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEtaNotificationConfigMutation, DeleteEtaNotificationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEtaNotificationConfigMutation, DeleteEtaNotificationConfigMutationVariables>(DeleteEtaNotificationConfigDocument, options);
      }
export type DeleteEtaNotificationConfigMutationHookResult = ReturnType<typeof useDeleteEtaNotificationConfigMutation>;
export type DeleteEtaNotificationConfigMutationResult = Apollo.MutationResult<DeleteEtaNotificationConfigMutation>;
export type DeleteEtaNotificationConfigMutationOptions = Apollo.BaseMutationOptions<DeleteEtaNotificationConfigMutation, DeleteEtaNotificationConfigMutationVariables>;
export const AddOrderNoteDocument = gql`
    mutation AddOrderNote($orderId: Int!, $note: String!) {
  addOrderNote(orderId: $orderId, note: $note)
}
    `;
export type AddOrderNoteMutationFn = Apollo.MutationFunction<AddOrderNoteMutation, AddOrderNoteMutationVariables>;

/**
 * __useAddOrderNoteMutation__
 *
 * To run a mutation, you first call `useAddOrderNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderNoteMutation, { data, loading, error }] = useAddOrderNoteMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAddOrderNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderNoteMutation, AddOrderNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderNoteMutation, AddOrderNoteMutationVariables>(AddOrderNoteDocument, options);
      }
export type AddOrderNoteMutationHookResult = ReturnType<typeof useAddOrderNoteMutation>;
export type AddOrderNoteMutationResult = Apollo.MutationResult<AddOrderNoteMutation>;
export type AddOrderNoteMutationOptions = Apollo.BaseMutationOptions<AddOrderNoteMutation, AddOrderNoteMutationVariables>;
export const SplitJobDocument = gql`
    mutation SplitJob($driverId: Int!, $jobId: Int!, $splitPercentage: String!) {
  splitJob(driverId: $driverId, jobId: $jobId, splitPercentage: $splitPercentage)
}
    `;
export type SplitJobMutationFn = Apollo.MutationFunction<SplitJobMutation, SplitJobMutationVariables>;

/**
 * __useSplitJobMutation__
 *
 * To run a mutation, you first call `useSplitJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitJobMutation, { data, loading, error }] = useSplitJobMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *      jobId: // value for 'jobId'
 *      splitPercentage: // value for 'splitPercentage'
 *   },
 * });
 */
export function useSplitJobMutation(baseOptions?: Apollo.MutationHookOptions<SplitJobMutation, SplitJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitJobMutation, SplitJobMutationVariables>(SplitJobDocument, options);
      }
export type SplitJobMutationHookResult = ReturnType<typeof useSplitJobMutation>;
export type SplitJobMutationResult = Apollo.MutationResult<SplitJobMutation>;
export type SplitJobMutationOptions = Apollo.BaseMutationOptions<SplitJobMutation, SplitJobMutationVariables>;
export const RecordRoutePlanningUsageDocument = gql`
    mutation RecordRoutePlanningUsage($input: RecordRoutePlanningUsageInput!) {
  recordRoutePlanningUsage(input: $input) {
    used
    limit
    isUnlimited
    resetDate
  }
}
    `;
export type RecordRoutePlanningUsageMutationFn = Apollo.MutationFunction<RecordRoutePlanningUsageMutation, RecordRoutePlanningUsageMutationVariables>;

/**
 * __useRecordRoutePlanningUsageMutation__
 *
 * To run a mutation, you first call `useRecordRoutePlanningUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordRoutePlanningUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordRoutePlanningUsageMutation, { data, loading, error }] = useRecordRoutePlanningUsageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordRoutePlanningUsageMutation(baseOptions?: Apollo.MutationHookOptions<RecordRoutePlanningUsageMutation, RecordRoutePlanningUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordRoutePlanningUsageMutation, RecordRoutePlanningUsageMutationVariables>(RecordRoutePlanningUsageDocument, options);
      }
export type RecordRoutePlanningUsageMutationHookResult = ReturnType<typeof useRecordRoutePlanningUsageMutation>;
export type RecordRoutePlanningUsageMutationResult = Apollo.MutationResult<RecordRoutePlanningUsageMutation>;
export type RecordRoutePlanningUsageMutationOptions = Apollo.BaseMutationOptions<RecordRoutePlanningUsageMutation, RecordRoutePlanningUsageMutationVariables>;
export const SubmitSuggestAssignmentDocument = gql`
    mutation SubmitSuggestAssignment($input: SubmitSuggestAssignmentInput!) {
  submitSuggestAssignment(input: $input) {
    requestId
    status
    error
    errors {
      jobStopId
      field
      reason
      value
    }
    usageCount
    usageLimit
  }
}
    `;
export type SubmitSuggestAssignmentMutationFn = Apollo.MutationFunction<SubmitSuggestAssignmentMutation, SubmitSuggestAssignmentMutationVariables>;

/**
 * __useSubmitSuggestAssignmentMutation__
 *
 * To run a mutation, you first call `useSubmitSuggestAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSuggestAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSuggestAssignmentMutation, { data, loading, error }] = useSubmitSuggestAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSuggestAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSuggestAssignmentMutation, SubmitSuggestAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSuggestAssignmentMutation, SubmitSuggestAssignmentMutationVariables>(SubmitSuggestAssignmentDocument, options);
      }
export type SubmitSuggestAssignmentMutationHookResult = ReturnType<typeof useSubmitSuggestAssignmentMutation>;
export type SubmitSuggestAssignmentMutationResult = Apollo.MutationResult<SubmitSuggestAssignmentMutation>;
export type SubmitSuggestAssignmentMutationOptions = Apollo.BaseMutationOptions<SubmitSuggestAssignmentMutation, SubmitSuggestAssignmentMutationVariables>;
export const CancelSuggestAssignmentDocument = gql`
    mutation CancelSuggestAssignment($input: CancelSuggestAssignmentInput!) {
  cancelSuggestAssignment(input: $input)
}
    `;
export type CancelSuggestAssignmentMutationFn = Apollo.MutationFunction<CancelSuggestAssignmentMutation, CancelSuggestAssignmentMutationVariables>;

/**
 * __useCancelSuggestAssignmentMutation__
 *
 * To run a mutation, you first call `useCancelSuggestAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSuggestAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSuggestAssignmentMutation, { data, loading, error }] = useCancelSuggestAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSuggestAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelSuggestAssignmentMutation, CancelSuggestAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSuggestAssignmentMutation, CancelSuggestAssignmentMutationVariables>(CancelSuggestAssignmentDocument, options);
      }
export type CancelSuggestAssignmentMutationHookResult = ReturnType<typeof useCancelSuggestAssignmentMutation>;
export type CancelSuggestAssignmentMutationResult = Apollo.MutationResult<CancelSuggestAssignmentMutation>;
export type CancelSuggestAssignmentMutationOptions = Apollo.BaseMutationOptions<CancelSuggestAssignmentMutation, CancelSuggestAssignmentMutationVariables>;
export const SuggestAssignJobDocument = gql`
    mutation SuggestAssignJob($manifestDriverId: Int!, $jobIds: [Int]!, $sequences: [Int!]!, $optimizationEtas: [ETAItemInput!]!, $skillOverrideNotes: [SkillOverrideNoteInput]) {
  suggestAssignJob(
    manifestDriverId: $manifestDriverId
    jobIds: $jobIds
    sequences: $sequences
    optimizationEtas: $optimizationEtas
    skillOverrideNotes: $skillOverrideNotes
  )
}
    `;
export type SuggestAssignJobMutationFn = Apollo.MutationFunction<SuggestAssignJobMutation, SuggestAssignJobMutationVariables>;

/**
 * __useSuggestAssignJobMutation__
 *
 * To run a mutation, you first call `useSuggestAssignJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestAssignJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestAssignJobMutation, { data, loading, error }] = useSuggestAssignJobMutation({
 *   variables: {
 *      manifestDriverId: // value for 'manifestDriverId'
 *      jobIds: // value for 'jobIds'
 *      sequences: // value for 'sequences'
 *      optimizationEtas: // value for 'optimizationEtas'
 *      skillOverrideNotes: // value for 'skillOverrideNotes'
 *   },
 * });
 */
export function useSuggestAssignJobMutation(baseOptions?: Apollo.MutationHookOptions<SuggestAssignJobMutation, SuggestAssignJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestAssignJobMutation, SuggestAssignJobMutationVariables>(SuggestAssignJobDocument, options);
      }
export type SuggestAssignJobMutationHookResult = ReturnType<typeof useSuggestAssignJobMutation>;
export type SuggestAssignJobMutationResult = Apollo.MutationResult<SuggestAssignJobMutation>;
export type SuggestAssignJobMutationOptions = Apollo.BaseMutationOptions<SuggestAssignJobMutation, SuggestAssignJobMutationVariables>;
export const GetDistinctValuesDocument = gql`
    query getDistinctValues($field: String!, $typeName: String!, $limit: Int) {
  getDistinctValues(field: $field, limit: $limit, typename: $typeName) {
    items {
      key
      doc_count
    }
  }
}
    `;

/**
 * __useGetDistinctValuesQuery__
 *
 * To run a query within a React component, call `useGetDistinctValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctValuesQuery({
 *   variables: {
 *      field: // value for 'field'
 *      typeName: // value for 'typeName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDistinctValuesQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctValuesQuery, GetDistinctValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctValuesQuery, GetDistinctValuesQueryVariables>(GetDistinctValuesDocument, options);
      }
export function useGetDistinctValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctValuesQuery, GetDistinctValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctValuesQuery, GetDistinctValuesQueryVariables>(GetDistinctValuesDocument, options);
        }
export type GetDistinctValuesQueryHookResult = ReturnType<typeof useGetDistinctValuesQuery>;
export type GetDistinctValuesLazyQueryHookResult = ReturnType<typeof useGetDistinctValuesLazyQuery>;
export type GetDistinctValuesQueryResult = Apollo.QueryResult<GetDistinctValuesQuery, GetDistinctValuesQueryVariables>;
export const GetUserPrefDocument = gql`
    query GetUserPref($name: String!) {
  getUserPref(name: $name) {
    name
    value
  }
}
    `;

/**
 * __useGetUserPrefQuery__
 *
 * To run a query within a React component, call `useGetUserPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPrefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetUserPrefQuery(baseOptions: Apollo.QueryHookOptions<GetUserPrefQuery, GetUserPrefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPrefQuery, GetUserPrefQueryVariables>(GetUserPrefDocument, options);
      }
export function useGetUserPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPrefQuery, GetUserPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPrefQuery, GetUserPrefQueryVariables>(GetUserPrefDocument, options);
        }
export type GetUserPrefQueryHookResult = ReturnType<typeof useGetUserPrefQuery>;
export type GetUserPrefLazyQueryHookResult = ReturnType<typeof useGetUserPrefLazyQuery>;
export type GetUserPrefQueryResult = Apollo.QueryResult<GetUserPrefQuery, GetUserPrefQueryVariables>;
export const SearchUserPrefsDocument = gql`
    query SearchUserPrefs {
  searchUserPrefs {
    items {
      name
      value
    }
  }
}
    `;

/**
 * __useSearchUserPrefsQuery__
 *
 * To run a query within a React component, call `useSearchUserPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchUserPrefsQuery(baseOptions?: Apollo.QueryHookOptions<SearchUserPrefsQuery, SearchUserPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserPrefsQuery, SearchUserPrefsQueryVariables>(SearchUserPrefsDocument, options);
      }
export function useSearchUserPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserPrefsQuery, SearchUserPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserPrefsQuery, SearchUserPrefsQueryVariables>(SearchUserPrefsDocument, options);
        }
export type SearchUserPrefsQueryHookResult = ReturnType<typeof useSearchUserPrefsQuery>;
export type SearchUserPrefsLazyQueryHookResult = ReturnType<typeof useSearchUserPrefsLazyQuery>;
export type SearchUserPrefsQueryResult = Apollo.QueryResult<SearchUserPrefsQuery, SearchUserPrefsQueryVariables>;
export const GetTenantPrefDocument = gql`
    query GetTenantPref($name: String!) {
  getTenantPref(name: $name) {
    name
    value
  }
}
    `;

/**
 * __useGetTenantPrefQuery__
 *
 * To run a query within a React component, call `useGetTenantPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantPrefQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTenantPrefQuery(baseOptions: Apollo.QueryHookOptions<GetTenantPrefQuery, GetTenantPrefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantPrefQuery, GetTenantPrefQueryVariables>(GetTenantPrefDocument, options);
      }
export function useGetTenantPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantPrefQuery, GetTenantPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantPrefQuery, GetTenantPrefQueryVariables>(GetTenantPrefDocument, options);
        }
export type GetTenantPrefQueryHookResult = ReturnType<typeof useGetTenantPrefQuery>;
export type GetTenantPrefLazyQueryHookResult = ReturnType<typeof useGetTenantPrefLazyQuery>;
export type GetTenantPrefQueryResult = Apollo.QueryResult<GetTenantPrefQuery, GetTenantPrefQueryVariables>;
export const SearchTenantPrefsDocument = gql`
    query SearchTenantPrefs {
  searchTenantPrefs {
    items {
      name
      value
    }
  }
}
    `;

/**
 * __useSearchTenantPrefsQuery__
 *
 * To run a query within a React component, call `useSearchTenantPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTenantPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTenantPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchTenantPrefsQuery(baseOptions?: Apollo.QueryHookOptions<SearchTenantPrefsQuery, SearchTenantPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTenantPrefsQuery, SearchTenantPrefsQueryVariables>(SearchTenantPrefsDocument, options);
      }
export function useSearchTenantPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTenantPrefsQuery, SearchTenantPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTenantPrefsQuery, SearchTenantPrefsQueryVariables>(SearchTenantPrefsDocument, options);
        }
export type SearchTenantPrefsQueryHookResult = ReturnType<typeof useSearchTenantPrefsQuery>;
export type SearchTenantPrefsLazyQueryHookResult = ReturnType<typeof useSearchTenantPrefsLazyQuery>;
export type SearchTenantPrefsQueryResult = Apollo.QueryResult<SearchTenantPrefsQuery, SearchTenantPrefsQueryVariables>;
export const SearchDispatchGroupsDocument = gql`
    query searchDispatchGroups($filter: ModelDispatchGroupFilterInput, $sort: [SearchableDispatchGroupSortInput], $limit: Int, $nextToken: String) {
  searchDispatchGroups(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      siteId
      description
      dispatchGroup
      dispatchGroupId
      dispatchType
    }
  }
}
    `;

/**
 * __useSearchDispatchGroupsQuery__
 *
 * To run a query within a React component, call `useSearchDispatchGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDispatchGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDispatchGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSearchDispatchGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SearchDispatchGroupsQuery, SearchDispatchGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDispatchGroupsQuery, SearchDispatchGroupsQueryVariables>(SearchDispatchGroupsDocument, options);
      }
export function useSearchDispatchGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDispatchGroupsQuery, SearchDispatchGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDispatchGroupsQuery, SearchDispatchGroupsQueryVariables>(SearchDispatchGroupsDocument, options);
        }
export type SearchDispatchGroupsQueryHookResult = ReturnType<typeof useSearchDispatchGroupsQuery>;
export type SearchDispatchGroupsLazyQueryHookResult = ReturnType<typeof useSearchDispatchGroupsLazyQuery>;
export type SearchDispatchGroupsQueryResult = Apollo.QueryResult<SearchDispatchGroupsQuery, SearchDispatchGroupsQueryVariables>;
export const SearchDriverLocationDocument = gql`
    query SearchDriverLocation($filter: ModelDriverLocationFilterInput, $sort: [SearchableDriverLocationsSortInput], $limit: Int, $nextToken: String) {
  searchDriverLocations(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      accuracy
      altitude
      auxData
      coordinates
      driverId
      fixDateTime
      heading
      indexDateTime
      receiveDateTime
      tenantId
      velocity
    }
    nextToken
    total
  }
}
    `;

/**
 * __useSearchDriverLocationQuery__
 *
 * To run a query within a React component, call `useSearchDriverLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriverLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriverLocationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSearchDriverLocationQuery(baseOptions?: Apollo.QueryHookOptions<SearchDriverLocationQuery, SearchDriverLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriverLocationQuery, SearchDriverLocationQueryVariables>(SearchDriverLocationDocument, options);
      }
export function useSearchDriverLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriverLocationQuery, SearchDriverLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriverLocationQuery, SearchDriverLocationQueryVariables>(SearchDriverLocationDocument, options);
        }
export type SearchDriverLocationQueryHookResult = ReturnType<typeof useSearchDriverLocationQuery>;
export type SearchDriverLocationLazyQueryHookResult = ReturnType<typeof useSearchDriverLocationLazyQuery>;
export type SearchDriverLocationQueryResult = Apollo.QueryResult<SearchDriverLocationQuery, SearchDriverLocationQueryVariables>;
export const SearchDriversDocument = gql`
    query SearchDrivers($filter: ModelDriverFilterInput, $sort: [SearchableDriverSortInput], $limit: Int, $nextToken: String) {
  searchDrivers(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      autoAccept
      autoSend
      driverCode
      driverAlias
      driverId
      driverStatus
      name
      siteId
      startZip
      startZone
      endZip
      endZone
      dispatchGroupId
      vehicleTypeId
      address
      city
      state
      zip
    }
  }
}
    `;

/**
 * __useSearchDriversQuery__
 *
 * To run a query within a React component, call `useSearchDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriversQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSearchDriversQuery(baseOptions?: Apollo.QueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
      }
export function useSearchDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
        }
export type SearchDriversQueryHookResult = ReturnType<typeof useSearchDriversQuery>;
export type SearchDriversLazyQueryHookResult = ReturnType<typeof useSearchDriversLazyQuery>;
export type SearchDriversQueryResult = Apollo.QueryResult<SearchDriversQuery, SearchDriversQueryVariables>;
export const SearchDriversEnhancedDocument = gql`
    query searchDriversEnhanced($filter: DriverFilterInput, $sort: [SearchableDriverSortInput], $limit: Int, $offset: Int) {
  searchDriversEnhanced(
    filter: $filter
    sort: $sort
    limit: $limit
    offset: $offset
  ) {
    items {
      autoAccept
      autoSend
      driverCode
      driverAlias
      driverId
      driverStatus
      name
      siteId
      startZip
      startZone
      endZip
      endZone
      dispatchGroupId
      vehicleTypeId
      address
      city
      state
      zip
      phone
      skills
    }
    total
  }
}
    `;

/**
 * __useSearchDriversEnhancedQuery__
 *
 * To run a query within a React component, call `useSearchDriversEnhancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriversEnhancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriversEnhancedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchDriversEnhancedQuery(baseOptions?: Apollo.QueryHookOptions<SearchDriversEnhancedQuery, SearchDriversEnhancedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriversEnhancedQuery, SearchDriversEnhancedQueryVariables>(SearchDriversEnhancedDocument, options);
      }
export function useSearchDriversEnhancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriversEnhancedQuery, SearchDriversEnhancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriversEnhancedQuery, SearchDriversEnhancedQueryVariables>(SearchDriversEnhancedDocument, options);
        }
export type SearchDriversEnhancedQueryHookResult = ReturnType<typeof useSearchDriversEnhancedQuery>;
export type SearchDriversEnhancedLazyQueryHookResult = ReturnType<typeof useSearchDriversEnhancedLazyQuery>;
export type SearchDriversEnhancedQueryResult = Apollo.QueryResult<SearchDriversEnhancedQuery, SearchDriversEnhancedQueryVariables>;
export const Map_SearchJobsDocument = gql`
    query Map_SearchJobs($filter: JobFilter, $sort: [JobSortInput], $offset: Int, $limit: Int) {
  searchJobs(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      jobId
      jobNumber
      service
      jobStatus
      indicatorRank
      indicatorColor
      indicatorExpiry
      indicatorSnoozeUntil
      order {
        orderId
        customer {
          name
        }
        requirements {
          id
          code
          name
        }
      }
      vehicleType {
        description
      }
      stops {
        name
        jobStopId
        sequence
        stopType
        dispatchZone
        scheduledDateTime
        earlyDateTime
        lateDateTime
        arriveDateTime
        departDateTime
        podDateTime
        jobStopStatus
        timeZone
        address
        city
        state
        zip
      }
    }
  }
}
    `;

/**
 * __useMap_SearchJobsQuery__
 *
 * To run a query within a React component, call `useMap_SearchJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMap_SearchJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMap_SearchJobsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMap_SearchJobsQuery(baseOptions?: Apollo.QueryHookOptions<Map_SearchJobsQuery, Map_SearchJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Map_SearchJobsQuery, Map_SearchJobsQueryVariables>(Map_SearchJobsDocument, options);
      }
export function useMap_SearchJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Map_SearchJobsQuery, Map_SearchJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Map_SearchJobsQuery, Map_SearchJobsQueryVariables>(Map_SearchJobsDocument, options);
        }
export type Map_SearchJobsQueryHookResult = ReturnType<typeof useMap_SearchJobsQuery>;
export type Map_SearchJobsLazyQueryHookResult = ReturnType<typeof useMap_SearchJobsLazyQuery>;
export type Map_SearchJobsQueryResult = Apollo.QueryResult<Map_SearchJobsQuery, Map_SearchJobsQueryVariables>;
export const Map_SearchManifestsDocument = gql`
    query Map_SearchManifests($filter: ManifestFilter, $sort: [ManifestSortInput], $offset: Int, $limit: Int) {
  searchManifests(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      manifestDriverId
      manifestStatus
      vehicleType {
        description
      }
      driver {
        driverId
        code
        name
      }
      stops {
        name
        jobStopId
        manifestSequence
        stopType
        timeZone
        scheduledDateTime
        earlyDateTime
        lateDateTime
        arriveDateTime
        dispatchZone
        departDateTime
        podDateTime
        jobStopStatus
        address
        city
        state
        zip
        indicatorRank
        indicatorColor
        indicatorExpiry
        indicatorSnoozeUntil
        job {
          jobNumber
          jobId
        }
        order {
          orderId
          service
          customer {
            customerId
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMap_SearchManifestsQuery__
 *
 * To run a query within a React component, call `useMap_SearchManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMap_SearchManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMap_SearchManifestsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMap_SearchManifestsQuery(baseOptions?: Apollo.QueryHookOptions<Map_SearchManifestsQuery, Map_SearchManifestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Map_SearchManifestsQuery, Map_SearchManifestsQueryVariables>(Map_SearchManifestsDocument, options);
      }
export function useMap_SearchManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Map_SearchManifestsQuery, Map_SearchManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Map_SearchManifestsQuery, Map_SearchManifestsQueryVariables>(Map_SearchManifestsDocument, options);
        }
export type Map_SearchManifestsQueryHookResult = ReturnType<typeof useMap_SearchManifestsQuery>;
export type Map_SearchManifestsLazyQueryHookResult = ReturnType<typeof useMap_SearchManifestsLazyQuery>;
export type Map_SearchManifestsQueryResult = Apollo.QueryResult<Map_SearchManifestsQuery, Map_SearchManifestsQueryVariables>;
export const SearchManifestDetailsDocument = gql`
    query SearchManifestDetails($filter: ManifestFilter, $sort: [ManifestSortInput], $offset: Int, $limit: Int) {
  searchManifests(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      events {
        eventId
        eventTypeId
        startDateTime
      }
      lastZone
      endZip
      totalPieces
      manifestDriverId
      manifestDate
      manifestStatus
      autoCloseManifest
      optimizedDateTime
      optimizedBy
      startMileage
      endMileage
      vehicleType {
        vehicleTypeId
        description
      }
      dispatchGroup {
        dispatchGroupId
        name
        description
      }
      driver {
        driverId
        code
        name
        phone
        alias
        note
        skills {
          id
          name
          skillDescription
          status
        }
        qualifications {
          id
          code
          name
        }
        dispatchGroup {
          dispatchGroupId
          name
        }
      }
      stops {
        jobStopId
        sequence
        name
        address
        city
        state
        zip
        timeZone
        manifestSequence
        scheduledDateTime
        earlyDateTime
        dispatchZone
        lateDateTime
        arriveDateTime
        departDateTime
        podName
        podDateTime
        podRequired
        stopType
        jobStopStatus
        see
        phone
        note
        room
        indicatorRank
        indicatorColor
        indicatorExpiry
        indicatorSnoozeUntil
        job {
          jobId
          jobNumber
          alias
          pieces
          weight
          routeNumber
          site {
            code
            siteId
          }
          driverId
          driverId2
          splitPercentage
        }
        order {
          alias
          auth
          caller
          callerPhone
          description
          declaredValue
          orderId
          codAmount
          codStatus
          otherReference
          invoiceReference
          podRequired
          service
          tabPieces
          createDate
          customer {
            customerId
            customerCode
            name
            notes
            alias
            group
          }
          priority {
            orderPriorityId
            description
          }
          orderSkills {
            id
            name
          }
          requirements {
            id
            code
            name
          }
          user {
            userId
            userName
          }
          notes
          service
        }
      }
      stopCount
      metadata {
        alerts {
          level
          message
        }
      }
    }
    nextToken
    total
  }
}
    `;

/**
 * __useSearchManifestDetailsQuery__
 *
 * To run a query within a React component, call `useSearchManifestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchManifestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchManifestDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchManifestDetailsQuery(baseOptions?: Apollo.QueryHookOptions<SearchManifestDetailsQuery, SearchManifestDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchManifestDetailsQuery, SearchManifestDetailsQueryVariables>(SearchManifestDetailsDocument, options);
      }
export function useSearchManifestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchManifestDetailsQuery, SearchManifestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchManifestDetailsQuery, SearchManifestDetailsQueryVariables>(SearchManifestDetailsDocument, options);
        }
export type SearchManifestDetailsQueryHookResult = ReturnType<typeof useSearchManifestDetailsQuery>;
export type SearchManifestDetailsLazyQueryHookResult = ReturnType<typeof useSearchManifestDetailsLazyQuery>;
export type SearchManifestDetailsQueryResult = Apollo.QueryResult<SearchManifestDetailsQuery, SearchManifestDetailsQueryVariables>;
export const GeoCodeAddressesDocument = gql`
    query GeoCodeAddresses($formattedAddresses: [String!]!) {
  geocodeAddresses(formattedAddresses: $formattedAddresses) {
    items {
      lat
      lon
      formattedAddress
      locationType
      status
    }
  }
}
    `;

/**
 * __useGeoCodeAddressesQuery__
 *
 * To run a query within a React component, call `useGeoCodeAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoCodeAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoCodeAddressesQuery({
 *   variables: {
 *      formattedAddresses: // value for 'formattedAddresses'
 *   },
 * });
 */
export function useGeoCodeAddressesQuery(baseOptions: Apollo.QueryHookOptions<GeoCodeAddressesQuery, GeoCodeAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoCodeAddressesQuery, GeoCodeAddressesQueryVariables>(GeoCodeAddressesDocument, options);
      }
export function useGeoCodeAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoCodeAddressesQuery, GeoCodeAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoCodeAddressesQuery, GeoCodeAddressesQueryVariables>(GeoCodeAddressesDocument, options);
        }
export type GeoCodeAddressesQueryHookResult = ReturnType<typeof useGeoCodeAddressesQuery>;
export type GeoCodeAddressesLazyQueryHookResult = ReturnType<typeof useGeoCodeAddressesLazyQuery>;
export type GeoCodeAddressesQueryResult = Apollo.QueryResult<GeoCodeAddressesQuery, GeoCodeAddressesQueryVariables>;
export const SearchVehicleTypesDocument = gql`
    query SearchVehicleTypes($filter: ModelVehicleTypeFilterInput, $limit: Int, $nextToken: String, $sort: [SearchableVehicleTypeSortInput]) {
  searchVehicleTypes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sort: $sort
  ) {
    items {
      vehicleTypeId
      description
      sortSequence
      rank
    }
  }
}
    `;

/**
 * __useSearchVehicleTypesQuery__
 *
 * To run a query within a React component, call `useSearchVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehicleTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchVehicleTypesQuery(baseOptions?: Apollo.QueryHookOptions<SearchVehicleTypesQuery, SearchVehicleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVehicleTypesQuery, SearchVehicleTypesQueryVariables>(SearchVehicleTypesDocument, options);
      }
export function useSearchVehicleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVehicleTypesQuery, SearchVehicleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVehicleTypesQuery, SearchVehicleTypesQueryVariables>(SearchVehicleTypesDocument, options);
        }
export type SearchVehicleTypesQueryHookResult = ReturnType<typeof useSearchVehicleTypesQuery>;
export type SearchVehicleTypesLazyQueryHookResult = ReturnType<typeof useSearchVehicleTypesLazyQuery>;
export type SearchVehicleTypesQueryResult = Apollo.QueryResult<SearchVehicleTypesQuery, SearchVehicleTypesQueryVariables>;
export const SearchIndicatorConfigsDocument = gql`
    query SearchIndicatorConfigs($filter: IndicatorConfigsFilter) {
  searchIndicatorConfigs(filter: $filter) {
    items {
      config
      siteId
      sk
    }
  }
}
    `;

/**
 * __useSearchIndicatorConfigsQuery__
 *
 * To run a query within a React component, call `useSearchIndicatorConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIndicatorConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIndicatorConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchIndicatorConfigsQuery(baseOptions?: Apollo.QueryHookOptions<SearchIndicatorConfigsQuery, SearchIndicatorConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIndicatorConfigsQuery, SearchIndicatorConfigsQueryVariables>(SearchIndicatorConfigsDocument, options);
      }
export function useSearchIndicatorConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIndicatorConfigsQuery, SearchIndicatorConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIndicatorConfigsQuery, SearchIndicatorConfigsQueryVariables>(SearchIndicatorConfigsDocument, options);
        }
export type SearchIndicatorConfigsQueryHookResult = ReturnType<typeof useSearchIndicatorConfigsQuery>;
export type SearchIndicatorConfigsLazyQueryHookResult = ReturnType<typeof useSearchIndicatorConfigsLazyQuery>;
export type SearchIndicatorConfigsQueryResult = Apollo.QueryResult<SearchIndicatorConfigsQuery, SearchIndicatorConfigsQueryVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($filter: CustomerFilter, $sort: [CustomerSort], $offset: Int, $limit: Int) {
  searchCustomers(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    items {
      customerCode
      customerId
      customerGroup
      name
      siteId
    }
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions?: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const SearchServicesDocument = gql`
    query SearchServices($filter: ServiceFilter, $sort: [ServiceSort], $offset: Int, $limit: Int) {
  searchServices(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      serviceId
      service
      description
      siteId
    }
  }
}
    `;

/**
 * __useSearchServicesQuery__
 *
 * To run a query within a React component, call `useSearchServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchServicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchServicesQuery(baseOptions?: Apollo.QueryHookOptions<SearchServicesQuery, SearchServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchServicesQuery, SearchServicesQueryVariables>(SearchServicesDocument, options);
      }
export function useSearchServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchServicesQuery, SearchServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchServicesQuery, SearchServicesQueryVariables>(SearchServicesDocument, options);
        }
export type SearchServicesQueryHookResult = ReturnType<typeof useSearchServicesQuery>;
export type SearchServicesLazyQueryHookResult = ReturnType<typeof useSearchServicesLazyQuery>;
export type SearchServicesQueryResult = Apollo.QueryResult<SearchServicesQuery, SearchServicesQueryVariables>;
export const SearchEventTypesDocument = gql`
    query SearchEventTypes($filter: EventTypeFilterInput, $sort: [EventTypeSortInput!], $offset: Int, $limit: Int) {
  searchEventTypes(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      customerId
      description
      driverCreatable
      eBilling
      eventType
      eventTypeId
      lateReason
      pieceStatusId
      showOnWeb
    }
  }
}
    `;

/**
 * __useSearchEventTypesQuery__
 *
 * To run a query within a React component, call `useSearchEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<SearchEventTypesQuery, SearchEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventTypesQuery, SearchEventTypesQueryVariables>(SearchEventTypesDocument, options);
      }
export function useSearchEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventTypesQuery, SearchEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventTypesQuery, SearchEventTypesQueryVariables>(SearchEventTypesDocument, options);
        }
export type SearchEventTypesQueryHookResult = ReturnType<typeof useSearchEventTypesQuery>;
export type SearchEventTypesLazyQueryHookResult = ReturnType<typeof useSearchEventTypesLazyQuery>;
export type SearchEventTypesQueryResult = Apollo.QueryResult<SearchEventTypesQuery, SearchEventTypesQueryVariables>;
export const SearchLateStopsDocument = gql`
    query SearchLateStops($filter: LateStopFilterInput, $sort: [LateStopSortInput!], $offset: Int, $limit: Int) {
  searchLateStops(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      lateStopId
      siteId
      customerId
      customerGroup
      sequence
      serviceId
      stopMinutes
      stopType
      timeType
      triggerType
    }
  }
}
    `;

/**
 * __useSearchLateStopsQuery__
 *
 * To run a query within a React component, call `useSearchLateStopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLateStopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLateStopsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchLateStopsQuery(baseOptions?: Apollo.QueryHookOptions<SearchLateStopsQuery, SearchLateStopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLateStopsQuery, SearchLateStopsQueryVariables>(SearchLateStopsDocument, options);
      }
export function useSearchLateStopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLateStopsQuery, SearchLateStopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLateStopsQuery, SearchLateStopsQueryVariables>(SearchLateStopsDocument, options);
        }
export type SearchLateStopsQueryHookResult = ReturnType<typeof useSearchLateStopsQuery>;
export type SearchLateStopsLazyQueryHookResult = ReturnType<typeof useSearchLateStopsLazyQuery>;
export type SearchLateStopsQueryResult = Apollo.QueryResult<SearchLateStopsQuery, SearchLateStopsQueryVariables>;
export const OptimizeRoutesDocument = gql`
    query OptimizeRoutes($routeOptimizationRequests: [RouteOptimizationRequest!]!, $routeOptimizationRequestOptions: [RouteOptimizationRequestOption!]) {
  optimizeRoutes(
    routeOptimizationRequests: $routeOptimizationRequests
    routeOptimizationRequestOptions: $routeOptimizationRequestOptions
  ) {
    items {
      routeDifference {
        distanceDifference
        timeDifference
      }
      originalRoute {
        info {
          copyrights
          took
        }
        paths {
          points {
            encodedLine
            lineType
          }
        }
      }
      manifestDriverId
      valid
      solution {
        cached
        job_id
        copyrights
        processing_time
        status
        waiting_time_in_queue
        rateLimitCredits
        solution {
          distance
          transport_time
          max_operation_time
          waiting_time
          service_duration
          preparation_time
          completion_time
          no_vehicles
          no_unassigned
          routes {
            vehicle_id
            distance
            transport_time
            completion_time
            waiting_time
            service_duration
            preparation_time
            activities {
              type
              id
              location_id
              address {
                location_id
                name
                lon
                lat
              }
              arr_time
              arr_date_time
              end_time
              end_date_time
              waiting_time
              preparation_time
              distance
              driving_time
              load_before
              load_after
            }
            points {
              type
              coordinates
            }
          }
          unassigned {
            services
            shipments
            breaks
            details {
              id
              code
              reason
            }
          }
        }
      }
      validationErrors {
        hints {
          details
          message
          serviceId
        }
        message
      }
      optimizationEtas {
        jobStopId
        eta
        generatedDateTime
        etaSource
      }
    }
  }
}
    `;

/**
 * __useOptimizeRoutesQuery__
 *
 * To run a query within a React component, call `useOptimizeRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizeRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizeRoutesQuery({
 *   variables: {
 *      routeOptimizationRequests: // value for 'routeOptimizationRequests'
 *      routeOptimizationRequestOptions: // value for 'routeOptimizationRequestOptions'
 *   },
 * });
 */
export function useOptimizeRoutesQuery(baseOptions: Apollo.QueryHookOptions<OptimizeRoutesQuery, OptimizeRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimizeRoutesQuery, OptimizeRoutesQueryVariables>(OptimizeRoutesDocument, options);
      }
export function useOptimizeRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimizeRoutesQuery, OptimizeRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimizeRoutesQuery, OptimizeRoutesQueryVariables>(OptimizeRoutesDocument, options);
        }
export type OptimizeRoutesQueryHookResult = ReturnType<typeof useOptimizeRoutesQuery>;
export type OptimizeRoutesLazyQueryHookResult = ReturnType<typeof useOptimizeRoutesLazyQuery>;
export type OptimizeRoutesQueryResult = Apollo.QueryResult<OptimizeRoutesQuery, OptimizeRoutesQueryVariables>;
export const GetBatchOptimizationResultDocument = gql`
    query GetBatchOptimizationResult($jobId: String!) {
  getBatchOptimizationResult(jobId: $jobId) {
    items {
      routeDifference {
        distanceDifference
        timeDifference
      }
      originalRoute {
        info {
          copyrights
          took
        }
        paths {
          points {
            encodedLine
            lineType
          }
        }
      }
      manifestDriverId
      valid
      solution {
        cached
        job_id
        copyrights
        processing_time
        status
        waiting_time_in_queue
        rateLimitCredits
        solution {
          distance
          transport_time
          max_operation_time
          waiting_time
          service_duration
          preparation_time
          completion_time
          no_vehicles
          no_unassigned
          routes {
            vehicle_id
            distance
            transport_time
            completion_time
            waiting_time
            service_duration
            preparation_time
            activities {
              type
              id
              location_id
              address {
                location_id
                name
                lon
                lat
              }
              arr_time
              arr_date_time
              end_time
              end_date_time
              waiting_time
              preparation_time
              distance
              driving_time
              load_before
              load_after
            }
            points {
              type
              coordinates
            }
          }
          unassigned {
            services
            shipments
            breaks
            details {
              id
              code
              reason
            }
          }
        }
      }
      validationErrors {
        hints {
          details
          message
          serviceId
        }
        message
      }
      optimizationEtas {
        jobStopId
        eta
        generatedDateTime
        etaSource
      }
    }
  }
}
    `;

/**
 * __useGetBatchOptimizationResultQuery__
 *
 * To run a query within a React component, call `useGetBatchOptimizationResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBatchOptimizationResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBatchOptimizationResultQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetBatchOptimizationResultQuery(baseOptions: Apollo.QueryHookOptions<GetBatchOptimizationResultQuery, GetBatchOptimizationResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBatchOptimizationResultQuery, GetBatchOptimizationResultQueryVariables>(GetBatchOptimizationResultDocument, options);
      }
export function useGetBatchOptimizationResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBatchOptimizationResultQuery, GetBatchOptimizationResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBatchOptimizationResultQuery, GetBatchOptimizationResultQueryVariables>(GetBatchOptimizationResultDocument, options);
        }
export type GetBatchOptimizationResultQueryHookResult = ReturnType<typeof useGetBatchOptimizationResultQuery>;
export type GetBatchOptimizationResultLazyQueryHookResult = ReturnType<typeof useGetBatchOptimizationResultLazyQuery>;
export type GetBatchOptimizationResultQueryResult = Apollo.QueryResult<GetBatchOptimizationResultQuery, GetBatchOptimizationResultQueryVariables>;
export const SearchOrderPrioritiesDocument = gql`
    query SearchOrderPriorities($filter: ModelOrderPriorityFilterInput, $sort: [SearchableOrderPrioritySortInput], $limit: Int) {
  searchOrderPriorities(filter: $filter, sort: $sort, limit: $limit) {
    items {
      orderPriorityId
      description
      dispatchJobColor
      siteId
    }
  }
}
    `;

/**
 * __useSearchOrderPrioritiesQuery__
 *
 * To run a query within a React component, call `useSearchOrderPrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOrderPrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOrderPrioritiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchOrderPrioritiesQuery(baseOptions?: Apollo.QueryHookOptions<SearchOrderPrioritiesQuery, SearchOrderPrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOrderPrioritiesQuery, SearchOrderPrioritiesQueryVariables>(SearchOrderPrioritiesDocument, options);
      }
export function useSearchOrderPrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOrderPrioritiesQuery, SearchOrderPrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOrderPrioritiesQuery, SearchOrderPrioritiesQueryVariables>(SearchOrderPrioritiesDocument, options);
        }
export type SearchOrderPrioritiesQueryHookResult = ReturnType<typeof useSearchOrderPrioritiesQuery>;
export type SearchOrderPrioritiesLazyQueryHookResult = ReturnType<typeof useSearchOrderPrioritiesLazyQuery>;
export type SearchOrderPrioritiesQueryResult = Apollo.QueryResult<SearchOrderPrioritiesQuery, SearchOrderPrioritiesQueryVariables>;
export const SearchDispatchStationGroupsDocument = gql`
    query SearchDispatchStationGroups($filter: ModelDispatchStationGroupFilterInput, $sort: [SearchableDispatchStationSortInput], $limit: Int, $nextToken: String) {
  searchDispatchStationGroups(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      pk
      sk
      dispatchStation
      description
      dispatchGroupId
      dispatchType
    }
  }
}
    `;

/**
 * __useSearchDispatchStationGroupsQuery__
 *
 * To run a query within a React component, call `useSearchDispatchStationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDispatchStationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDispatchStationGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSearchDispatchStationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SearchDispatchStationGroupsQuery, SearchDispatchStationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDispatchStationGroupsQuery, SearchDispatchStationGroupsQueryVariables>(SearchDispatchStationGroupsDocument, options);
      }
export function useSearchDispatchStationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDispatchStationGroupsQuery, SearchDispatchStationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDispatchStationGroupsQuery, SearchDispatchStationGroupsQueryVariables>(SearchDispatchStationGroupsDocument, options);
        }
export type SearchDispatchStationGroupsQueryHookResult = ReturnType<typeof useSearchDispatchStationGroupsQuery>;
export type SearchDispatchStationGroupsLazyQueryHookResult = ReturnType<typeof useSearchDispatchStationGroupsLazyQuery>;
export type SearchDispatchStationGroupsQueryResult = Apollo.QueryResult<SearchDispatchStationGroupsQuery, SearchDispatchStationGroupsQueryVariables>;
export const SearchFeeTitlesDocument = gql`
    query SearchFeeTitles($filter: FeeTitleFilterInput, $sort: [FeeTitleSortInput!], $limit: Int, $offset: Int) {
  searchFeeTitles(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    items {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useSearchFeeTitlesQuery__
 *
 * To run a query within a React component, call `useSearchFeeTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFeeTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFeeTitlesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchFeeTitlesQuery(baseOptions?: Apollo.QueryHookOptions<SearchFeeTitlesQuery, SearchFeeTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFeeTitlesQuery, SearchFeeTitlesQueryVariables>(SearchFeeTitlesDocument, options);
      }
export function useSearchFeeTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFeeTitlesQuery, SearchFeeTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFeeTitlesQuery, SearchFeeTitlesQueryVariables>(SearchFeeTitlesDocument, options);
        }
export type SearchFeeTitlesQueryHookResult = ReturnType<typeof useSearchFeeTitlesQuery>;
export type SearchFeeTitlesLazyQueryHookResult = ReturnType<typeof useSearchFeeTitlesLazyQuery>;
export type SearchFeeTitlesQueryResult = Apollo.QueryResult<SearchFeeTitlesQuery, SearchFeeTitlesQueryVariables>;
export const SearchSitesDocument = gql`
    query SearchSites($filter: SiteFilterInput, $sort: [SiteSortInput!], $limit: Int, $offset: Int) {
  searchSites(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    items {
      siteId
      code
    }
  }
}
    `;

/**
 * __useSearchSitesQuery__
 *
 * To run a query within a React component, call `useSearchSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSitesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchSitesQuery(baseOptions?: Apollo.QueryHookOptions<SearchSitesQuery, SearchSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSitesQuery, SearchSitesQueryVariables>(SearchSitesDocument, options);
      }
export function useSearchSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSitesQuery, SearchSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSitesQuery, SearchSitesQueryVariables>(SearchSitesDocument, options);
        }
export type SearchSitesQueryHookResult = ReturnType<typeof useSearchSitesQuery>;
export type SearchSitesLazyQueryHookResult = ReturnType<typeof useSearchSitesLazyQuery>;
export type SearchSitesQueryResult = Apollo.QueryResult<SearchSitesQuery, SearchSitesQueryVariables>;
export const GetRouteDocument = gql`
    query GetRoute($routingRequest: RoutingRequest!) {
  route(routingRequest: $routingRequest) {
    result {
      paths {
        ascend
        boundaryBox
        descend
        distance
        points {
          lineType
          coordinates
          encodedLine
        }
        pointsEncoded
        pointsOrder
        snappedWaypoints {
          __typename
          lineType
          coordinates
          encodedLine
        }
        time
      }
      info {
        copyrights
        took
      }
    }
  }
}
    `;

/**
 * __useGetRouteQuery__
 *
 * To run a query within a React component, call `useGetRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteQuery({
 *   variables: {
 *      routingRequest: // value for 'routingRequest'
 *   },
 * });
 */
export function useGetRouteQuery(baseOptions: Apollo.QueryHookOptions<GetRouteQuery, GetRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteQuery, GetRouteQueryVariables>(GetRouteDocument, options);
      }
export function useGetRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteQuery, GetRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteQuery, GetRouteQueryVariables>(GetRouteDocument, options);
        }
export type GetRouteQueryHookResult = ReturnType<typeof useGetRouteQuery>;
export type GetRouteLazyQueryHookResult = ReturnType<typeof useGetRouteLazyQuery>;
export type GetRouteQueryResult = Apollo.QueryResult<GetRouteQuery, GetRouteQueryVariables>;
export const GetRouteWithEtasDocument = gql`
    query GetRouteWithEtas($routePoints: [RouteWithEtasPoint!]!, $startDateTime: String, $dwellTimeSeconds: Int, $service: String) {
  getRouteWithEtas(
    routePoints: $routePoints
    startDateTime: $startDateTime
    dwellTimeSeconds: $dwellTimeSeconds
    service: $service
  ) {
    items {
      manifestDriverId
      message
      rateLimitCredits
      distance
      drivingTimeSeconds
      items {
        jobStopId
        eta
        etaSource
        generatedDateTime
      }
      polyline {
        lineType
        coordinates
        encodedLine
      }
    }
    message
  }
}
    `;

/**
 * __useGetRouteWithEtasQuery__
 *
 * To run a query within a React component, call `useGetRouteWithEtasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRouteWithEtasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRouteWithEtasQuery({
 *   variables: {
 *      routePoints: // value for 'routePoints'
 *      startDateTime: // value for 'startDateTime'
 *      dwellTimeSeconds: // value for 'dwellTimeSeconds'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetRouteWithEtasQuery(baseOptions: Apollo.QueryHookOptions<GetRouteWithEtasQuery, GetRouteWithEtasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRouteWithEtasQuery, GetRouteWithEtasQueryVariables>(GetRouteWithEtasDocument, options);
      }
export function useGetRouteWithEtasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRouteWithEtasQuery, GetRouteWithEtasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRouteWithEtasQuery, GetRouteWithEtasQueryVariables>(GetRouteWithEtasDocument, options);
        }
export type GetRouteWithEtasQueryHookResult = ReturnType<typeof useGetRouteWithEtasQuery>;
export type GetRouteWithEtasLazyQueryHookResult = ReturnType<typeof useGetRouteWithEtasLazyQuery>;
export type GetRouteWithEtasQueryResult = Apollo.QueryResult<GetRouteWithEtasQuery, GetRouteWithEtasQueryVariables>;
export const GetEtaDocument = gql`
    query GetETA($manifestDriverIds: [Int!]!, $includeLastSent: Boolean) {
  getETA(manifestDriverIds: $manifestDriverIds, includeLastSent: $includeLastSent) {
    items {
      items {
        jobStopId
        eta
        generatedDateTime
        etaSource
      }
      lastSentItems {
        jobStopId
        windowStart
        windowEnd
      }
      manifestDriverId
      message
      latestCompletedJobStopIds
      optimizationEtas {
        jobStopId
        eta
        generatedDateTime
        etaSource
      }
      status
      completeTopmostStreak
    }
    message
  }
}
    `;

/**
 * __useGetEtaQuery__
 *
 * To run a query within a React component, call `useGetEtaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtaQuery({
 *   variables: {
 *      manifestDriverIds: // value for 'manifestDriverIds'
 *      includeLastSent: // value for 'includeLastSent'
 *   },
 * });
 */
export function useGetEtaQuery(baseOptions: Apollo.QueryHookOptions<GetEtaQuery, GetEtaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtaQuery, GetEtaQueryVariables>(GetEtaDocument, options);
      }
export function useGetEtaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtaQuery, GetEtaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtaQuery, GetEtaQueryVariables>(GetEtaDocument, options);
        }
export type GetEtaQueryHookResult = ReturnType<typeof useGetEtaQuery>;
export type GetEtaLazyQueryHookResult = ReturnType<typeof useGetEtaLazyQuery>;
export type GetEtaQueryResult = Apollo.QueryResult<GetEtaQuery, GetEtaQueryVariables>;
export const GetDispatchStationRestrictionInfoDocument = gql`
    query getDispatchStationRestrictionInfo {
  getDispatchStationRestrictionInfo {
    dispatchGridFlag
    dispatchStation
    subDispatchStations
  }
}
    `;

/**
 * __useGetDispatchStationRestrictionInfoQuery__
 *
 * To run a query within a React component, call `useGetDispatchStationRestrictionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispatchStationRestrictionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispatchStationRestrictionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDispatchStationRestrictionInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDispatchStationRestrictionInfoQuery, GetDispatchStationRestrictionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDispatchStationRestrictionInfoQuery, GetDispatchStationRestrictionInfoQueryVariables>(GetDispatchStationRestrictionInfoDocument, options);
      }
export function useGetDispatchStationRestrictionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDispatchStationRestrictionInfoQuery, GetDispatchStationRestrictionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDispatchStationRestrictionInfoQuery, GetDispatchStationRestrictionInfoQueryVariables>(GetDispatchStationRestrictionInfoDocument, options);
        }
export type GetDispatchStationRestrictionInfoQueryHookResult = ReturnType<typeof useGetDispatchStationRestrictionInfoQuery>;
export type GetDispatchStationRestrictionInfoLazyQueryHookResult = ReturnType<typeof useGetDispatchStationRestrictionInfoLazyQuery>;
export type GetDispatchStationRestrictionInfoQueryResult = Apollo.QueryResult<GetDispatchStationRestrictionInfoQuery, GetDispatchStationRestrictionInfoQueryVariables>;
export const SearchSkillsDocument = gql`
    query SearchSkills($filter: SkillFilterInput, $sort: [SkillSortInput!], $limit: Int) {
  searchSkills(filter: $filter, sort: $sort, limit: $limit) {
    items {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useSearchSkillsQuery__
 *
 * To run a query within a React component, call `useSearchSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSkillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
      }
export function useSearchSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
        }
export type SearchSkillsQueryHookResult = ReturnType<typeof useSearchSkillsQuery>;
export type SearchSkillsLazyQueryHookResult = ReturnType<typeof useSearchSkillsLazyQuery>;
export type SearchSkillsQueryResult = Apollo.QueryResult<SearchSkillsQuery, SearchSkillsQueryVariables>;
export const SearchEtaNotificationConfigsDocument = gql`
    query SearchEtaNotificationConfigs($filter: EtaNotificationConfigsFilter, $limit: Int, $nextToken: String) {
  searchEtaNotificationConfigs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      sk
      siteId
      config
    }
    nextToken
  }
}
    `;

/**
 * __useSearchEtaNotificationConfigsQuery__
 *
 * To run a query within a React component, call `useSearchEtaNotificationConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEtaNotificationConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEtaNotificationConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSearchEtaNotificationConfigsQuery(baseOptions?: Apollo.QueryHookOptions<SearchEtaNotificationConfigsQuery, SearchEtaNotificationConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEtaNotificationConfigsQuery, SearchEtaNotificationConfigsQueryVariables>(SearchEtaNotificationConfigsDocument, options);
      }
export function useSearchEtaNotificationConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEtaNotificationConfigsQuery, SearchEtaNotificationConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEtaNotificationConfigsQuery, SearchEtaNotificationConfigsQueryVariables>(SearchEtaNotificationConfigsDocument, options);
        }
export type SearchEtaNotificationConfigsQueryHookResult = ReturnType<typeof useSearchEtaNotificationConfigsQuery>;
export type SearchEtaNotificationConfigsLazyQueryHookResult = ReturnType<typeof useSearchEtaNotificationConfigsLazyQuery>;
export type SearchEtaNotificationConfigsQueryResult = Apollo.QueryResult<SearchEtaNotificationConfigsQuery, SearchEtaNotificationConfigsQueryVariables>;
export const GetRoutePlanningResultDocument = gql`
    query GetRoutePlanningResult($input: GetRoutePlanningResultInput!) {
  getRoutePlanningResult(input: $input) {
    beforeTotals {
      totalDeliveryStops
      totalMiles
      totalPickupStops
      totalRoutes
      totalTransitSeconds
    }
    copyrights
    job_id
    manifestDriverIds
    message
    processing_time
    status
    waiting_time_in_queue
    routeEtas {
      vehicleId
      startDateTime
      endDateTime
      etas {
        jobStopId
        eta
        etaSource
        generatedDateTime
      }
    }
    solution {
      costs
      distance
      time
      transport_time
      completion_time
      max_operation_time
      waiting_time
      service_duration
      preparation_time
      no_vehicles
      no_unassigned
      routes {
        vehicle_id
        shift_id
        distance
        transport_time
        completion_time
        waiting_time
        service_duration
        preparation_time
        activities {
          type
          id
          location_id
          address {
            location_id
            name
            lon
            lat
          }
          arr_time
          arr_date_time
          end_time
          end_date_time
          waiting_time
          preparation_time
          distance
          driving_time
          load_before
          load_after
        }
        points {
          type
          coordinates
        }
      }
      unassigned {
        services
        shipments
        breaks
        details {
          id
          code
          reason
        }
      }
    }
  }
}
    `;

/**
 * __useGetRoutePlanningResultQuery__
 *
 * To run a query within a React component, call `useGetRoutePlanningResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoutePlanningResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoutePlanningResultQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRoutePlanningResultQuery(baseOptions: Apollo.QueryHookOptions<GetRoutePlanningResultQuery, GetRoutePlanningResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoutePlanningResultQuery, GetRoutePlanningResultQueryVariables>(GetRoutePlanningResultDocument, options);
      }
export function useGetRoutePlanningResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoutePlanningResultQuery, GetRoutePlanningResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoutePlanningResultQuery, GetRoutePlanningResultQueryVariables>(GetRoutePlanningResultDocument, options);
        }
export type GetRoutePlanningResultQueryHookResult = ReturnType<typeof useGetRoutePlanningResultQuery>;
export type GetRoutePlanningResultLazyQueryHookResult = ReturnType<typeof useGetRoutePlanningResultLazyQuery>;
export type GetRoutePlanningResultQueryResult = Apollo.QueryResult<GetRoutePlanningResultQuery, GetRoutePlanningResultQueryVariables>;
export const GetDriverTotalManifestsDocument = gql`
    query GetDriverTotalManifests($driverId: Int!) {
  getDriverTotalManifests(driverId: $driverId) {
    manifestCount
  }
}
    `;

/**
 * __useGetDriverTotalManifestsQuery__
 *
 * To run a query within a React component, call `useGetDriverTotalManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverTotalManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverTotalManifestsQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetDriverTotalManifestsQuery(baseOptions: Apollo.QueryHookOptions<GetDriverTotalManifestsQuery, GetDriverTotalManifestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverTotalManifestsQuery, GetDriverTotalManifestsQueryVariables>(GetDriverTotalManifestsDocument, options);
      }
export function useGetDriverTotalManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverTotalManifestsQuery, GetDriverTotalManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverTotalManifestsQuery, GetDriverTotalManifestsQueryVariables>(GetDriverTotalManifestsDocument, options);
        }
export type GetDriverTotalManifestsQueryHookResult = ReturnType<typeof useGetDriverTotalManifestsQuery>;
export type GetDriverTotalManifestsLazyQueryHookResult = ReturnType<typeof useGetDriverTotalManifestsLazyQuery>;
export type GetDriverTotalManifestsQueryResult = Apollo.QueryResult<GetDriverTotalManifestsQuery, GetDriverTotalManifestsQueryVariables>;
export const GetRoutePlanningUsageDocument = gql`
    query GetRoutePlanningUsage {
  getRoutePlanningUsage {
    used
    limit
    isUnlimited
    resetDate
  }
}
    `;

/**
 * __useGetRoutePlanningUsageQuery__
 *
 * To run a query within a React component, call `useGetRoutePlanningUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoutePlanningUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoutePlanningUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoutePlanningUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetRoutePlanningUsageQuery, GetRoutePlanningUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoutePlanningUsageQuery, GetRoutePlanningUsageQueryVariables>(GetRoutePlanningUsageDocument, options);
      }
export function useGetRoutePlanningUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoutePlanningUsageQuery, GetRoutePlanningUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoutePlanningUsageQuery, GetRoutePlanningUsageQueryVariables>(GetRoutePlanningUsageDocument, options);
        }
export type GetRoutePlanningUsageQueryHookResult = ReturnType<typeof useGetRoutePlanningUsageQuery>;
export type GetRoutePlanningUsageLazyQueryHookResult = ReturnType<typeof useGetRoutePlanningUsageLazyQuery>;
export type GetRoutePlanningUsageQueryResult = Apollo.QueryResult<GetRoutePlanningUsageQuery, GetRoutePlanningUsageQueryVariables>;
export const GetSuggestAssignmentUsageDocument = gql`
    query GetSuggestAssignmentUsage {
  getSuggestAssignmentUsage {
    used
    limit
    resetDate
  }
}
    `;

/**
 * __useGetSuggestAssignmentUsageQuery__
 *
 * To run a query within a React component, call `useGetSuggestAssignmentUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestAssignmentUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestAssignmentUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuggestAssignmentUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetSuggestAssignmentUsageQuery, GetSuggestAssignmentUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestAssignmentUsageQuery, GetSuggestAssignmentUsageQueryVariables>(GetSuggestAssignmentUsageDocument, options);
      }
export function useGetSuggestAssignmentUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestAssignmentUsageQuery, GetSuggestAssignmentUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestAssignmentUsageQuery, GetSuggestAssignmentUsageQueryVariables>(GetSuggestAssignmentUsageDocument, options);
        }
export type GetSuggestAssignmentUsageQueryHookResult = ReturnType<typeof useGetSuggestAssignmentUsageQuery>;
export type GetSuggestAssignmentUsageLazyQueryHookResult = ReturnType<typeof useGetSuggestAssignmentUsageLazyQuery>;
export type GetSuggestAssignmentUsageQueryResult = Apollo.QueryResult<GetSuggestAssignmentUsageQuery, GetSuggestAssignmentUsageQueryVariables>;
export const GetSuggestAssignmentResultDocument = gql`
    query GetSuggestAssignmentResult($input: GetSuggestAssignmentResultInput!) {
  getSuggestAssignmentResult(input: $input) {
    requestId
    status
    error
    errors {
      jobStopId
      field
      reason
      value
    }
    result {
      candidates {
        manifestDriverId
        driverId
        driverName
        driverCode
        matchReason
        incompleteStopCount
        hasEta
        additionalTime
        baselineDuration
        optimizedDuration
        baselineDistance
        optimizedDistance
        timeWindowBuffer
        suggestReasons
        optimizedSequences {
          jobStopId
          stopType
          isNewJobStop
        }
        optimizedEtas {
          jobStopId
          eta
          etaSource
          generatedDateTime
        }
      }
      evaluatedCount
      feasible
      processedTime
      ghProcessedTime
      credits
    }
  }
}
    `;

/**
 * __useGetSuggestAssignmentResultQuery__
 *
 * To run a query within a React component, call `useGetSuggestAssignmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestAssignmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestAssignmentResultQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuggestAssignmentResultQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestAssignmentResultQuery, GetSuggestAssignmentResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestAssignmentResultQuery, GetSuggestAssignmentResultQueryVariables>(GetSuggestAssignmentResultDocument, options);
      }
export function useGetSuggestAssignmentResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestAssignmentResultQuery, GetSuggestAssignmentResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestAssignmentResultQuery, GetSuggestAssignmentResultQueryVariables>(GetSuggestAssignmentResultDocument, options);
        }
export type GetSuggestAssignmentResultQueryHookResult = ReturnType<typeof useGetSuggestAssignmentResultQuery>;
export type GetSuggestAssignmentResultLazyQueryHookResult = ReturnType<typeof useGetSuggestAssignmentResultLazyQuery>;
export type GetSuggestAssignmentResultQueryResult = Apollo.QueryResult<GetSuggestAssignmentResultQuery, GetSuggestAssignmentResultQueryVariables>;
export const OnJobAssignmentUpdateDocument = gql`
    subscription onJobAssignmentUpdate {
  onJobAssignmentUpdate {
    tenantId
    manifestDriverId
    jobIds
    jobStopIds
    submissionResult
    userName
  }
}
    `;

/**
 * __useOnJobAssignmentUpdateSubscription__
 *
 * To run a query within a React component, call `useOnJobAssignmentUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnJobAssignmentUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnJobAssignmentUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnJobAssignmentUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnJobAssignmentUpdateSubscription, OnJobAssignmentUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnJobAssignmentUpdateSubscription, OnJobAssignmentUpdateSubscriptionVariables>(OnJobAssignmentUpdateDocument, options);
      }
export type OnJobAssignmentUpdateSubscriptionHookResult = ReturnType<typeof useOnJobAssignmentUpdateSubscription>;
export type OnJobAssignmentUpdateSubscriptionResult = Apollo.SubscriptionResult<OnJobAssignmentUpdateSubscription>;
export const OnDispatchUpdateDocument = gql`
    subscription onDispatchUpdate {
  onDispatchUpdate {
    data
    tenantId
  }
}
    `;

/**
 * __useOnDispatchUpdateSubscription__
 *
 * To run a query within a React component, call `useOnDispatchUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDispatchUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDispatchUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnDispatchUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnDispatchUpdateSubscription, OnDispatchUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDispatchUpdateSubscription, OnDispatchUpdateSubscriptionVariables>(OnDispatchUpdateDocument, options);
      }
export type OnDispatchUpdateSubscriptionHookResult = ReturnType<typeof useOnDispatchUpdateSubscription>;
export type OnDispatchUpdateSubscriptionResult = Apollo.SubscriptionResult<OnDispatchUpdateSubscription>;
export const OnDataChangedDocument = gql`
    subscription onDataChanged($entityType: DataChangeEntityType!, $entityId: String) {
  onDataChanged(entityType: $entityType, entityId: $entityId) {
    entityId
    entityType
  }
}
    `;

/**
 * __useOnDataChangedSubscription__
 *
 * To run a query within a React component, call `useOnDataChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnDataChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDataChangedSubscription({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useOnDataChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnDataChangedSubscription, OnDataChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnDataChangedSubscription, OnDataChangedSubscriptionVariables>(OnDataChangedDocument, options);
      }
export type OnDataChangedSubscriptionHookResult = ReturnType<typeof useOnDataChangedSubscription>;
export type OnDataChangedSubscriptionResult = Apollo.SubscriptionResult<OnDataChangedSubscription>;